'use strict';
const SURAHS = [{"n":1,"f":"001-Al-Fatihah.mp3","a":"الفاتحة","t":"Al-Fatihah","e":"The Opening","m":"Pembukaan","y":7,"p":"M","de":"The essence of the whole Quran: praise of Allah, devotion, and the plea for the straight path. Recited in every rakaat of salah.","dm":"Intipati seluruh Al-Quran: pujian kepada Allah, pengabdian, dan permohonan jalan yang lurus. Dibaca dalam setiap rakaat solat."},{"n":2,"f":"002-Al-Baqarah.mp3","a":"البقرة","t":"Al-Baqarah","e":"The Cow","m":"Lembu Betina","y":286,"p":"D","de":"The longest surah: faith versus hypocrisy, the stories of Adam and Bani Israil, laws of fasting, hajj and finance. Contains Ayat al-Kursi (verse 255).","dm":"Surah terpanjang: iman lawan nifak, kisah Nabi Adam dan Bani Israil, hukum puasa, haji dan muamalat. Mengandungi Ayat al-Kursi (ayat 255)."},{"n":3,"f":"003-Al-Imran.mp3","a":"آل عمران","t":"Ali 'Imran","e":"The Family of Imran","m":"Keluarga Imran","y":200,"p":"D","de":"The family of Imran and Maryam, the birth of Isa AS, and lessons from the battles of Badr and Uhud on steadfastness.","dm":"Keluarga Imran dan Maryam, kelahiran Nabi Isa AS, serta pengajaran perang Badar dan Uhud tentang keteguhan iman."},{"n":4,"f":"004-An-Nisa'.mp3","a":"النساء","t":"An-Nisa'","e":"The Women","m":"Wanita","y":176,"p":"D","de":"Rights of women and orphans, the law of inheritance, family rulings and the command to judge with justice.","dm":"Hak wanita dan anak yatim, hukum faraid, peraturan kekeluargaan dan perintah menegakkan keadilan."},{"n":5,"f":"005-Al-Ma'idah.mp3","a":"المائدة","t":"Al-Ma'idah","e":"The Table Spread","m":"Hidangan","y":120,"p":"D","de":"Fulfilling covenants, lawful and unlawful food, and the table spread requested from Isa AS. Verse 3 announces the perfection of the religion.","dm":"Menunaikan janji, makanan halal dan haram, serta hidangan yang diminta daripada Nabi Isa AS. Ayat 3 mengisytiharkan kesempurnaan agama."},{"n":6,"f":"006-Al-An'am.mp3","a":"الأنعام","t":"Al-An'am","e":"The Cattle","m":"Binatang Ternakan","y":165,"p":"M","de":"Tauhid argued through creation — the sun, stars and life itself — with the story of Ibrahim AS searching for his Lord.","dm":"Tauhid dibuktikan melalui ciptaan — matahari, bintang dan kehidupan — bersama kisah Nabi Ibrahim AS mencari Tuhannya."},{"n":7,"f":"007-Al-A'raf.mp3","a":"الأعراف","t":"Al-A'raf","e":"The Heights","m":"Tempat Tertinggi","y":206,"p":"M","de":"Adam and Iblis, then the nations who rejected Nuh, Hud, Salih, Lut and Shu'aib — and the people of the Heights between Paradise and Fire.","dm":"Kisah Adam dan Iblis, kemudian umat yang mendustakan Nuh, Hud, Salih, Lut dan Syuaib — serta penghuni Al-A'raf antara syurga dan neraka."},{"n":8,"f":"008-Al-Anfal.mp3","a":"الأنفال","t":"Al-Anfal","e":"The Spoils of War","m":"Rampasan Perang","y":75,"p":"D","de":"Revealed after the Battle of Badr: how spoils are shared, the marks of true believers, and victory through reliance on Allah.","dm":"Diturunkan selepas Perang Badar: pembahagian harta rampasan, ciri mukmin sejati, dan kemenangan melalui tawakal kepada Allah."},{"n":9,"f":"009-At-Taubah.mp3","a":"التوبة","t":"At-Taubah","e":"The Repentance","m":"Pengampunan","y":129,"p":"D","de":"The only surah without Bismillah: repentance, the expedition of Tabuk, and the exposure of the hypocrites.","dm":"Satu-satunya surah tanpa Bismillah: taubat, ekspedisi Tabuk, dan pendedahan golongan munafik."},{"n":10,"f":"010-Yunus.mp3","a":"يونس","t":"Yunus","e":"Jonah","m":"Nabi Yunus a.s.","y":109,"p":"M","de":"Allah's signs in the heavens and earth, the truth of revelation — and the people of Yunus, the one nation whose repentance saved them.","dm":"Tanda kebesaran Allah di langit dan bumi, kebenaran wahyu — dan kaum Nabi Yunus, satu-satunya umat yang taubatnya menyelamatkan mereka."},{"n":11,"f":"011-Hood.mp3","a":"هود","t":"Hud","e":"Hud","m":"Nabi Hud a.s.","y":123,"p":"M","de":"Nuh's ark, then Hud, Salih, Lut and Shu'aib: remaining upright when a whole society rejects the message.","dm":"Bahtera Nabi Nuh, kemudian Hud, Salih, Lut dan Syuaib: kekal istiqamah walaupun seluruh masyarakat menolak dakwah."},{"n":12,"f":"012-Yusuf.mp3","a":"يوسف","t":"Yusuf","e":"Joseph","m":"Nabi Yusuf a.s.","y":111,"p":"M","de":"Called the most beautiful of stories: Yusuf AS from the well to the palace — patience with brothers, temptation resisted, and forgiveness at the end.","dm":"Digelar sebaik-baik kisah: Nabi Yusuf AS dari perigi ke istana — sabar dengan saudara, menolak godaan, dan kemaafan di akhirnya."},{"n":13,"f":"013-Ar-Ra'd.mp3","a":"الرعد","t":"Ar-Ra'd","e":"The Thunder","m":"Guruh","y":43,"p":"D","de":"Thunder glorifies Allah with His praise; truth and falsehood are contrasted, and verse 28 declares that hearts find rest in His remembrance.","dm":"Guruh bertasbih memuji Allah; hak dan batil dibandingkan, dan ayat 28 menegaskan hati menjadi tenang dengan mengingati Allah."},{"n":14,"f":"014-Ibrahim.mp3","a":"إبراهيم","t":"Ibrahim","e":"Abraham","m":"Nabi Ibrahim a.s.","y":52,"p":"M","de":"Ibrahim AS prays for the safety of Makkah and his descendants; a good word is likened to a firm tree with roots and fruit.","dm":"Doa Nabi Ibrahim AS untuk keamanan Makkah dan zuriatnya; kalimah yang baik diumpamakan pohon teguh yang berakar dan berbuah."},{"n":15,"f":"015-Al-Hijr.mp3","a":"الحجر","t":"Al-Hijr","e":"The Rocky Tract","m":"Kawasan Berbatu","y":99,"p":"M","de":"The people of al-Hijr carved homes in mountains yet perished. Verse 9 carries Allah's own guarantee to preserve the Quran.","dm":"Kaum al-Hijr memahat rumah di gunung namun tetap binasa. Ayat 9 membawa jaminan Allah sendiri memelihara Al-Quran."},{"n":16,"f":"016-An-Nahl.mp3","a":"النحل","t":"An-Nahl","e":"The Bee","m":"Lebah","y":128,"p":"M","de":"Known as the surah of blessings: the bee is divinely inspired, and favour after favour calls mankind to gratitude.","dm":"Dikenali sebagai surah nikmat: lebah diberi ilham Ilahi, dan nikmat demi nikmat menyeru manusia supaya bersyukur."},{"n":17,"f":"017-Al-Isra.mp3","a":"الإسراء","t":"Al-Isra'","e":"The Night Journey","m":"Perjalanan Malam","y":111,"p":"M","de":"The night journey of the Prophet ﷺ to Jerusalem, followed by a charter of ethics — starting with excellence to parents (verse 23).","dm":"Perjalanan Israk Nabi ﷺ ke Baitulmaqdis, diikuti tuntunan akhlak — bermula dengan berbakti kepada ibu bapa (ayat 23)."},{"n":18,"f":"018-Al-Kahf.mp3","a":"الكهف","t":"Al-Kahf","e":"The Cave","m":"Gua","y":110,"p":"M","de":"Four trials in one surah: faith (the sleepers of the cave), wealth (the two gardens), knowledge (Musa and Khidir) and power (Dhul-Qarnayn). Sunnah to recite on Fridays.","dm":"Empat ujian dalam satu surah: iman (pemuda gua), harta (dua kebun), ilmu (Musa dan Khidir) dan kuasa (Zulkarnain). Sunat dibaca pada hari Jumaat."},{"n":19,"f":"019-Maryam.mp3","a":"مريم","t":"Maryam","e":"Mary","m":"Siti Maryam","y":98,"p":"M","de":"The miracle births of Yahya and Isa AS, and Maryam's devotion — a surah whose heartbeat is Allah's mercy.","dm":"Kelahiran ajaib Nabi Yahya dan Nabi Isa AS, serta ketakwaan Maryam — surah yang bernadikan rahmat Allah."},{"n":20,"f":"020-TaHa.mp3","a":"طه","t":"Ta-Ha","e":"Ta-Ha","m":"Taahaa","y":135,"p":"M","de":"Musa AS's story told in depth, from the sacred valley to facing Firaun. It opens by declaring the Quran was not revealed to cause hardship.","dm":"Kisah Nabi Musa AS secara mendalam, dari lembah suci hingga berdepan Firaun. Dibuka dengan penegasan Al-Quran bukan diturunkan untuk menyusahkan."},{"n":21,"f":"021-Al-Anbiya'.mp3","a":"الأنبياء","t":"Al-Anbiya'","e":"The Prophets","m":"Para Nabi","y":112,"p":"M","de":"A parade of prophets — Ibrahim breaking the idols, Ayyub's patience, Yunus in the darkness — one message: your ummah is one, and I am your Lord.","dm":"Barisan para nabi — Ibrahim memusnahkan berhala, kesabaran Ayyub, Yunus dalam kegelapan — satu mesej: umat ini satu, dan Akulah Tuhan kamu."},{"n":22,"f":"022-Al-Hajj.mp3","a":"الحج","t":"Al-Hajj","e":"The Pilgrimage","m":"Haji","y":78,"p":"D","de":"The rites of pilgrimage, the earthquake of the Last Hour, and the first permission for the oppressed to defend themselves.","dm":"Syiar ibadah haji, gegaran hari Kiamat, dan keizinan pertama bagi golongan yang dizalimi untuk mempertahankan diri."},{"n":23,"f":"023-Al-Mu'minun.mp3","a":"المؤمنون","t":"Al-Mu'minun","e":"The Believers","m":"Golongan yang Beriman","y":118,"p":"M","de":"Opens with the traits of successful believers — khushu' in prayer, guarded chastity, kept trusts — then traces the stages of human creation.","dm":"Dibuka dengan sifat mukmin yang berjaya — khusyuk dalam solat, menjaga kehormatan, memelihara amanah — kemudian menyusuri peringkat kejadian manusia."},{"n":24,"f":"024-An-Nur.mp3","a":"النور","t":"An-Nur","e":"The Light","m":"Cahaya","y":64,"p":"D","de":"The famous Light verse (35), with rulings on modesty and slander that protect the honour of a believing society.","dm":"Ayat Cahaya yang masyhur (ayat 35), berserta hukum menjaga maruah dan larangan fitnah demi kehormatan masyarakat beriman."},{"n":25,"f":"025-Al-Furqan.mp3","a":"الفرقان","t":"Al-Furqan","e":"The Criterion","m":"Pembeza Kebenaran dan Kebatilan","y":77,"p":"M","de":"The Quran as the Criterion between truth and falsehood, ending with the beloved description of the servants of Ar-Rahman (63-77).","dm":"Al-Quran sebagai pembeza antara hak dan batil, diakhiri dengan sifat-sifat 'Ibadurrahman yang dikasihi (ayat 63-77)."},{"n":26,"f":"026-Ash-Shu'ara'.mp3","a":"الشعراء","t":"Ash-Shu'ara'","e":"The Poets","m":"Para Penyair","y":227,"p":"M","de":"Prophets plead with their nations in a rhythmic refrain; it closes by declaring the Quran is no work of poets.","dm":"Para rasul merayu kaum masing-masing dalam susunan berirama; ditutup dengan penegasan Al-Quran bukan karangan penyair."},{"n":27,"f":"027-An-Naml.mp3","a":"النمل","t":"An-Naml","e":"The Ants","m":"Semut","y":93,"p":"M","de":"Sulaiman AS hears the ant in the valley, the hoopoe brings news of Saba', and its queen comes to believe in Allah.","dm":"Nabi Sulaiman AS mendengar semut di lembah, burung hud-hud membawa berita Saba', dan ratunya akhirnya beriman kepada Allah."},{"n":28,"f":"028-Al-Qasas.mp3","a":"القصص","t":"Al-Qasas","e":"The Stories","m":"Cerita-cerita","y":88,"p":"M","de":"Musa AS raised inside Firaun's own palace, his flight to Madyan — and Qarun, swallowed by the earth together with his treasure.","dm":"Nabi Musa AS dibesarkan di istana Firaun sendiri, hijrahnya ke Madyan — dan Qarun yang ditelan bumi bersama hartanya."},{"n":29,"f":"029-Al-'Ankabut.mp3","a":"العنكبوت","t":"Al-'Ankabut","e":"The Spider","m":"Labah-labah","y":69,"p":"M","de":"Everyone who claims faith will be tested; every refuge besides Allah is as frail as the spider's web.","dm":"Setiap yang mengaku beriman pasti diuji; setiap sandaran selain Allah serapuh sarang labah-labah."},{"n":30,"f":"030-Ar-Room.mp3","a":"الروم","t":"Ar-Rum","e":"The Romans","m":"Bangsa Rom","y":60,"p":"M","de":"A prophecy fulfilled: Rome would rise again after defeat. Among His signs — the love and mercy placed between spouses (verse 21).","dm":"Ramalan Al-Quran yang terbukti benar: Rom bangkit semula selepas kalah. Antara tanda kebesaran-Nya — kasih sayang antara suami isteri (ayat 21)."},{"n":31,"f":"031-Luqman.mp3","a":"لقمان","t":"Luqman","e":"Luqman","m":"Luqman","y":34,"p":"M","de":"Luqman's advice to his son: never associate partners with Allah, be grateful, pray, enjoin good and walk humbly — timeless parenting.","dm":"Wasiat Luqman kepada anaknya: jangan syirik, bersyukur, dirikan solat, ajak kepada kebaikan dan rendah hati — didikan sepanjang zaman."},{"n":32,"f":"032-As-Sajdah.mp3","a":"السجدة","t":"As-Sajdah","e":"The Prostration","m":"Sujud","y":30,"p":"M","de":"Man's creation from clay and a despised drop, and the praise of those who leave their beds at night to call on their Lord.","dm":"Kejadian manusia daripada tanah dan air yang hina, serta pujian bagi mereka yang meninggalkan tempat tidur untuk bermunajat di malam hari."},{"n":33,"f":"033-Al-Ahzab.mp3","a":"الأحزاب","t":"Al-Ahzab","e":"The Combined Forces","m":"Golongan yang Bersekutu","y":73,"p":"D","de":"The Battle of the Confederates, guidance for the Prophet's ﷺ household, and the verses of hijab and salawat upon the Prophet.","dm":"Perang Ahzab, panduan rumah tangga Nabi ﷺ, serta ayat hijab dan ayat selawat ke atas baginda."},{"n":34,"f":"034-Saba'.mp3","a":"سبأ","t":"Saba'","e":"Sheba","m":"Kaum Saba’","y":54,"p":"M","de":"Dawud and Sulaiman answered blessings with gratitude; Saba' answered them with denial — and their great dam burst.","dm":"Nabi Daud dan Sulaiman membalas nikmat dengan syukur; kaum Saba' membalasnya dengan kufur — lalu empangan besar mereka pecah."},{"n":35,"f":"035-Fatir.mp3","a":"فاطر","t":"Fatir","e":"The Originator","m":"Pencipta","y":45,"p":"M","de":"Allah the Originator of the heavens and earth, the angels as His messengers, and three ranks of this ummah inheriting the Book.","dm":"Allah Pencipta langit dan bumi, para malaikat sebagai utusan-Nya, dan tiga golongan umat ini yang mewarisi Al-Kitab."},{"n":36,"f":"036-Yasin.mp3","a":"يس","t":"Ya-Sin","e":"Ya-Sin","m":"Yaasin","y":83,"p":"M","de":"Often called the heart of the Quran: the certainty of revelation, signs in the dead earth revived, and the promise of resurrection.","dm":"Sering digelar jantung Al-Quran: kepastian wahyu, tanda pada bumi mati yang dihidupkan semula, dan janji kebangkitan."},{"n":37,"f":"037-As-Saffat.mp3","a":"الصافات","t":"As-Saffat","e":"Those Ranged in Ranks","m":"Yang Teratur Berbaris","y":182,"p":"M","de":"The ranked angels, the prophets delivered one after another — and Ibrahim AS willing to sacrifice his own son in obedience.","dm":"Malaikat yang berbaris, para nabi diselamatkan satu demi satu — dan Nabi Ibrahim AS rela mengorbankan puteranya kerana taat."},{"n":38,"f":"038-Sad.mp3","a":"ص","t":"Sad","e":"Sad","m":"Saad","y":88,"p":"M","de":"Dawud and Sulaiman: kingship joined with repentance; and Iblis's arrogance when commanded to bow to Adam.","dm":"Nabi Daud dan Sulaiman: kerajaan yang disertai taubat; dan keangkuhan Iblis apabila diperintah sujud kepada Adam."},{"n":39,"f":"039-Az-Zumar.mp3","a":"الزمر","t":"Az-Zumar","e":"The Groups","m":"Rombongan","y":75,"p":"M","de":"Worship Allah with pure sincerity. Verse 53 is the Quran's widest door of hope: despair not of the mercy of Allah.","dm":"Beribadahlah dengan penuh ikhlas. Ayat 53 adalah pintu harapan terluas dalam Al-Quran: jangan berputus asa daripada rahmat Allah."},{"n":40,"f":"040-Ghafir.mp3","a":"غافر","t":"Ghafir","e":"The Forgiver","m":"Orang yang Beriman","y":85,"p":"M","de":"The Forgiver of sin and Acceptor of repentance; a secret believer in Firaun's court stands up to defend Musa AS.","dm":"Allah Pengampun dosa dan Penerima taubat; seorang mukmin yang merahsiakan imannya di istana Firaun bangkit membela Nabi Musa AS."},{"n":41,"f":"041-Fussilat.mp3","a":"فصلت","t":"Fussilat","e":"Explained in Detail","m":"Dijelaskan","y":54,"p":"M","de":"A Book explained in detail; on Judgment Day skin and limbs testify. Verse 34: repel evil with what is better, and enemies become friends.","dm":"Kitab yang dijelaskan terperinci; pada hari Kiamat kulit dan anggota badan menjadi saksi. Ayat 34: tolak kejahatan dengan kebaikan, musuh menjadi sahabat."},{"n":42,"f":"042-Ash-Shura.mp3","a":"الشورى","t":"Ash-Shura","e":"The Consultation","m":"Permesyuaratan","y":53,"p":"M","de":"Named after consultation — syura — the believers' way of deciding affairs, upon the one message shared by all prophets.","dm":"Dinamakan sempena musyawarah — syura — cara mukmin memutuskan urusan, di atas risalah yang satu bagi semua rasul."},{"n":43,"f":"043-Az-Zukhruf.mp3","a":"الزخرف","t":"Az-Zukhruf","e":"The Gold Adornments","m":"Perhiasan Emas","y":89,"p":"M","de":"Gold and ornaments are no measure of honour before Allah; Isa AS is His servant, and true worth lies in taqwa.","dm":"Emas dan perhiasan bukan ukuran kemuliaan di sisi Allah; Nabi Isa AS hamba-Nya, dan nilai sebenar terletak pada takwa."},{"n":44,"f":"044-Ad-Dukha.mp3","a":"الدخان","t":"Ad-Dukhan","e":"The Smoke","m":"Kabut / Asap","y":59,"p":"M","de":"The smoke of a day of reckoning, the blessed night on which the Quran descended, and the end of Firaun's arrogance.","dm":"Asap pada hari pembalasan, malam penuh berkat penurunan Al-Quran, dan kesudahan keangkuhan Firaun."},{"n":45,"f":"045-Al-Jathiya.mp3","a":"الجاثية","t":"Al-Jathiyah","e":"The Kneeling","m":"Yang Berlutut","y":37,"p":"M","de":"Every nation kneeling, summoned to its book of deeds — and countless signs for a people who reflect.","dm":"Setiap umat berlutut, dipanggil kepada buku amalannya — dan tanda-tanda yang banyak bagi kaum yang berfikir."},{"n":46,"f":"046-Al-Ahqaf.mp3","a":"الأحقاف","t":"Al-Ahqaf","e":"The Wind-Curved Sandhills","m":"Bukit-bukit Pasir","y":35,"p":"M","de":"The people of 'Ad at the wind-curved sandhills destroyed by the very wind they welcomed; verse 15 commands excellence to parents.","dm":"Kaum 'Ad di bukit-bukit pasir dibinasakan oleh angin yang mereka sangka rahmat; ayat 15 memerintahkan berbuat baik kepada ibu bapa."},{"n":47,"f":"047-Muhammad.mp3","a":"محمد","t":"Muhammad","e":"Muhammad","m":"Nabi Muhammad SAW","y":38,"p":"D","de":"The struggle between truth and falsehood. Verse 7: if you help the cause of Allah, He will help you and plant your feet firmly.","dm":"Perjuangan antara hak dan batil. Ayat 7: jika kamu menolong agama Allah, Dia akan menolong kamu dan meneguhkan pendirianmu."},{"n":48,"f":"048-Al-Fath.mp3","a":"الفتح","t":"Al-Fath","e":"The Victory","m":"Kemenangan","y":29,"p":"D","de":"The treaty of Hudaybiyyah declared a clear victory, and the Prophet's ﷺ dream of entering Makkah fulfilled.","dm":"Perjanjian Hudaibiyah diisytiharkan sebagai kemenangan yang nyata, dan mimpi Nabi ﷺ memasuki Makkah menjadi kenyataan."},{"n":49,"f":"049-Al-Hujurat.mp3","a":"الحجرات","t":"Al-Hujurat","e":"The Rooms","m":"Bilik-bilik","y":18,"p":"D","de":"The surah of manners: verify news before spreading it, no mocking or backbiting — the noblest of you is the most God-conscious (verse 13).","dm":"Surah adab: semak berita sebelum disebarkan, jangan mengejek dan mengumpat — semulia-mulia kamu ialah yang paling bertakwa (ayat 13)."},{"n":50,"f":"050-Qaf.mp3","a":"ق","t":"Qaf","e":"Qaf","m":"Qaaf","y":45,"p":"M","de":"Answers to those who doubt resurrection; Allah is nearer to man than his jugular vein, and every word is recorded.","dm":"Jawapan kepada yang meragui kebangkitan; Allah lebih dekat kepada manusia daripada urat lehernya, dan setiap kata dicatat."},{"n":51,"f":"051-Az-Zariyat.mp3","a":"الذاريات","t":"Adh-Dhariyat","e":"The Winnowing Winds","m":"Angin yang Menerbangkan","y":60,"p":"M","de":"Oaths by the scattering winds; sustenance is decreed in heaven — and jinn and mankind were created only to worship Allah (verse 56).","dm":"Sumpah demi angin yang menerbangkan; rezeki telah ditentukan di langit — dan jin serta manusia dicipta hanya untuk mengabdi kepada Allah (ayat 56)."},{"n":52,"f":"052-At-Tur.mp3","a":"الطور","t":"At-Tur","e":"The Mount","m":"Bukit","y":49,"p":"M","de":"An oath by Mount Tur, then rapid-fire questions that dismantle every excuse of the deniers — did they create themselves?","dm":"Sumpah demi Gunung Tur, kemudian soalan bertubi-tubi meruntuhkan setiap alasan para pendusta — adakah mereka mencipta diri sendiri?"},{"n":53,"f":"053-An-Najm.mp3","a":"النجم","t":"An-Najm","e":"The Star","m":"Bintang","y":62,"p":"M","de":"What the Prophet ﷺ saw at the Lote Tree of the utmost boundary was true; and man shall have only what he strives for (verse 39).","dm":"Apa yang Nabi ﷺ saksikan di Sidratul-Muntaha adalah benar; dan manusia hanya memperoleh apa yang diusahakannya (ayat 39)."},{"n":54,"f":"054-Al-Qamar.mp3","a":"القمر","t":"Al-Qamar","e":"The Moon","m":"Bulan","y":55,"p":"M","de":"The moon was split as a sign; four times the surah repeats: We have made the Quran easy to remember — is there any who will take heed?","dm":"Bulan terbelah sebagai tanda; empat kali surah ini mengulang: Kami mudahkan Al-Quran untuk diingati — adakah sesiapa yang mahu mengambil pelajaran?"},{"n":55,"f":"055-Ar-Rahman.mp3","a":"الرحمن","t":"Ar-Rahman","e":"The Most Merciful","m":"Yang Maha Pemurah","y":78,"p":"D","de":"The surah of favours, asking 31 times: which of your Lord's favours will you both deny? — from the sun and seas to the gardens of Paradise.","dm":"Surah nikmat, bertanya 31 kali: maka nikmat Tuhanmu yang manakah kamu berdua dustakan? — daripada matahari dan lautan hinggalah taman syurga."},{"n":56,"f":"056-Al-Waqi'ah.mp3","a":"الواقعة","t":"Al-Waqi'ah","e":"The Inevitable","m":"Peristiwa yang Tidak Dapat Dielakkan","y":96,"p":"M","de":"The inevitable event splits mankind into three companies — the foremost, the right and the left — and none can push death back.","dm":"Peristiwa yang pasti berlaku membahagikan manusia kepada tiga golongan — yang terdahulu, kanan dan kiri — dan tiada siapa mampu menahan kematian."},{"n":57,"f":"057-Al-Hadid.mp3","a":"الحديد","t":"Al-Hadid","e":"The Iron","m":"Besi","y":29,"p":"D","de":"Iron sent down with mighty strength; worldly life is play and delusion — so race one another to forgiveness and spend in His cause.","dm":"Besi diturunkan dengan kekuatan yang hebat; kehidupan dunia hanya permainan dan tipu daya — maka berlumbalah kepada keampunan dan berinfaklah."},{"n":58,"f":"058-Al-Mujadilah.mp3","a":"المجادلة","t":"Al-Mujadilah","e":"The Pleading Woman","m":"Perempuan yang Merayu","y":22,"p":"D","de":"Allah heard the woman who pleaded about her husband; He is with you wherever you are, and no secret counsel escapes Him.","dm":"Allah mendengar wanita yang mengadu tentang suaminya; Dia bersamamu di mana jua kamu berada, dan tiada bisikan rahsia terlepas daripada-Nya."},{"n":59,"f":"059-Al-Hashr.mp3","a":"الحشر","t":"Al-Hashr","e":"The Exile","m":"Pengusiran","y":24,"p":"D","de":"The exile of Banu Nadir for breaking their pact — and the majestic closing verses listing the most beautiful names of Allah.","dm":"Pengusiran Bani Nadhir kerana mengkhianati perjanjian — dan penutup surah yang agung menyenaraikan Asmaul Husna."},{"n":60,"f":"060-Al-Mumtahinah.mp3","a":"الممتحنة","t":"Al-Mumtahanah","e":"She Who is Examined","m":"Perempuan yang Diuji","y":13,"p":"D","de":"Loyalty is for Allah's sake alone; yet He does not forbid kindness and justice towards those who do not fight the believers (verse 8).","dm":"Kesetiaan hanyalah kerana Allah; namun Dia tidak melarang berbuat baik dan berlaku adil kepada mereka yang tidak memerangi orang beriman (ayat 8)."},{"n":61,"f":"061-As-Saff.mp3","a":"الصف","t":"As-Saff","e":"The Ranks","m":"Barisan","y":14,"p":"D","de":"Believers who fight in ranks like a solid structure; say only what you do — and the trade with Allah that saves from a painful punishment.","dm":"Mukmin yang berjuang dalam barisan seperti binaan yang kukuh; kotakan apa yang dikatakan — dan perniagaan bersama Allah yang menyelamatkan daripada azab pedih."},{"n":62,"f":"062-Al-Jumu'ah.mp3","a":"الجمعة","t":"Al-Jumu'ah","e":"Friday","m":"Hari Jumaat","y":11,"p":"D","de":"When the call to Friday prayer is made, leave trade and hasten to the remembrance of Allah; knowledge unpractised is condemned.","dm":"Apabila diseru untuk solat Jumaat, tinggalkanlah jual beli dan segeralah mengingati Allah; ilmu tanpa amal dicela."},{"n":63,"f":"063-Al-Munafiqun.mp3","a":"المنافقون","t":"Al-Munafiqun","e":"The Hypocrites","m":"Golongan Munafik","y":11,"p":"D","de":"The hypocrites take their oaths as shields; believers are warned: let not wealth and children divert you from the remembrance of Allah.","dm":"Golongan munafik menjadikan sumpah sebagai perisai; mukmin diperingatkan: jangan harta dan anak-anak melalaikan kamu daripada mengingati Allah."},{"n":64,"f":"064-At-Taghabun.mp3","a":"التغابن","t":"At-Taghabun","e":"Mutual Loss and Gain","m":"Dinampakkan Kesalahan","y":18,"p":"D","de":"The Day when winners and losers are revealed; your wealth and children are but a trial, and with Allah is an immense reward.","dm":"Hari didedahkan siapa untung dan rugi; harta dan anak-anakmu hanyalah ujian, dan di sisi Allah pahala yang besar."},{"n":65,"f":"065-At-Talaq.mp3","a":"الطلاق","t":"At-Talaq","e":"The Divorce","m":"Cerai / Talak","y":12,"p":"D","de":"Divorce conducted with dignity — waiting periods and fair provision. Whoever fears Allah, He makes for him a way out (verses 2-3).","dm":"Perceraian dilaksanakan dengan ihsan — iddah dan nafkah yang adil. Sesiapa yang bertakwa, Allah adakan baginya jalan keluar (ayat 2-3)."},{"n":66,"f":"066-At-Tahrim.mp3","a":"التحريم","t":"At-Tahrim","e":"The Prohibition","m":"Mengharamkan","y":12,"p":"D","de":"Lessons from the Prophet's ﷺ own household, sealed with four women as signs: the wives of Nuh and Lut, the wife of Firaun, and Maryam.","dm":"Pengajaran daripada rumah tangga Nabi ﷺ sendiri, ditutup dengan perumpamaan empat wanita: isteri Nuh dan Lut (pengkhianatan), isteri Firaun (Asiah), dan Maryam (keimanan)."},{"n":67,"f":"067-Al-Mulk.mp3","a":"الملك","t":"Al-Mulk","e":"The Sovereignty","m":"Kerajaan","y":30,"p":"M","de":"All sovereignty is in Allah's hand; death and life were created to test which of you is best in deeds. Known as a protector concerning the grave.","dm":"Segala kerajaan di tangan Allah; mati dan hidup dicipta untuk menguji siapa yang terbaik amalannya. Dikenali sebagai pelindung berkaitan azab kubur."},{"n":68,"f":"068-Al-Qalam.mp3","a":"القلم","t":"Al-Qalam","e":"The Pen","m":"Pena / Kalam","y":52,"p":"M","de":"An oath by the pen and what they write; the Prophet ﷺ praised for his tremendous character (verse 4); and the lesson of the stingy garden owners.","dm":"Sumpah demi pena dan apa yang dituliskan; Nabi ﷺ dipuji dengan akhlak yang agung (ayat 4); dan pengajaran pemilik kebun yang bakhil."},{"n":69,"f":"069-Al-Haqqah.mp3","a":"الحاقة","t":"Al-Haqqah","e":"The Reality","m":"Keadaan Sebenar / Hari Kiamat","y":52,"p":"M","de":"The undeniable Reality: Thamud, 'Ad and Firaun swept away — and on that Day each receives his book in the right or the left hand.","dm":"Hari kebenaran yang tidak dapat dinafikan: Thamud, 'Ad dan Firaun dibinasakan — dan pada hari itu setiap orang menerima kitabnya di tangan kanan atau kiri."},{"n":70,"f":"070-Al-Ma'arij.mp3","a":"المعارج","t":"Al-Ma'arij","e":"The Ascending Stairways","m":"Tempat-tempat Naik","y":44,"p":"M","de":"A scoffer demanded the punishment; man was created anxious and impatient — except those who are constant in their prayer.","dm":"Seorang pengejek meminta disegerakan azab; manusia dicipta bersifat keluh kesah — kecuali mereka yang tetap mendirikan solat."},{"n":71,"f":"071-Nooh.mp3","a":"نوح","t":"Nuh","e":"Noah","m":"Nabi Nuh a.s.","y":28,"p":"M","de":"Nuh AS called his people for 950 years, day and night. His counsel: seek forgiveness, and Allah sends rain, wealth and children (verses 10-12).","dm":"Nabi Nuh AS berdakwah 950 tahun siang dan malam. Pesannya: beristighfarlah, nescaya Allah menurunkan hujan, harta dan zuriat (ayat 10-12)."},{"n":72,"f":"072-Al-Jinn.mp3","a":"الجن","t":"Al-Jinn","e":"The Jinn","m":"Jin","y":28,"p":"M","de":"A company of jinn heard the Quran and believed on the spot; the knowledge of the unseen belongs to Allah alone.","dm":"Sekumpulan jin mendengar Al-Quran lalu terus beriman; ilmu ghaib hanyalah milik Allah semata-mata."},{"n":73,"f":"073-Al-Muzzammil.mp3","a":"المزمل","t":"Al-Muzzammil","e":"The Enshrouded One","m":"Yang Berselimut","y":20,"p":"M","de":"The enwrapped Prophet ﷺ told to stand in night prayer and recite the Quran slowly and clearly — training for the heavy word to come.","dm":"Nabi ﷺ yang berselimut diperintahkan bangun solat malam dan membaca Al-Quran secara tartil — persiapan menerima wahyu yang berat."},{"n":74,"f":"074-Al-Muddaththir.mp3","a":"المدثر","t":"Al-Muddaththir","e":"The Cloaked One","m":"Yang Berselubung","y":56,"p":"M","de":"Arise and warn! The cloaked Prophet ﷺ is commissioned for da'wah; Saqar awaits the deniers, and every soul is held by what it earned.","dm":"Bangunlah dan berilah peringatan! Nabi ﷺ yang berkelubung diangkat untuk berdakwah; Saqar menanti pendusta, dan setiap jiwa terikat dengan amalannya."},{"n":75,"f":"075-Al-Qiyamah.mp3","a":"القيامة","t":"Al-Qiyamah","e":"The Resurrection","m":"Hari Kebangkitan / Kiamat","y":40,"p":"M","de":"Allah is able to reassemble even the fingertips; the surah walks through the moment of death and the faces of that Day.","dm":"Allah mampu menyusun semula hingga hujung jari; surah ini menggambarkan detik kematian dan wajah-wajah manusia pada hari itu."},{"n":76,"f":"076-Al-Insan.mp3","a":"الإنسان","t":"Al-Insan","e":"The Man","m":"Manusia","y":31,"p":"D","de":"Man began as a drop of mingled fluid; the righteous feed the poor, orphan and captive purely for the love of Allah — their reward, the drink of Paradise.","dm":"Manusia bermula daripada setitis air mani yang bercampur; orang soleh memberi makan fakir, anak yatim dan tawanan semata-mata kerana cinta kepada Allah — balasannya minuman syurga."},{"n":77,"f":"077-Al-Mursalat.mp3","a":"المرسلات","t":"Al-Mursalat","e":"Those Sent Forth","m":"Malaikat Yang Diutus","y":50,"p":"M","de":"The winds sent forth in succession as heralds; ten times it thunders: woe that Day to the deniers!","dm":"Angin yang diutus berturut-turut sebagai petanda; sepuluh kali ia menegaskan: kecelakaan besar pada hari itu bagi para pendusta!"},{"n":78,"f":"078-An-Naba'.mp3","a":"النبأ","t":"An-Naba'","e":"The Great News","m":"Berita Besar","y":40,"p":"M","de":"The great news they argue about — resurrection. Sleep, the night, mountains and rain stand as proofs, while Jahannam lies in ambush.","dm":"Berita besar yang mereka pertikaikan — kebangkitan. Tidur, malam, gunung dan hujan menjadi bukti, sementara neraka Jahannam sedia menanti."},{"n":79,"f":"079-An-Nazi'at.mp3","a":"النازعات","t":"An-Nazi'at","e":"Those Who Pull Out","m":"Malaikat Yang Mencabut","y":46,"p":"M","de":"The angels who wrench out souls; Musa's confrontation with Firaun retold — and the Hour whose timing rests with your Lord alone.","dm":"Malaikat yang mencabut nyawa; pertembungan Musa dengan Firaun diceritakan semula — dan saat Kiamat yang ketentuannya hanya di sisi Tuhanmu."},{"n":80,"f":"080-'Abasa.mp3","a":"عبس","t":"'Abasa","e":"He Frowned","m":"Dia Bermasam Muka","y":42,"p":"M","de":"A gentle correction of the Prophet ﷺ regarding the blind seeker Ibn Umm Maktum: guidance is for whoever comes striving.","dm":"Teguran lembut kepada Nabi ﷺ berkenaan Ibn Ummi Maktum yang buta: hidayah adalah untuk sesiapa yang datang bersungguh-sungguh."},{"n":81,"f":"081-At-Takwir.mp3","a":"التكوير","t":"At-Takwir","e":"The Folding Up","m":"Menggulung","y":29,"p":"M","de":"The sun folded up, stars scattered, seas set aflame — cosmic collapse, until every soul knows what it has brought.","dm":"Matahari digulung, bintang berguguran, lautan menggelegak — kehancuran alam, hingga setiap jiwa mengetahui apa yang dibawanya."},{"n":82,"f":"082-Al-Infitar.mp3","a":"الانفطار","t":"Al-Infitar","e":"The Cleaving","m":"Terpecah & Terbelah","y":19,"p":"M","de":"The sky cleft asunder — yet noble angels keep writing every deed. What has deceived you concerning your Generous Lord?","dm":"Langit terbelah — namun malaikat mulia terus mencatat setiap amalan. Apakah yang memperdayakanmu terhadap Tuhanmu Yang Maha Pemurah?"},{"n":83,"f":"083-AlMutaffifin.mp3","a":"المطففين","t":"Al-Mutaffifin","e":"Those Who Deal in Fraud","m":"Golongan yang Curang","y":36,"p":"M","de":"Woe to those who cheat in weights and measures — demanding in full, giving short. Records lie in Sijjin for the wicked, 'Illiyyin for the righteous.","dm":"Celakalah mereka yang curang dalam sukatan dan timbangan — menuntut penuh, memberi kurang. Catatan si jahat dalam Sijjin, si soleh dalam 'Illiyyin."},{"n":84,"f":"084-Al-Inshqaq.mp3","a":"الانشقاق","t":"Al-Inshiqaq","e":"The Splitting Asunder","m":"Terbelah","y":25,"p":"M","de":"The sky splits open in obedience to its Lord; O man, you are toiling onward stage by stage to the meeting with Him.","dm":"Langit terbelah patuh kepada Tuhannya; wahai manusia, engkau bersusah payah setahap demi setahap menuju pertemuan dengan-Nya."},{"n":85,"f":"085-Al-Buruj.mp3","a":"البروج","t":"Al-Buruj","e":"The Constellations","m":"Gugusan Bintang","y":22,"p":"M","de":"The people of the trench burned the believers alive for their faith — but Allah's promise outlasts every tyrant.","dm":"Ashabul Ukhdud membakar orang beriman hidup-hidup kerana iman mereka — tetapi janji Allah mengatasi setiap penzalim."},{"n":86,"f":"086-At-Tariq.mp3","a":"الطارق","t":"At-Tariq","e":"The Night-Comer","m":"Pengunjung Malam","y":17,"p":"M","de":"An oath by the piercing night star; man was created from ejected fluid — surely He is able to bring him back.","dm":"Sumpah demi bintang yang menembusi malam; manusia dicipta daripada air yang terpancar — sesungguhnya Dia berkuasa mengembalikannya."},{"n":87,"f":"087-Al-A'la.mp3","a":"الأعلى","t":"Al-A'la","e":"The Most High","m":"Yang Tertinggi","y":19,"p":"M","de":"Glorify the name of your Lord Most High, who creates and proportions; the Hereafter is better and more lasting — as in the scriptures of Ibrahim and Musa.","dm":"Sucikanlah nama Tuhanmu Yang Maha Tinggi, yang mencipta lalu menyempurnakan; akhirat lebih baik dan lebih kekal — sebagaimana dalam suhuf Ibrahim dan Musa."},{"n":88,"f":"088-Al-Ghashiyah.mp3","a":"الغاشية","t":"Al-Ghashiyah","e":"The Overwhelming","m":"Peristiwa Menggelisahkan/Hari Pembalasan","y":26,"p":"M","de":"Faces that Day — some humbled and weary, others radiant and pleased. Look at the camel, the sky, the mountains, the earth: then remind, for you are but a reminder.","dm":"Wajah-wajah pada hari itu — ada yang tunduk hina, ada yang berseri gembira. Perhatikan unta, langit, gunung dan bumi: lalu berilah peringatan, kerana tugasmu hanyalah mengingatkan."},{"n":89,"f":"089-Al-Fajr.mp3","a":"الفجر","t":"Al-Fajr","e":"The Dawn","m":"Fajar / Sinar Mentari","y":30,"p":"M","de":"Oaths by the dawn and ten nights; the fates of 'Ad, Thamud and Firaun — and the call home: O tranquil soul, return to your Lord well-pleased.","dm":"Sumpah demi fajar dan sepuluh malam; kesudahan 'Ad, Thamud dan Firaun — dan panggilan pulang: wahai jiwa yang tenang, kembalilah kepada Tuhanmu dengan redha."},{"n":90,"f":"090-Al-Balad.mp3","a":"البلد","t":"Al-Balad","e":"The City","m":"Negeri","y":20,"p":"M","de":"An oath by this city of Makkah; man is created into toil — and the steep path is freeing a slave and feeding the hungry on a day of famine.","dm":"Sumpah demi kota Makkah ini; manusia dicipta dalam kepayahan — dan jalan yang mendaki ialah membebaskan hamba serta memberi makan pada hari kelaparan."},{"n":91,"f":"091-Ash-Shams.mp3","a":"الشمس","t":"Ash-Shams","e":"The Sun","m":"Matahari","y":15,"p":"M","de":"Seven oaths by the sun, moon and soul: successful is the one who purifies it, ruined is the one who corrupts it — as Thamud learned through the she-camel.","dm":"Tujuh sumpah demi matahari, bulan dan jiwa: beruntunglah yang menyucikannya, rugilah yang mengotorinya — seperti pengajaran Thamud dengan unta betina."},{"n":92,"f":"092-Al-Lail.mp3","a":"الليل","t":"Al-Lail","e":"The Night","m":"Malam","y":21,"p":"M","de":"Your striving is truly diverse: for the generous and God-fearing, the path to ease is smoothed; for the miserly denier, the path to hardship.","dm":"Usaha kamu sungguh berbeza-beza: bagi yang pemurah dan bertakwa dimudahkan jalan kesenangan; bagi yang bakhil dan mendustakan, jalan kesukaran."},{"n":93,"f":"093-Ad-Duha.mp3","a":"الضحى","t":"Ad-Duha","e":"The Morning Brightness","m":"Pagi yang Cemerlang / Matahari Meninggi","y":11,"p":"M","de":"By the morning brightness: your Lord has not forsaken you nor does He hate you — so honour the orphan, and turn no beggar away.","dm":"Demi cahaya duha: Tuhanmu tidak meninggalkanmu dan tidak membencimu — maka muliakanlah anak yatim, dan jangan herdik peminta."},{"n":94,"f":"094-Ash-Sharh.mp3","a":"الشرح","t":"Ash-Sharh","e":"The Relief","m":"Melapangkan","y":8,"p":"M","de":"Did We not expand your breast and remove your burden? Twice affirmed: truly with hardship comes ease.","dm":"Bukankah Kami telah melapangkan dadamu dan mengangkat bebanmu? Ditegaskan dua kali: sesungguhnya bersama kesulitan ada kemudahan."},{"n":95,"f":"095-At-Tin.mp3","a":"التين","t":"At-Tin","e":"The Fig","m":"Buah Tin / Buah Ara","y":8,"p":"M","de":"By the fig and the olive: man was created in the finest mould, then reduced to the lowest — except those who believe and do righteous deeds.","dm":"Demi buah tin dan zaitun: manusia dicipta dalam sebaik-baik kejadian, kemudian dikembalikan ke tempat yang serendah-rendahnya — kecuali yang beriman dan beramal soleh."},{"n":96,"f":"096-Al-'Alaq.mp3","a":"العلق","t":"Al-'Alaq","e":"The Clot","m":"Segumpal Darah","y":19,"p":"M","de":"The first revelation at Hira: Read in the name of your Lord! Knowledge comes by the pen — and the surah ends: prostrate and draw near.","dm":"Wahyu pertama di Gua Hira: Bacalah dengan nama Tuhanmu! Ilmu datang melalui pena — dan surah ini ditutup: sujudlah dan dekatkanlah dirimu."},{"n":97,"f":"097-Al-Qadr.mp3","a":"القدر","t":"Al-Qadr","e":"The Night of Decree","m":"Kemuliaan","y":5,"p":"M","de":"The Night of Decree is better than a thousand months; the angels and the Spirit descend, and it is peace until the break of dawn.","dm":"Lailatul Qadar lebih baik daripada seribu bulan; para malaikat dan Jibril turun, sejahteralah malam itu hingga terbit fajar."},{"n":98,"f":"098-Al-Baiyinah.mp3","a":"البينة","t":"Al-Baiyinah","e":"The Clear Evidence","m":"Bukti yang Nyata","y":8,"p":"D","de":"The clear evidence has come; they were only commanded to worship Allah with pure devotion — the believers who act are the best of creation.","dm":"Bukti yang nyata telah datang; mereka hanya diperintahkan menyembah Allah dengan penuh ikhlas — mukmin yang beramal adalah sebaik-baik makhluk."},{"n":99,"f":"099-Az-Zalzalah.mp3","a":"الزلزلة","t":"Az-Zalzalah","e":"The Earthquake","m":"Kegoncangan","y":8,"p":"D","de":"The earth's final quake makes her tell her news: whoever does an atom's weight of good will see it, and an atom's weight of evil will see it.","dm":"Gegaran terakhir bumi membuatkannya menceritakan beritanya: sesiapa membuat kebaikan sebesar zarah akan melihatnya, dan kejahatan sebesar zarah pun akan melihatnya."},{"n":100,"f":"100-Al-'Adiyat.mp3","a":"العاديات","t":"Al-'Adiyat","e":"The Coursers","m":"Yang Berlari Kencang","y":11,"p":"M","de":"War steeds charging at dawn bear witness: man is ungrateful to his Lord — and he himself testifies to it by his intense love of wealth.","dm":"Kuda perang yang menyerbu di waktu subuh menjadi saksi: manusia sungguh tidak bersyukur kepada Tuhannya — dan dia sendiri menyaksikannya melalui cintanya yang keras kepada harta."},{"n":101,"f":"101-Al-Qari'ah.mp3","a":"القارعة","t":"Al-Qari'ah","e":"The Striking Hour","m":"Hari Yang Hingar Bingar / Kiamat","y":11,"p":"M","de":"The striking calamity, when people are like scattered moths: heavy scales bring a pleasant life, light scales a blazing abyss.","dm":"Hari yang menggemparkan, ketika manusia bagai kelkatu berterbangan: timbangan yang berat membawa kehidupan yang diredhai, yang ringan ke jurang api."},{"n":102,"f":"102-At-Takathur.mp3","a":"التكاثر","t":"At-Takathur","e":"The Rivalry in Increase","m":"Bermegah-megah","y":8,"p":"M","de":"Competing to pile up more distracted you — until you visit the graves. You will surely see the Blaze, then be asked about every delight.","dm":"Bermegah-megah mengumpul harta melalaikan kamu — hingga kamu masuk ke kubur. Pasti kamu akan melihat neraka, kemudian ditanya tentang segala nikmat."},{"n":103,"f":"103-Al-'Asr.mp3","a":"العصر","t":"Al-'Asr","e":"The Time","m":"Masa","y":3,"p":"M","de":"By time itself: all mankind is in loss — except those who believe, do good, and counsel one another to truth and to patience.","dm":"Demi masa: sesungguhnya manusia dalam kerugian — kecuali yang beriman, beramal soleh, dan berpesan-pesan dengan kebenaran serta kesabaran."},{"n":104,"f":"104-Al-Humazah.mp3","a":"الهمزة","t":"Al-Humazah","e":"The Slanderer","m":"Pengumpat","y":9,"p":"M","de":"Woe to every slanderer and backbiter who hoards wealth thinking it grants immortality — the crushing Fire will close in over them.","dm":"Celakalah setiap pengumpat dan pencela yang menimbun harta dan menyangka hartanya mengekalkannya — api Hutamah akan menutup rapat ke atas mereka."},{"n":105,"f":"105-Al-Fil.mp3","a":"الفيل","t":"Al-Fil","e":"The Elephant","m":"Gajah","y":5,"p":"M","de":"Abrahah's army of elephants marched on the Kaaba — and flocks of birds with stones of baked clay left them like devoured straw.","dm":"Tentera bergajah Abrahah mara ke Kaabah — lalu burung berbondong-bondong dengan batu dari tanah terbakar menjadikan mereka bagai daun dimakan ulat."},{"n":106,"f":"106-Quraish.mp3","a":"قريش","t":"Quraish","e":"Quraish","m":"Kaum Quraisy","y":4,"p":"M","de":"The security of Quraish's winter and summer journeys — so let them worship the Lord of this House who fed them and made them safe.","dm":"Keamanan perjalanan Quraisy pada musim sejuk dan panas — maka hendaklah mereka menyembah Tuhan Rumah ini yang memberi mereka makan dan keamanan."},{"n":107,"f":"107-Al-Ma'un.mp3","a":"الماعون","t":"Al-Ma'un","e":"The Small Kindnesses","m":"Barangan Berguna","y":7,"p":"M","de":"Have you seen the one who denies the judgment? He pushes away the orphan — and woe to worshippers who are heedless and pray to be seen.","dm":"Tahukah kamu orang yang mendustakan hari pembalasan? Dialah yang mengherdik anak yatim — dan celakalah orang yang solatnya lalai dan riak."},{"n":108,"f":"108-Al-Kauthar.mp3","a":"الكوثر","t":"Al-Kauthar","e":"The Abundance","m":"Sungai Di Syurga","y":3,"p":"M","de":"The Prophet ﷺ granted al-Kauthar in abundance: so pray to your Lord and sacrifice — it is his enemy who is cut off.","dm":"Nabi ﷺ dikurniakan nikmat al-Kautsar yang melimpah: maka solatlah kerana Tuhanmu dan berkorbanlah — musuhnya itulah yang sebenarnya terputus."},{"n":109,"f":"109-Al-Kafirun.mp3","a":"الكافرون","t":"Al-Kafirun","e":"The Disbelievers","m":"Golongan Kafir","y":6,"p":"M","de":"The clean line of creed, revealed when idolaters offered to take turns in worship: for you is your religion, and for me is mine.","dm":"Garis akidah yang tegas, diturunkan ketika musyrikin menawarkan ibadah bergilir: bagimu agamamu, dan bagiku agamaku."},{"n":110,"f":"110-An-Nasr.mp3","a":"النصر","t":"An-Nasr","e":"The Divine Support","m":"Pertolongan","y":3,"p":"D","de":"When Allah's help and the conquest of Makkah came and people entered Islam in crowds — glorify your Lord and seek His forgiveness.","dm":"Apabila pertolongan Allah dan pembukaan Makkah tiba dan manusia berbondong-bondong memeluk Islam — bertasbihlah memuji Tuhanmu dan mohonlah keampunan-Nya."},{"n":111,"f":"111-Al-Masad.mp3","a":"المسد","t":"Al-Masad","e":"The Palm Fiber","m":"Nyalaan Api","y":5,"p":"M","de":"The doom of Abu Lahab and his wife, sworn enemies of the Prophet ﷺ — neither wealth nor gains availed them against Allah's decree.","dm":"Kebinasaan Abu Lahab dan isterinya, musuh ketat Nabi ﷺ — harta dan usahanya langsung tidak berguna menentang ketetapan Allah."},{"n":112,"f":"112-Al-Ikhlas.mp3","a":"الإخلاص","t":"Al-Ikhlas","e":"The Sincerity","m":"Tulus Ikhlas / Memurnikan Keesaan Allah","y":4,"p":"M","de":"Equal to a third of the Quran: Say, He is Allah, the One, the Eternal Refuge — He neither begets nor is born, and none is comparable to Him.","dm":"Menyamai sepertiga Al-Quran: Katakanlah, Dialah Allah Yang Maha Esa, tempat bergantung segala sesuatu — tidak beranak dan tidak diperanakkan, dan tiada sesuatu pun yang setara dengan-Nya."},{"n":113,"f":"113-Al-Falaq.mp3","a":"الفلق","t":"Al-Falaq","e":"The Daybreak","m":"Waktu Subuh / Dinihari","y":5,"p":"M","de":"Seeking refuge with the Lord of daybreak from the evil of what He created — from darkness, from sorcery, and from the envier when he envies.","dm":"Memohon perlindungan dengan Tuhan yang menguasai subuh daripada kejahatan makhluk-Nya — daripada kegelapan malam, sihir, dan kedengkian pendengki."},{"n":114,"f":"114-An-Nas.mp3","a":"الناس","t":"An-Nas","e":"Mankind","m":"Manusia","y":6,"p":"M","de":"The final surah: refuge with the Lord, King and God of mankind from the retreating whisperer — among jinn and among men.","dm":"Surah terakhir: berlindung dengan Tuhan, Raja dan Sembahan manusia daripada bisikan syaitan yang menyelinap — daripada kalangan jin dan manusia."}];
const audio = document.getElementById('dxq-audio');
audio.crossOrigin = 'anonymous'; // CORS-clean load so the analyser may read the signal
const list = document.getElementById('dxq-list');
const player = document.getElementById('dxq-player');
const $ = (id) => document.getElementById(id);
const LS_KEY = 'quran-player-v1';
const LS_LANG = 'quran-lang';

let current = -1;
let pendingJmp = null;
let shuffle = false;
let repeat = 0;            // 0 off, 1 all, 2 one
const SPEEDS = [1, 1.25, 1.5, 0.75];
let speedIx = 0;

/* ---------- i18n ---------- */
const I18N = {
  en: {
    pill: 'Complete 114 Surah',
    tagline: 'Recited by',
    desc: 'Listen to 12 renowned reciters, follow the text word by word, read the full Madinah mushaf, and understand every verse with translations, classical tafsir and related hadith — all on one page.',
    resume: 'Continue listening',
    all: 'All 114',
    fav: 'Favourites',
    empty: 'No surah matches your search.',
    aboutH: 'About Digital Quran',
    search: 'Search surah… (e.g. 36, Yasin, Cave)',
    verses: 'verses',
    chatBtn: 'Quran AI Chat',
    chatSub: 'Verified authentic text',
    chatHi: 'Assalamualaikum! Ask me for any verse, translation or classical tafsir — everything I show is fetched live from verified authentic sources, never AI-generated. Try: “2:255”, “Al-Kahf 1-5”, “tafsir Al-Ikhlas”, or a topic like “patience in hardship”.',
    chatPh: 'Ask a verse, surah or topic…',
    chatLoad: 'Fetching verified text…',
    chatErr: 'Could not reach the Quran server. Please check your connection and try again.',
    chatTafsir: 'Read Tafsir (Ibn Kathir)',
    chatFound: 'Closest verses for',
    chatNoRes: 'No verses matched that search. Try different words.',
    chatCap: 'Showing the first 10 verses of the range.',
    chatNote: 'Translation: Sahih International (English) · Tafsir: Ibn Kathir',
    readAria: 'Read Surah',
    readMore: 'Load next verses',
    readEnd: 'End of surah — صدق الله العظيم',
    readTafsir: 'Tafsir',
    buffer: 'buffering…',
    loadErr: 'Could not load this file — check the MP3 is available.',
    playCard: 'Play Surah',
    aFilterNav: 'Search and filter surah',
    aSearch: 'Search surah',
    aFilter: 'Filter',
    aPlaylist: 'Surah playlist',
    aReader: 'Surah reader',
    aClose: 'Close',
    aAsk: 'Ask',
    aSend: 'Send',
    aPlayer: 'Audio player',
    aSeek: 'Seek',
    aShuffle: 'Shuffle',
    aPrev: 'Previous surah',
    aNext: 'Next surah',
    aPlay: 'Play',
    aPause: 'Pause',
    tPlayPause: 'Play / Pause',
    aRepeat: ['Repeat: off', 'Repeat: all', 'Repeat: one'],
    aRepeatT: 'Repeat',
    aSpeed: 'Playback speed',
    aVol: 'Volume',
    aMin: 'Minimize player',
    aExpand: 'Expand player',
    noTafsir: 'No tafsir entry is available for this verse.',
    mtChip: 'Translate to Malay (auto)',
    mtBack: 'View original (English)',
    mtLoad: 'Translating…',
    mtNote: 'Automatic machine translation of Tafsir Ibn Kathir.',
    mtErr: 'Translation service is unavailable right now — the original English text is shown.',
    mtNoteHadith: 'Automatic machine translation of the related hadith.',
    answersChip: 'Q&A',
    answersNone: 'No questions for this verse.',
    mtNoteAnswers: 'Automatic machine translation of the scholarly Q&A.',
    mtNoteInfo: 'Automatic machine translation of the surah overview.',
    emptyClear: 'Show all 114',
    aTop: 'Back to top',
    aNowJump: 'Show current surah in the list',
    bookBtn: 'Read Mushaf',
    bookTitle: 'Mushaf Al-Quran',
    bookLoad: 'Downloading the mushaf… first time only, it opens instantly after this.',
    bookErr: 'The mushaf could not be loaded right now — please try again shortly.',
    bookDl: 'Download PDF',
    bookNextL: 'Next',
    bookPrevL: 'Previous',
    bookSrc: 'Madinah Mushaf — King Fahd Complex',
    aBook: 'Mushaf reader',
    dailyT: 'Verse of the Day',
    dailyOpen: 'Read in context',
    dailyShufA: 'Show another verse',
    aQari: 'Choose reciter',
    streakLbl: 'day streak',
    searchTrBtn: 'Search "{q}" in the translation',
    searchTrHead: 'Verse matches for',
    srchOpen: 'Open',
    noTrRes: 'No verses matched that search.',
    sajdah: 'Sajdah verse',
    kar: 'Follow along',
    textSize: 'Text size',
    playAyah: 'Play this verse',
    rumi: 'Rumi transliteration',
    dqSub: 'Al-Quran Al-Kareem · 114 Surah',
    dqReciters: '12 reciters',
    dqListenL: 'Listen',
    dqListenT: 'Play the whole Quran',
    dqListenS: 'Continuous playlist from Al-Fatihah to An-Nas with a live visualizer — or tap any surah below.',
    dqPlayAll: 'Play all',
    dqTajL: 'Learn Tajweed',
    dqTajT: 'Colour-coded tajweed',
    dqTajS: '20 colour-coded rules + how to recite every letter.',
    dqOpenEx: 'Open example',
    dqUnderstand: 'Understand',
    dqTafsirT: 'Tafsir & Hadith',
    dqTafsirS: 'Ibn Kathir tafsir in Malay + related hadith for every verse.',
    dqOpenReader: 'Open reader',
    tafSource: 'Tafsir source',
    tafEnGrp: 'English editions',
    tafArGrp: 'Arabic · machine-translated',
    dqMushafL: 'Read',
    dqMushafT: 'Read the Mushaf',
    dqMushafS: 'The full Madinah mushaf in 15 editions — flip through the pages like a real copy.',
    dqMushafGo: 'Open mushaf',
    dqMushafEd: '15 editions',
    dqChatL: 'Ask',
    dqChatT: 'Quran AI Chat',
    dqChatS: 'Ask for any verse, translation or tafsir — from verified sources.',
    dqChatGo: 'Start chat',
    dqBeginner: 'For beginners',
    dqAuto: 'Auto',
    dqRumiT: 'Rumi transliteration',
    dqRumiS: 'Follow the Arabic pronunciation in Latin script — ideal for new learners.',
    hukumChip: 'Rules',
    hukumNone: 'No tajweed rules detected in this verse.',
    tajDesc: {
      madda_normal: 'Lengthen the sound for 2 counts.',
      madda_permissible: 'When stopping here, lengthen 2, 4 or 6 counts.',
      madda_lin: 'Soft وْ / يْ after a fatha at a stopping point — lengthen 2, 4 or 6 counts.',
      madda_muttasil: 'Mad meets hamzah in the same word — lengthen 4 or 5 counts.',
      madda_munfasil: 'Mad meets hamzah starting the next word — lengthen 2, 4 or 5 counts.',
      madda_necessary: 'Lengthen for 6 counts.',
      madda_badal: 'Hamzah followed by a madd letter — lengthen 2 counts.',
      qalaqah: 'Give the letter (ق ط ب ج د) a bouncing echo when it is silent.',
      ghunnah: 'Hold the nasal sound of نّ / مّ for 2 counts.',
      izhar_halqi: 'Pronounce the nun sakinah/tanwin clearly, with no nasalisation.',
      ikhafa: 'Hide the nun sakinah/tanwin into a 2-count nasal sound.',
      izhar_shafawi: 'Pronounce the mim sakinah clearly, with no nasalisation.',
      ikhafa_shafawi: 'Hide the mim sakinah with a nasal sound before ب.',
      idgham_ghunnah: 'Merge the nun sakinah/tanwin into the next letter (ي ن م و) with nasalisation.',
      idgham_wo_ghunnah: 'Merge the nun sakinah/tanwin into ل or ر without nasalisation.',
      idgham_shafawi: 'Merge the mim sakinah into the following م with nasalisation.',
      idgham_mutajanisayn: 'Merge the letter into the next letter of the same articulation point.',
      idgham_mutaqaribayn: 'Merge the letter into the next letter of a close articulation point.',
      iqlab: 'Convert the nun sakinah/tanwin into a nasal م sound before ب.',
      ham_wasl: 'Pronounced only when starting here; dropped when reading continuously.',
      laam_shamsiyah: 'The lam is silent — move straight into the doubled letter after it.',
      laam_qamariyah: 'The lam is pronounced clearly.',
      slnt: 'This letter is not pronounced.',
    },
    karStopA: 'Stop follow-along',
    taj: 'Tajweed',
    tajLegend: 'Colours mark tajweed rules: mad, ghunnah, qalqalah, ikhfa, idgham, iqlab.',
    infoBtn: 'About',
    infoHead: 'About this surah',
    bmkBtn: 'Bookmarks',
    bmkAdd: 'Bookmark this verse',
    bmkEmpty: 'No bookmarks yet — use the bookmark button on any verse in the reader.',
    wbwHint: 'Tap any word for its meaning',
    goalSet: 'Set a daily reading goal',
    goalLbl: 'Goal: {n} verses a day',
    goalDone: 'Reached!',
    juzHizbPh: 'Juz / Hizb…',
    hadithChip: 'Hadith',
    hadithNone: 'No linked hadith recorded for this verse.',
  },
  ms: {
    pill: '114 Surah Lengkap',
    tagline: 'Bacaan oleh',
    desc: 'Dengar bacaan 12 qari pilihan, ikuti teks kata demi kata, baca mushaf Madinah penuh, dan fahami setiap ayat dengan terjemahan, tafsir klasik dan hadis berkaitan — semuanya dalam satu halaman.',
    resume: 'Sambung mendengar',
    all: 'Semua 114',
    fav: 'Surah Pilihan',
    empty: 'Tiada surah sepadan dengan carian anda.',
    aboutH: 'Tentang Digital Quran',
    search: 'Cari surah… (cth. 36, Yasin, Gua)',
    verses: 'ayat',
    chatBtn: 'Quran AI Chat',
    chatSub: 'Teks sahih terjamin',
    chatHi: 'Assalamualaikum! Minta mana-mana ayat, terjemahan atau tafsir klasik — semua yang saya papar diambil terus daripada sumber sahih, bukan dijana AI. Cuba: “2:255”, “Al-Kahf 1-5”, “tafsir Al-Ikhlas”, atau topik seperti “sabar menghadapi ujian”.',
    chatPh: 'Tanya ayat, surah atau topik…',
    chatLoad: 'Mengambil teks sahih…',
    chatErr: 'Tidak dapat menghubungi pelayan Quran. Sila semak sambungan dan cuba lagi.',
    chatTafsir: 'Baca Tafsir (Ibn Kathir)',
    chatFound: 'Ayat terdekat untuk',
    chatNoRes: 'Tiada ayat sepadan dengan carian itu. Cuba perkataan lain.',
    chatCap: 'Memaparkan 10 ayat pertama julat itu.',
    chatNote: 'Terjemahan ayat: Abdullah Basmeih · Tafsir: Ibn Kathir',
    readAria: 'Baca Surah',
    readMore: 'Muat ayat seterusnya',
    readEnd: 'Tamat surah — صدق الله العظيم',
    readTafsir: 'Tafsir',
    buffer: 'memuatkan…',
    loadErr: 'Fail audio tidak dapat dimuatkan — sila cuba lagi.',
    playCard: 'Main Surah',
    aFilterNav: 'Cari dan tapis surah',
    aSearch: 'Cari surah',
    aFilter: 'Tapis',
    aPlaylist: 'Senarai surah',
    aReader: 'Pembaca surah',
    aClose: 'Tutup',
    aAsk: 'Tanya',
    aSend: 'Hantar',
    aPlayer: 'Pemain audio',
    aSeek: 'Kedudukan bacaan',
    aShuffle: 'Mod rawak',
    aPrev: 'Surah sebelumnya',
    aNext: 'Surah seterusnya',
    aPlay: 'Main',
    aPause: 'Jeda',
    tPlayPause: 'Main / Jeda',
    aRepeat: ['Ulang: mati', 'Ulang: semua', 'Ulang: satu'],
    aRepeatT: 'Ulang',
    aSpeed: 'Kelajuan bacaan',
    aVol: 'Kelantangan',
    aMin: 'Kecilkan pemain',
    aExpand: 'Besarkan pemain',
    noTafsir: 'Tiada catatan tafsir untuk ayat ini.',
    mtChip: 'Terjemah ke BM (automatik)',
    mtBack: 'Lihat teks asal (Inggeris)',
    mtLoad: 'Menterjemah…',
    mtNote: 'Terjemahan automatik daripada tafsir Ibn Kathir.',
    mtErr: 'Perkhidmatan terjemahan tidak tersedia buat masa ini — teks asal Inggeris dipaparkan.',
    mtNoteHadith: 'Terjemahan automatik daripada teks hadis berkaitan.',
    answersChip: 'Soalan',
    answersNone: 'Tiada soalan untuk ayat ini.',
    mtNoteAnswers: 'Terjemahan automatik daripada soal jawab ulama.',
    mtNoteInfo: 'Terjemahan automatik daripada nota pengenalan surah.',
    emptyClear: 'Papar semua 114',
    aTop: 'Kembali ke atas',
    aNowJump: 'Tunjuk surah semasa dalam senarai',
    bookBtn: 'Baca Mushaf',
    bookTitle: 'Mushaf Al-Quran',
    bookLoad: 'Memuat turun mushaf… kali pertama sahaja, selepas ini terus terbuka.',
    bookErr: 'Mushaf tidak dapat dimuatkan buat masa ini — sila cuba sebentar lagi.',
    bookDl: 'Muat turun PDF',
    bookNextL: 'Seterusnya',
    bookPrevL: 'Sebelum',
    bookSrc: 'Mushaf Madinah — Kompleks Raja Fahd',
    aBook: 'Pembaca mushaf',
    dailyT: 'Ayat Hari Ini',
    dailyOpen: 'Baca dalam konteks',
    dailyShufA: 'Papar ayat lain',
    aQari: 'Pilih qari',
    streakLbl: 'hari berturut-turut',
    searchTrBtn: 'Cari "{q}" dalam terjemahan',
    searchTrHead: 'Padanan ayat untuk',
    srchOpen: 'Buka',
    noTrRes: 'Tiada ayat sepadan dengan carian itu.',
    sajdah: 'Ayat sajdah',
    kar: 'Ikut Bacaan',
    textSize: 'Saiz teks',
    playAyah: 'Main ayat ini',
    rumi: 'Transliterasi Rumi',
    dqSub: 'Al-Quran Al-Kareem · 114 Surah',
    dqReciters: '12 qari',
    dqListenL: 'Dengar',
    dqListenT: 'Main seluruh Al-Quran',
    dqListenS: 'Senarai main berterusan dari Al-Fatihah ke An-Nas dengan visualizer masa nyata — atau tekan mana-mana surah di bawah.',
    dqPlayAll: 'Main semua',
    dqTajL: 'Belajar Tajweed',
    dqTajT: 'Tajweed berwarna',
    dqTajS: '20 hukum berwarna + cara bacaan setiap huruf.',
    dqOpenEx: 'Buka contoh',
    dqUnderstand: 'Fahami',
    dqTafsirT: 'Tafsir & Hadis',
    dqTafsirS: 'Tafsir Ibn Kathir dalam BM + hadis berkaitan untuk setiap ayat.',
    dqOpenReader: 'Buka pembaca',
    tafSource: 'Sumber tafsir',
    tafEnGrp: 'Edisi Inggeris',
    tafArGrp: 'Arab · terjemahan mesin',
    dqMushafL: 'Baca',
    dqMushafT: 'Baca Mushaf',
    dqMushafS: 'Mushaf Madinah penuh dalam 15 edisi — selak muka surat seperti naskhah sebenar.',
    dqMushafGo: 'Buka mushaf',
    dqMushafEd: '15 edisi',
    dqChatL: 'Tanya',
    dqChatT: 'Quran AI Chat',
    dqChatS: 'Tanya apa-apa ayat, terjemahan atau tafsir — daripada sumber sahih.',
    dqChatGo: 'Mula chat',
    dqBeginner: 'Untuk pemula',
    dqAuto: 'Auto BM',
    dqRumiT: 'Transliterasi Rumi',
    dqRumiS: 'Ikut sebutan Arab dalam tulisan Rumi — sesuai untuk yang baru belajar.',
    hukumChip: 'Hukum',
    hukumNone: 'Tiada hukum tajweed dikesan dalam ayat ini.',
    tajDesc: {
      madda_normal: 'Panjangkan bacaan 2 harakat.',
      madda_permissible: 'Ketika waqaf (berhenti) di sini, panjangkan 2, 4 atau 6 harakat.',
      madda_lin: 'Huruf lin (وْ / يْ selepas baris atas) ketika waqaf — panjangkan 2, 4 atau 6 harakat.',
      madda_muttasil: 'Mad bertemu hamzah dalam kata yang sama — panjangkan 4 atau 5 harakat.',
      madda_munfasil: 'Mad bertemu hamzah di awal kata berikutnya — panjangkan 2, 4 atau 5 harakat.',
      madda_necessary: 'Panjangkan bacaan 6 harakat.',
      madda_badal: 'Hamzah diikuti huruf madd — panjangkan 2 harakat.',
      qalaqah: 'Lantunkan bunyi huruf (ق ط ب ج د) ketika ia bersukun.',
      ghunnah: 'Dengungkan نّ / مّ selama 2 harakat.',
      izhar_halqi: 'Sebut nun sakinah/tanwin dengan jelas, tanpa dengung.',
      ikhafa: 'Samarkan nun sakinah/tanwin dengan dengung 2 harakat.',
      izhar_shafawi: 'Sebut mim sakinah dengan jelas, tanpa dengung.',
      ikhafa_shafawi: 'Samarkan mim sakinah dengan dengung sebelum ب.',
      idgham_ghunnah: 'Masukkan nun sakinah/tanwin ke huruf berikutnya (ي ن م و) dengan dengung.',
      idgham_wo_ghunnah: 'Masukkan nun sakinah/tanwin ke ل atau ر tanpa dengung.',
      idgham_shafawi: 'Masukkan mim sakinah ke م berikutnya dengan dengung.',
      idgham_mutajanisayn: 'Masukkan huruf ke dalam huruf sama makhraj selepasnya.',
      idgham_mutaqaribayn: 'Masukkan huruf ke dalam huruf hampir makhraj selepasnya.',
      iqlab: 'Tukarkan nun sakinah/tanwin kepada bunyi م berdengung sebelum ب.',
      ham_wasl: 'Disebut hanya jika bacaan bermula di sini; gugur ketika bacaan bersambung.',
      laam_shamsiyah: 'Lam tidak disebut — terus kepada huruf bersabdu selepasnya.',
      laam_qamariyah: 'Lam disebut dengan jelas.',
      slnt: 'Huruf ini tidak disebut.',
    },
    karStopA: 'Henti ikut bacaan',
    taj: 'Tajweed',
    tajLegend: 'Warna menanda hukum tajweed: mad, ghunnah, qalqalah, ikhfa, idgham, iqlab.',
    infoBtn: 'Tentang',
    infoHead: 'Tentang surah ini',
    bmkBtn: 'Penanda',
    bmkAdd: 'Tanda ayat ini',
    bmkEmpty: 'Tiada penanda lagi — tekan butang penanda pada mana-mana ayat dalam pembaca.',
    wbwHint: 'Sentuh mana-mana perkataan untuk maknanya',
    goalSet: 'Tetapkan sasaran bacaan harian',
    goalLbl: 'Sasaran: {n} ayat sehari',
    goalDone: 'Tercapai!',
    juzHizbPh: 'Juz / Hizb…',
    hadithChip: 'Hadis',
    hadithNone: 'Tiada hadis berkait direkodkan untuk ayat ini.',
  },
};
let lang = 'en';
try { lang = localStorage.getItem(LS_LANG) === 'ms' ? 'ms' : 'en'; } catch (e) {}

const ICO = {
  play: '<path d="M8 5.5 19 12 8 18.5z"/>',
  stop: '<rect x="6.5" y="6.5" width="11" height="11" rx="1.5"/>',
  book: '<path d="M2 4h7a3 3 0 0 1 3 3v13a2.4 2.4 0 0 0-2.4-2.4H2z"/><path d="M22 4h-7a3 3 0 0 0-3 3v13a2.4 2.4 0 0 1 2.4-2.4H22z"/>',
  mic: '<path d="M12 2a3 3 0 0 1 3 3v6a3 3 0 0 1-6 0V5a3 3 0 0 1 3-3z"/><path d="M19 10v1a7 7 0 0 1-14 0v-1"/><path d="M12 18v4"/>',
  palette: '<circle cx="13.5" cy="6.5" r="1.1"/><circle cx="17.5" cy="10.5" r="1.1"/><circle cx="8.5" cy="7.5" r="1.1"/><circle cx="6.5" cy="12" r="1.1"/><path d="M12 2a10 10 0 1 0 0 20 2 2 0 0 0 2-2v-1a2 2 0 0 1 2-2h2a4 4 0 0 0 4-4A10 10 0 0 0 12 2z"/>',
  info: '<circle cx="12" cy="12" r="9.5"/><path d="M12 11v6"/><path d="M12 7.2v.4"/>',
  shuffle: '<path d="M16 3h5v5"/><path d="M4 20 21 3"/><path d="M21 16v5h-5"/><path d="m15 15 6 6"/><path d="m4 4 5 5"/>',
  bookmark: '<path d="M6 3h12a1 1 0 0 1 1 1v17l-7-4-7 4V4a1 1 0 0 1 1-1z"/>',
  volume: '<path d="M11 5 6 9H2v6h4l5 4z"/><path d="M15.5 8.5a5 5 0 0 1 0 7"/><path d="M18.5 5.5a9 9 0 0 1 0 13"/>',
  globe: '<circle cx="12" cy="12" r="9.5"/><path d="M2.5 12h19"/><path d="M12 2.5c3 3 3 16 0 19c-3-3-3-16 0-19z"/>',
  flame: '<path d="M12 2c1 4-4 6-4 10a4 4 0 0 0 8 0c0-2-1-3-1-3s3 1 3 5a6 6 0 0 1-12 0C6 8 12 7 12 2z"/>',
  search: '<circle cx="11" cy="11" r="7"/><path d="m21 21-4.3-4.3"/>',
  download: '<path d="M12 3v12"/><path d="m7 10 5 5 5-5"/><path d="M4 21h16"/>',
  target: '<circle cx="12" cy="12" r="9"/><circle cx="12" cy="12" r="4.6"/><path d="M12 11.2v1.6"/>',
};
function svgI(name, size) {
  return '<svg width="' + (size || 14) + '" height="' + (size || 14) + '" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + ICO[name] + '</svg>';
}
const meaning = (s) => (lang === 'ms' ? s.m : s.e);

function applyLang() {
  const t = I18N[lang];
  document.documentElement.lang = lang;
  document.querySelectorAll('[data-i18n]').forEach((el) => {
    const k = el.getAttribute('data-i18n');
    if (t[k]) el.textContent = t[k];
  });
  document.querySelectorAll('[data-i18n-aria]').forEach((el) => {
    const k = el.getAttribute('data-i18n-aria');
    if (t[k]) el.setAttribute('aria-label', t[k]);
  });
  document.querySelectorAll('[data-i18n-title]').forEach((el) => {
    const k = el.getAttribute('data-i18n-title');
    if (t[k]) el.title = t[k];
  });
  $('dxq-q').placeholder = t.search;
  $('dxq-chatInput').placeholder = t.chatPh;
  $('dxq-readMore').textContent = t.readMore;
  $('dxq-readPlay').innerHTML = '▶<span class="lbl"> ' + t.aPlay + '</span>';
  $('dxq-readPlay').setAttribute('aria-label', t.aPlay);
  chatQuickChips();
  renderTopics();
  if ($('dxq-readKar')) {
    $('dxq-readKar').innerHTML = svgI('mic') + '<span class="lbl"> ' + t.kar + '</span>';
    $('dxq-readKar').setAttribute('aria-label', t.kar);
    $('dxq-readTaj').innerHTML = svgI('palette') + '<span class="lbl"> ' + t.taj + '</span>';
    $('dxq-readTaj').setAttribute('aria-label', t.taj);
    $('dxq-readInfo').innerHTML = svgI('info') + '<span class="lbl"> ' + t.infoBtn + '</span>';
    $('dxq-readInfo').setAttribute('aria-label', t.infoBtn);
    if (typeof applyRdSize === 'function') applyRdSize();
    if (typeof applyRumi === 'function') applyRumi();
    if (typeof initReadTrans === 'function') initReadTrans();
    if (typeof refreshTranslations === 'function') refreshTranslations();
  }
  if (typeof dailyKey !== 'undefined' && dailyKey) showDaily(dailyKey);
  if (typeof renderGoal === 'function' && $('dxq-goalBtn')) renderGoal();
  if (typeof BMK !== 'undefined') {
    saveBmk();
    if (!$('dxq-bmkPanel').hidden) renderBmkPanel();
  }
  bumpStreak();
  if ($('dxq-bookEd')) {
    bookEdList();
    $('dxq-bookSub').textContent = t.bookSrc;
    $('dxq-bookNext').innerHTML = '‹<span class="lbl"> ' + t.bookNextL + '</span>';
    $('dxq-bookNext').setAttribute('aria-label', t.bookNextL);
    $('dxq-bookPrev').innerHTML = '<span class="lbl">' + t.bookPrevL + ' </span>›';
    $('dxq-bookPrev').setAttribute('aria-label', t.bookPrevL);
  }
  $('dxq-toggle').setAttribute('aria-label', audio.paused ? t.aPlay : t.aPause);
  $('dxq-rep').setAttribute('aria-label', t.aRepeat[repeat]);
  $('dxq-speed').setAttribute('aria-label', t.aSpeed + ': ' + SPEEDS[speedIx] + 'x');
  $('dxq-minify').setAttribute('aria-label', player.classList.contains('mini') ? t.aExpand : t.aMin);
  $('dxq-aboutEn').style.display = lang === 'en' ? '' : 'none';
  $('dxq-aboutMs').style.display = lang === 'ms' ? '' : 'none';
  $('dxq-langEn').classList.toggle('on', lang === 'en');
  $('dxq-langMs').classList.toggle('on', lang === 'ms');
  $('dxq-langEn').setAttribute('aria-pressed', lang === 'en');
  $('dxq-langMs').setAttribute('aria-pressed', lang === 'ms');
  render();
  applyFilter();
  if (current >= 0) paintNow();
}

const fmt = (s) => {
  if (!isFinite(s)) return '0:00';
  s = Math.round(s);
  const h = (s / 3600) | 0, m = ((s % 3600) / 60) | 0, x = (s % 60);
  return (h ? h + ':' + String(m).padStart(2, '0') : m) + ':' + String(x).padStart(2, '0');
};

/* ---------- playlist rendering ---------- */
function cardHTML(s, i) {
  const place = s.p === 'M' ? 'Makkiyah' : 'Madaniyah';
  const tags = s.y + ' ' + I18N[lang].verses + ' · <span class="place' + (s.p === 'D' ? ' mad' : '') + '">' + place + '</span>';
  const essence = lang === 'ms' ? s.dm : s.de;
  return '<li id="surah-' + s.n + '">' +
    '<div class="card" role="button" tabindex="0" data-i="' + i + '" aria-label="' + I18N[lang].playCard + ' ' + s.t + '">' +
      '<span class="crow">' +
        '<span class="num"><i></i><u></u><b>' + s.n + '</b></span>' +
        '<span class="meta">' +
          '<span class="tname">' + s.t + '<span class="eq" aria-hidden="true"><i></i><i></i><i></i></span></span>' +
          '<span class="ename">' + meaning(s) + '</span>' +
          '<span class="tags m">' + tags + '</span>' +
        '</span>' +
        '<span class="side">' +
          '<span class="aname" lang="ar" dir="rtl">' + s.a + '</span>' +
        '</span>' +
        '<span class="card-btns">' +
        '<button type="button" class="read-btn" aria-label="' + I18N[lang].readAria + ' ' + s.t + '">' +
          '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M2 4h7a3 3 0 0 1 3 3v13a2.4 2.4 0 0 0-2.4-2.4H2z"/><path d="M22 4h-7a3 3 0 0 0-3 3v13a2.4 2.4 0 0 1 2.4-2.4H22z"/></svg>' +
        '</button>' +
        '<button type="button" class="info-btn" aria-expanded="false" aria-label="' + (lang === 'ms' ? 'Intipati surah ' : 'About Surah ') + s.t + '">' +
          '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><circle cx="12" cy="12" r="9.5"/><path d="M12 11v6"/><path d="M12 7.2v.4"/></svg>' +
        '</button>' +
        '</span>' +
      '</span>' +
      '<span class="essence">' + essence + '</span>' +
    '</div></li>';
}
function render() {
  list.innerHTML = SURAHS.map(cardHTML).join('');
  if (current >= 0) {
    document.querySelectorAll('#dxq-list .card').forEach((c) => {
      c.classList.toggle('playing', +c.dataset.i === current);
      if (+c.dataset.i === current && !audio.paused) c.classList.add('live');
    });
  }
}

list.addEventListener('click', (e) => {
  const rb = e.target.closest('.read-btn');
  if (rb) {
    const card = rb.closest('.card');
    openReader(SURAHS[+card.dataset.i]);
    return;
  }
  const btn = e.target.closest('.info-btn');
  if (btn) {
    const card = btn.closest('.card');
    const open = card.classList.toggle('open');
    btn.setAttribute('aria-expanded', open);
    return;
  }
  const c = e.target.closest('.card');
  if (c) play(+c.dataset.i);
});
list.addEventListener('keydown', (e) => {
  if (e.target.closest('.info-btn') || e.target.closest('.read-btn')) return; // native buttons
  if (e.key === 'Enter' || e.key === ' ') {
    const c = e.target.closest('.card');
    if (c) { e.preventDefault(); play(+c.dataset.i); }
  }
});

/* ---------- filtering ---------- */
const q = $('dxq-q');
let activeFilter = 'all';
const FAV = new Set([18, 36, 55, 56, 67]); // Al-Kahf, Ya-Sin, Ar-Rahman, Al-Waqi'ah, Al-Mulk
function applyFilter() {
  const needle = q.value.trim().toLowerCase();
  let shown = 0;
  document.querySelectorAll('#dxq-list .card').forEach((c) => {
    const s = SURAHS[+c.dataset.i];
    let ok = true;
    if (activeFilter === 'M' || activeFilter === 'D') ok = s.p === activeFilter;
    else if (activeFilter === 'juz30') ok = s.n >= 78;
    else if (activeFilter === 'juz') ok = !juzSet || juzSet.has(s.n);
    else if (activeFilter === 'fav') ok = FAV.has(s.n);
    if (ok && needle) {
      ok = String(s.n) === needle ||
           s.t.toLowerCase().includes(needle) ||
           s.e.toLowerCase().includes(needle) ||
           s.m.toLowerCase().includes(needle) ||
           s.t.toLowerCase().replace(/[^a-z0-9]/g, '').includes(needle.replace(/[^a-z0-9]/g, ''));
    }
    c.parentElement.style.display = ok ? '' : 'none';
    if (ok) shown++;
  });
  $('dxq-empty').style.display = shown ? 'none' : 'block';
  const st = $('dxq-searchTr');
  if (st) {
    st.style.display = (!shown && needle.length >= 3) ? '' : 'none';
    st.innerHTML = svgI('search');
    st.appendChild(document.createTextNode(' ' + I18N[lang].searchTrBtn.replace('{q}', q.value.trim())));
    $('dxq-srchRes').innerHTML = '';
  }
}
let juzSet = null;
q.addEventListener('input', applyFilter);
document.querySelectorAll('.chip[data-f]').forEach((ch) => ch.addEventListener('click', () => {
  document.querySelectorAll('.chip').forEach((x) => x.classList.remove('on'));
  ch.classList.add('on');
  activeFilter = ch.dataset.f;
  applyFilter();
}));

/* ---------- language toggle ---------- */
$('dxq-langEn').addEventListener('click', () => { lang = 'en'; try { localStorage.setItem(LS_LANG, lang); } catch (e) {} applyLang(); });
$('dxq-langMs').addEventListener('click', () => { lang = 'ms'; try { localStorage.setItem(LS_LANG, lang); } catch (e) {} applyLang(); });

/* ---------- playback ---------- */
function srcFor(s) { return 'https://server8.mp3quran.net/afs/' + String(s.n).padStart(3, '0') + '.mp3'; }

function play(i, startAt) {
  if (i < 0) i = SURAHS.length - 1;
  if (i >= SURAHS.length) i = 0;
  const s = SURAHS[i];
  current = i;
  // fresh transport UI immediately — never show the previous surah's progress
  seek.value = 0;
  seek.style.setProperty('--fill', '0%');
  $('dxq-cur').textContent = '0:00';
  $('dxq-dur').textContent = '0:00';
  $('dxq-resumeBtn').style.display = 'none';
  try { history.replaceState(history.state, '', '#surah-' + s.n); } catch (e) {}
  bumpStreak();
  audio.src = qariSrc(s);
  if (pendingJmp) { audio.removeEventListener('loadedmetadata', pendingJmp); pendingJmp = null; }
  if (startAt) {
    // seek once metadata exists — older Safari ignores earlier seeks
    pendingJmp = function jump() { audio.currentTime = startAt; };
    audio.addEventListener('loadedmetadata', pendingJmp, { once: true });
  }
  audio.playbackRate = SPEEDS[speedIx];
  player.classList.add('buffering');
  audio.play().catch(() => {});
  paintNow();
}
function paintNow() {
  const s = SURAHS[current];
  if (!s) return;
  $('dxq-npNum').textContent = s.n;
  const np = $('dxq-npName');
  np.textContent = '';
  const spfx = document.createElement('span');
  spfx.className = 'sprefix';
  spfx.textContent = 'Surah ';
  np.appendChild(spfx);
  np.appendChild(document.createTextNode(s.t));
  $('dxq-npSub').textContent = meaning(s) + ' · ' + s.y + ' ' + I18N[lang].verses;
  player.classList.add('up');
  document.querySelectorAll('#dxq-list .card').forEach((c) => {
    c.classList.toggle('playing', +c.dataset.i === current);
  });
  document.title = '▶ ' + s.t + ' — Al-Quran · Alafasy';
  if ('mediaSession' in navigator) {
    navigator.mediaSession.metadata = new MediaMetadata({
      title: 'Surah ' + s.n + ' · ' + s.t + ' (' + meaning(s) + ')',
      artist: (QARIS.find((x) => x.id === qariState.id) || { n: 'Mishary Rashid Alafasy' }).n,
      album: 'Al-Quran Al-Kareem',
    });
  }
}
function next(auto) {
  if (repeat === 2 && auto) { audio.currentTime = 0; audio.play(); return; }
  if (shuffle) {
    let r = (Math.random() * (SURAHS.length - 1)) | 0;
    if (r >= current) r++;
    play(r);
    return;
  }
  const n = current + 1;
  if (n >= SURAHS.length) {
    if (repeat === 1 || !auto) play(0);
    return;
  }
  play(n);
}
const prev = () => { audio.currentTime > 4 ? (audio.currentTime = 0) : play(current - 1); };

$('dxq-toggle').addEventListener('click', () => {
  if (current < 0) { play(0); return; }
  audio.paused ? audio.play() : audio.pause();
});
$('dxq-next').addEventListener('click', () => next(false));
$('dxq-prev').addEventListener('click', prev);
$('dxq-shuf').addEventListener('click', () => {
  shuffle = !shuffle;
  $('dxq-shuf').classList.toggle('on', shuffle);
  $('dxq-shuf').setAttribute('aria-pressed', shuffle);
});
$('dxq-rep').addEventListener('click', () => {
  repeat = (repeat + 1) % 3;
  $('dxq-rep').classList.toggle('on', repeat > 0);
  $('dxq-rep').setAttribute('aria-pressed', repeat > 0);
  $('dxq-rep').setAttribute('aria-label', I18N[lang].aRepeat[repeat]);
  $('dxq-rep1').style.display = repeat === 2 ? 'block' : 'none';
});
$('dxq-speed').addEventListener('click', () => {
  speedIx = (speedIx + 1) % SPEEDS.length;
  audio.playbackRate = SPEEDS[speedIx];
  $('dxq-speed').textContent = SPEEDS[speedIx] + '×';
  $('dxq-speed').setAttribute('aria-label', I18N[lang].aSpeed + ': ' + SPEEDS[speedIx] + 'x');
});

/* ---------- audio events ---------- */
const seek = $('dxq-seek');
let seeking = false;
audio.addEventListener('timeupdate', () => {
  if (!seeking && audio.duration) {
    seek.value = (audio.currentTime / audio.duration) * 1000;
    seek.style.setProperty('--fill', (audio.currentTime / audio.duration) * 100 + '%');
  }
  if (!seeking) {
    $('dxq-cur').textContent = fmt(audio.currentTime);
    seek.setAttribute('aria-valuetext', fmt(audio.currentTime) + ' / ' + fmt(audio.duration));
  }
});
audio.addEventListener('durationchange', () => { $('dxq-dur').textContent = fmt(audio.duration); });
audio.addEventListener('playing', () => {
  player.classList.remove('buffering');
  $('dxq-toggle').setAttribute('aria-label', I18N[lang].aPause);
  $('dxq-icoPlay').style.display = 'none'; $('dxq-icoPause').style.display = '';
  document.querySelectorAll('#dxq-list .card.playing').forEach((c) => c.classList.add('live'));
});
audio.addEventListener('waiting', () => player.classList.add('buffering'));
audio.addEventListener('pause', () => {
  $('dxq-toggle').setAttribute('aria-label', I18N[lang].aPlay);
  $('dxq-icoPlay').style.display = ''; $('dxq-icoPause').style.display = 'none';
  document.querySelectorAll('#dxq-list .card.live').forEach((c) => c.classList.remove('live'));
});
audio.addEventListener('ended', () => next(true));
audio.addEventListener('error', () => {
  player.classList.remove('buffering');
  if (!vizWired && !corsFailed && audio.getAttribute('crossorigin') && current >= 0) {
    // source refused the CORS load — retry untainted; wave stays simulated
    corsFailed = true;
    audio.removeAttribute('crossorigin');
    play(current);
    return;
  }
  if (current >= 0) $('dxq-npSub').textContent = I18N[lang].loadErr;
});
const seekTo = () => {
  if (audio.duration) audio.currentTime = (seek.value / 1000) * audio.duration;
  seek.style.setProperty('--fill', (seek.value / 10) + '%');
};
seek.addEventListener('input', () => {
  seeking = true;
  seek.style.setProperty('--fill', (seek.value / 10) + '%');
  if (audio.duration) $('dxq-cur').textContent = fmt((seek.value / 1000) * audio.duration);
});
seek.addEventListener('change', () => { seekTo(); seeking = false; });
$('dxq-vol').addEventListener('input', () => {
  audio.volume = $('dxq-vol').value / 100;
  $('dxq-vol').style.setProperty('--fill', $('dxq-vol').value + '%');
});

/* ---------- background music: this page owns the audio ----------
   If this player is embedded in a site that runs a background-music
   widget (e.g. a Shopify music app), silence it and hide its floating
   button for as long as the visitor is on the Digital Quran page.
   Apps inject late, so keep rescanning. Standalone use: finds nothing. */
function silenceBackgroundMusic() {
  // the store's background-music app (roarJs) exposes dispose() — the
  // cleanest way to remove its floating player and stop its audio
  try {
    if (window.roarJs && window.roarJs.Music && window.roarJs.Music.dispose) {
      window.roarJs.Music.dispose();
    }
  } catch (e) {}
  document.querySelectorAll('audio, video').forEach((el) => {
    if (el !== audio) {
      try { el.muted = true; el.pause(); } catch (e) {}
    }
  });
  document.querySelectorAll(
    '[id*="music" i], [class*="music-player" i], [class*="bg-music" i], [class*="bgmusic" i], [class*="roar" i]'
  ).forEach((el) => {
    if (el !== audio && !el.contains(audio)) {
      el.style.setProperty('display', 'none', 'important');
    }
  });
  // the chat bubble (Chatty/Avada) sits exactly over the player controls —
  // hide it for the duration of this page
  document.querySelectorAll(
    '#Avada-FAQ_Widget, [id*="Avada-FAQ" i], [class*="Avada-Faqs" i], [id*="chatty-widget" i]'
  ).forEach((el) => {
    el.style.setProperty('display', 'none', 'important');
  });
}
silenceBackgroundMusic();
setInterval(silenceBackgroundMusic, 1000);

/* ---------- sound-wave visualizer (control area) ----------
   Simulated speech-cadence bars: a real AnalyserNode would require routing
   the <audio> through Web Audio, which mutes cross-origin media that lacks
   CORS headers (our CDN). The envelope below mimics tarteel phrasing and
   pauses with the audio, so the bar feels alive without touching playback. */
const viz = $('dxq-viz');
const vizCtx = viz ? viz.getContext('2d') : null;
let vizRaf = 0;
/* real spectrum analyser: safe only for CORS-clean audio (same-origin files
   or a CDN sending access-control-allow-origin) — otherwise the media source
   node outputs silence, so we only wire after media loads successfully and
   fall back to the simulated wave if the graph cannot be built */
let vizAC = null, vizAnalyser = null, vizFreq = null, vizWired = false, corsFailed = false;
function wireAnalyser() {
  if (vizWired || corsFailed || !vizCtx) return;
  try {
    vizAC = new (window.AudioContext || window.webkitAudioContext)();
    const node = vizAC.createMediaElementSource(audio);
    vizAnalyser = vizAC.createAnalyser();
    vizAnalyser.fftSize = 512;
    vizAnalyser.smoothingTimeConstant = 0.75;
    node.connect(vizAnalyser);
    vizAnalyser.connect(vizAC.destination);
    vizFreq = new Uint8Array(vizAnalyser.frequencyBinCount);
    vizWired = true;
  } catch (e) { vizAnalyser = null; }
}
document.addEventListener('pointerdown', () => {
  wireAnalyser();
  if (vizAC && vizAC.state === 'suspended') vizAC.resume().catch(() => {});
}, { passive: true });
window.__quranViz = () => ({ wired: vizWired, ctx: vizAC ? vizAC.state : null, corsFailed,
  energy: vizFreq ? vizFreq.reduce((a, b) => a + b, 0) : -1 });
const VBARS = 48;
const vLevels = new Float32Array(VBARS);
function vizSize() {
  if (!viz) return;
  const dpr = Math.min(window.devicePixelRatio || 1, 2);
  viz.width = Math.max(2, Math.round(viz.clientWidth * dpr));
  viz.height = Math.round(26 * dpr);
}
function vizDraw(ts) {
  const dpr = Math.min(window.devicePixelRatio || 1, 2);
  const W2 = viz.width, H2 = viz.height, mid = H2 / 2;
  const t = ts / 1000;
  const playing = !audio.paused && !audio.ended;
  let real = false;
  if (vizAnalyser && playing && vizAC && vizAC.state === 'running') {
    vizAnalyser.getByteFrequencyData(vizFreq);
    real = true;
  }
  // fallback phrase envelope (used only when the real graph is unavailable)
  const raw = Math.sin(t * 2.1) * 0.55 + Math.sin(t * 3.7 + 1.3) * 0.3 + Math.sin(t * 0.83 + 0.4) * 0.35;
  const env = playing ? Math.max(0.08, Math.min(1, raw * 0.75 + 0.55)) : 0;
  vizCtx.clearRect(0, 0, W2, H2);
  const bw = W2 / VBARS;
  for (let i = 0; i < VBARS; i++) {
    const centerFall = 1 - Math.pow(Math.abs(i - (VBARS - 1) / 2) / (VBARS / 2), 1.6);
    let target;
    if (real) {
      // low voice frequencies at the center, higher bands toward the edges
      const d = Math.abs(i - (VBARS - 1) / 2) / (VBARS / 2);
      const bin = 1 + Math.round(d * 60);
      target = Math.pow(vizFreq[bin] / 255, 1.25) * (0.35 + 0.65 * centerFall);
    } else {
      const flutter = 0.35 + 0.65 * Math.abs(Math.sin(i * 0.53 + t * 5.2) * 0.6 + Math.sin(i * 1.31 - t * 3.4) * 0.4);
      target = env * flutter * (0.25 + 0.75 * centerFall);
    }
    vLevels[i] += (target - vLevels[i]) * (playing ? (real ? 0.5 : 0.25) : 0.12);
    const h = Math.max(1.2 * dpr, vLevels[i] * (mid - 1.5 * dpr) * 2);
    const x = i * bw + bw * 0.22;
    const w = bw * 0.56;
    const grad = vizCtx.createLinearGradient(0, mid - h / 2, 0, mid + h / 2);
    grad.addColorStop(0, 'rgba(0,200,255,0.9)');
    grad.addColorStop(0.5, 'rgba(120,210,255,1)');
    grad.addColorStop(1, 'rgba(0,90,220,0.9)');
    vizCtx.fillStyle = grad;
    if (vizCtx.roundRect) {
      vizCtx.beginPath();
      vizCtx.roundRect(x, mid - h / 2, w, h, w / 2);
      vizCtx.fill();
    } else {
      vizCtx.fillRect(x, mid - h / 2, w, h);
    }
  }
  // keep animating while audible, and while bars settle after pause
  if (playing || vLevels.some((v) => v > 0.01)) {
    vizRaf = requestAnimationFrame(vizDraw);
  } else {
    vizRaf = 0;
  }
}
function vizStart() {
  if (!vizCtx || vizRaf) return;
  vizSize();
  vizRaf = requestAnimationFrame(vizDraw);
}
if (vizCtx) {
  audio.addEventListener('playing', () => {
    if (vizAC && vizAC.state === 'suspended') vizAC.resume().catch(() => {});
    vizStart();
  });
  window.addEventListener('resize', vizSize);
  vizSize();
}

/* ---------- minimize toggle ---------- */
const LS_MINI = 'quran-player-mini';
function setMini(on) {
  player.classList.toggle('mini', on);
  $('dxq-minify').setAttribute('aria-pressed', on);
  $('dxq-minify').setAttribute('aria-label', on ? I18N[lang].aExpand : I18N[lang].aMin);
  try { localStorage.setItem(LS_MINI, on ? '1' : '0'); } catch (e) {}
  vizSize(); // canvas box changes between modes
}
$('dxq-minify').addEventListener('click', () => setMini(!player.classList.contains('mini')));
try { if (localStorage.getItem(LS_MINI) === '1') setMini(true); } catch (e) {}

/* ---------- media session ---------- */
if ('mediaSession' in navigator) {
  navigator.mediaSession.setActionHandler('play', () => audio.play());
  navigator.mediaSession.setActionHandler('pause', () => audio.pause());
  navigator.mediaSession.setActionHandler('previoustrack', prev);
  navigator.mediaSession.setActionHandler('nexttrack', () => next(false));
}

/* ---------- keyboard ---------- */
document.addEventListener('keydown', (e) => {
  if (!chatWrap.hidden || !readWrap.hidden || !$('dxq-bookWrap').hidden) return;
  if (e.target.closest && e.target.closest('input, textarea, select, button, [role="button"]')) return;
  if (e.code === 'Space') { e.preventDefault(); $('dxq-toggle').click(); }
  else if (e.key === 'ArrowRight') audio.currentTime = Math.min(audio.currentTime + 10, audio.duration || 1e9);
  else if (e.key === 'ArrowLeft') audio.currentTime = Math.max(audio.currentTime - 10, 0);
  else if (e.key === 'n') next(false);
  else if (e.key === 'p') prev();
});

/* ---------- remember position ---------- */
setInterval(() => {
  if (current >= 0 && !audio.paused) {
    try { localStorage.setItem(LS_KEY, JSON.stringify({ i: current, t: audio.currentTime })); } catch (e) {}
  }
}, 3000);
window.addEventListener('pagehide', () => {
  if (current >= 0) {
    try { localStorage.setItem(LS_KEY, JSON.stringify({ i: current, t: audio.currentTime })); } catch (e) {}
  }
});
(function initResume() {
  let saved = null;
  try { saved = JSON.parse(localStorage.getItem(LS_KEY)); } catch (e) {}
  if (saved && SURAHS[saved.i] && saved.t > 5) {
    const s = SURAHS[saved.i];
    $('dxq-resumeLabel').textContent = 'Surah ' + s.t + ' · ' + fmt(saved.t);
    $('dxq-resumeBtn').style.display = 'inline-flex';
    $('dxq-resumeBtn').addEventListener('click', () => {
      play(saved.i, saved.t);
      $('dxq-resumeBtn').style.display = 'none';
    }, { once: true });
  }
})();

/* ---------- Quran AI Chat ----------
   Deterministic chat over the quran.ai MCP server (JSON-RPC over HTTP,
   CORS-open). Every reply is canonical data fetched live from the source API —
   nothing is generated, so the answers cannot hallucinate. */
const MCP_URL = 'https://mcp.quran.ai/';
let mcpSid = null, mcpNonce = null, mcpReadyP = null, mcpId = 100;

async function mcpRaw(body, useSid) {
  const headers = { 'Content-Type': 'application/json', 'Accept': 'application/json, text/event-stream' };
  if (useSid !== false && mcpSid) headers['mcp-session-id'] = mcpSid;
  const ctrl = new AbortController();
  const t = setTimeout(() => ctrl.abort(), 30000);
  try {
    const res = await fetch(MCP_URL, { method: 'POST', headers, body: JSON.stringify(body), signal: ctrl.signal });
    const sid = res.headers.get('mcp-session-id');
    if (sid) mcpSid = sid;
    if (!res.ok) throw new Error('HTTP ' + res.status);
    const text = await res.text();
    if (!text) return null;
    if ((res.headers.get('content-type') || '').includes('event-stream')) {
      const lines = text.split('\n').filter((l) => l.startsWith('data: '));
      return lines.length ? JSON.parse(lines[lines.length - 1].slice(6)) : null;
    }
    return JSON.parse(text);
  } finally { clearTimeout(t); }
}
async function mcpTool(name, args) {
  const a = mcpNonce ? Object.assign({ grounding_nonce: mcpNonce }, args) : args;
  const r = await mcpRaw({ jsonrpc: '2.0', id: ++mcpId, method: 'tools/call', params: { name, arguments: a } });
  if (!r || r.error) throw new Error(r && r.error ? r.error.message : 'empty');
  return r.result && r.result.content && r.result.content[0] ? r.result.content[0].text : '';
}
function mcpInit() {
  if (mcpReadyP) return mcpReadyP;
  mcpReadyP = (async () => {
    const init = await mcpRaw({ jsonrpc: '2.0', id: ++mcpId, method: 'initialize',
      params: { protocolVersion: '2025-03-26', capabilities: {}, clientInfo: { name: 'digital-quran-chat', version: '1.0' } } }, false);
    if (!init || init.error) throw new Error('init failed');
    await mcpRaw({ jsonrpc: '2.0', method: 'notifications/initialized' });
    const g = await mcpTool('fetch_grounding_rules', {});
    const m = /<grounding_nonce>([^<]+)<\/grounding_nonce>/.exec(g || '');
    mcpNonce = m ? m[1] : null;
    return true;
  })();
  mcpReadyP.catch(() => { mcpReadyP = null; });
  return mcpReadyP;
}

/* ---- chat UI helpers ---- */
const chatWrap = $('dxq-chatWrap'), chatLog = $('dxq-chatLog'), chatInput = $('dxq-chatInput');
function chatMsg(kind) {
  // only follow the log if the user is already reading the newest content
  const stick = chatLog.scrollHeight - chatLog.scrollTop - chatLog.clientHeight < 90;
  const d = document.createElement('div');
  d.className = 'qmsg ' + kind;
  chatLog.appendChild(d);
  if (stick) chatLog.scrollTop = chatLog.scrollHeight;
  return d;
}
function chatSaySafe(kind, text) {
  const d = chatMsg(kind);
  d.textContent = text;
  return d;
}
const stripSup = (s) => s.replace(/<sup[^>]*>[\s\S]*?<\/sup>/gi, '').replace(/<[^>]+>/g, '').replace(/lembaga(\s+)Adam/g, (m, sp) => 'susuk tubuh' + sp + 'Adam').replace(/Lembaga(\s+)Adam/g, (m, sp) => 'Susuk tubuh' + sp + 'Adam');
/* Best-effort Malaysian-style Rumi from quran.com's English transliteration (ed 57):
   'ayn marker AA and hamza marker / -> apostrophe; reduce doubled long vowels (ee->i,
   oo->u, aa->a); split hyphenated muqatta'at (Ya-seen->Ya sin); contract the Basmalah.
   An approximation, NOT a certified JAKIM edition (no Malay Rumi exists on the source). */
const rumiFix = (s) => {
  if (!s) return s;
  const t = s.split('AA').join("'").split('Aa').join("'").split('/').join("'")
    .replace(/ee/g, 'i').replace(/oo/g, 'u').replace(/aa/g, 'a').replace(/ii/g, 'i').replace(/uu/g, 'u')
    .replace(/([A-Za-z])-([A-Za-z])/g, '$1 $2')
    .replace(/\bBismi Allahi\b/g, 'Bismillahi').replace(/\bbismi Allahi\b/g, 'bismillahi')
    .replace(/Bismillahi arrahmani/g, 'Bismillahi rrahmani').replace(/bismillahi arrahmani/g, 'bismillahi rrahmani')
    .replace(/'{2,}/g, "'").replace(/\s+/g, ' ');
  return t.trim();
};
/* Rumi source = Kemenag (Indonesia) teksLatin, a proper connected-reading Latin that becomes
   Malaysian-style Rumi once diacritics + waqf marks are stripped (e.g. "Bismillāhir-raḥmānir-
   raḥīm(i)" -> "Bismillahir-rahmanir-rahim"). Sister standard to JAKIM, far closer than the
   English academic transliteration. Fetched per surah (CORS-enabled) and cached. */
const kmnClean = (s) => {
  if (!s) return s;
  return s.normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[‘’`]/g, "'")
    .replace(/\([a-z]{1,3}\)/gi, '').replace(/\s+/g, ' ').replace(/\s*\.\s*$/, '').trim();
};
// Nudge the Kemenag (Indonesian) translation toward Malaysian spelling: surga -> syurga
// (word-part replace so surganya/surga-surga follow too), preserving the matched case.
const kmnTr = (s) => s ? s.replace(/surga/g, 'syurga').replace(/Surga/g, 'Syurga') : s;
const kmnCache = {};
const loadKmn = (n) => {
  if (kmnCache[n]) return Promise.resolve(kmnCache[n]);
  return fetch('https://equran.id/api/v2/surat/' + n).then((r) => r.json()).then((j) => {
    const map = {}, ayat = (j && j.data && j.data.ayat) || [];
    ayat.forEach((a) => { map[a.nomorAyat] = { rumi: kmnClean(a.teksLatin || ''), tr: kmnTr(a.teksIndonesia || '') }; });
    kmnCache[n] = map; return map;
  }).catch(() => ({}));
};
/* Spelling typos in quran.com's Basmeih (BM) data — all are non-words, so exact-word
   replacement is safe (verse context confirmed). e.g. "terentu"->"tertentu", "kapada"->"kepada". */
const BM_TYPO = { terentu: 'tertentu', tldak: 'tidak', lblis: 'Iblis', makluk: 'makhluk', mandapat: 'mendapat', mangerjakan: 'mengerjakan', memjadi: 'menjadi', mendaapat: 'mendapat', mengalahkah: 'mengalahkan', menyelematkan: 'menyelamatkan', meyempurnakan: 'menyempurnakan', mukjzat: 'mukjizat', nengenai: 'mengenai', sesugguhnya: 'sesungguhnya', terdahuhu: 'terdahulu', turukan: 'turunkan', kabenaran: 'kebenaran', kapada: 'kepada', bahkah: 'bahkan', barpaling: 'berpaling', berlakunnya: 'berlakunya', dibangitkan: 'dibangkitkan', dikekhendaki: 'dikehendaki', akibatya: 'akibatnya', halya: 'halnya' };
const bmFix = (s) => s ? s.replace(/[A-Za-z]+/g, (m) => { const r = BM_TYPO[m.toLowerCase()]; return r ? (/^[A-Z]/.test(m) ? r.charAt(0).toUpperCase() + r.slice(1) : r) : m; }) : s;
const OK_TAGS = { P: 1, DIV: 1, H1: 1, H2: 1, H3: 1, EM: 1, STRONG: 1, I: 1, B: 1, BR: 1, UL: 1, OL: 1, LI: 1, BLOCKQUOTE: 1, SPAN: 1 };
function sanitizeInto(target, html) {
  const doc = new DOMParser().parseFromString(html, 'text/html');
  (function walk(from, to) {
    from.childNodes.forEach((n) => {
      if (n.nodeType === 3) { to.appendChild(document.createTextNode(n.textContent)); return; }
      if (n.nodeType !== 1) return;
      if (OK_TAGS[n.tagName]) {
        const el = document.createElement(n.tagName === 'DIV' ? 'P' : n.tagName);
        to.appendChild(el);
        walk(n, el);
      } else {
        walk(n, to);
      }
    });
  })(doc.body, target);
}

/* ---- query parsing: references, surah names, topics ---- */
function chatFindSurah(text) {
  const clean = (x) => x.toLowerCase().replace(/[’ʻ'`\-–]/g, ' ').replace(/\s+/g, ' ').trim();
  const t = ' ' + clean(text) + ' ';
  // joined runs of 1-3 query tokens catch squashed spellings: yasin, alkahf, arrahman
  const toks = clean(text).split(' ');
  const joined = new Set();
  for (let i = 0; i < toks.length; i++) {
    joined.add(toks[i]);
    if (i + 1 < toks.length) joined.add(toks[i] + toks[i + 1]);
    if (i + 2 < toks.length) joined.add(toks[i] + toks[i + 1] + toks[i + 2]);
  }
  let best = null;
  const hit = (s, w) => { if (!best || w > best.w) best = { s, w }; };
  for (const s of SURAHS) {
    for (const name of [s.t, s.e, s.m]) {
      const n = clean(name);
      if (n.length < 3) continue;
      if (t.includes(' ' + n + ' ')) hit(s, n.length + 10);
      const sq = n.replace(/ /g, '');
      if (sq !== n && sq.length >= 4 && joined.has(sq)) hit(s, sq.length + 5);
      const stripped = n.replace(/^(al|an|ar|as|ash|at|az|ad|the) /, '');
      if (stripped !== n && stripped.length >= 4) {
        if (t.includes(' ' + stripped + ' ')) hit(s, stripped.length);
        const ssq = stripped.replace(/ /g, '');
        if (ssq !== stripped && joined.has(ssq)) hit(s, ssq.length);
      }
    }
  }
  return best ? best.s : null;
}
function chatParse(q) {
  const lower = q.toLowerCase();
  const intent = {
    tafsir: /tafsir|tafseer|commentary|huraian|pengajaran/.test(lower),
  };
  if (/ayat\s*(al[- ]?)?kursi|kursi/.test(lower)) return { ref: '2:255', s: SURAHS[1], intent };
  const m = lower.match(/(\d{1,3})\s*[:.]\s*(\d{1,3})(?:\s*[-–]\s*(\d{1,3}))?/);
  if (m && +m[1] >= 1 && +m[1] <= 114) {
    return { ref: m[1] + ':' + m[2] + (m[3] ? '-' + m[3] : ''), s: SURAHS[+m[1] - 1], intent };
  }
  const bare = lower.trim().match(/^(?:surah\s+)?(\d{1,3})$/);
  if (bare && +bare[1] >= 1 && +bare[1] <= 114) {
    const sb = SURAHS[+bare[1] - 1];
    return { ref: sb.n + ':1-' + Math.min(5, sb.y), s: sb, intent, intro: true };
  }
  const s = chatFindSurah(lower);
  if (s) {
    const num = lower.match(/(?:ayat|ayah|verse)?\s*(\d{1,3})(?:\s*[-–]\s*(\d{1,3}))?\s*$/);
    if (num && +num[1] >= 1 && +num[1] <= s.y) {
      return { ref: s.n + ':' + num[1] + (num[2] ? '-' + Math.min(+num[2], s.y) : ''), s, intent };
    }
    return { ref: s.n + ':1-' + Math.min(5, s.y), s, intent, intro: true };
  }
  return { search: q.trim(), intent };
}
function capRange(ref) {
  const m = ref.match(/^(\d+):(\d+)-(\d+)$/);
  if (m && +m[3] - +m[2] >= 10) return { ref: m[1] + ':' + m[2] + '-' + (+m[2] + 9), capped: true };
  return { ref, capped: false };
}

/* Verse translations follow the UI language: EN = Sahih International via
   the MCP; BM = Abdullah Basmeih via the source REST API (resource 39 — the
   MCP carries no Malay edition; both share the same canonical source). */
/* Verse translation picker — quran.com carries these 9 English editions
   (BM has only Basmeih #39, so the picker is EN-only). */
var TRANS_EDS = [
  { qid: 20, label: 'Sahih International' },
  { qid: 85, label: 'M.A.S. Abdel Haleem' },
  { qid: 19, label: 'Pickthall' },
  { qid: 22, label: 'Yusuf Ali' },
  { qid: 203, label: 'Al-Hilali & Khan' },
  { qid: 84, label: 'T. Usmani' },
  { qid: 95, label: 'A. Maududi' },
  { qid: 149, label: "Bridges' translation" }
];
var curTransQid = (function () { var v = 0; try { v = +localStorage.getItem('quran-trans'); } catch (e) {} return v || 20; })();
/* Malay/Indonesian translation choices for BM mode so users can pick. Basmeih = official
   Malaysian (JAKIM); Kemenag = Indonesian ministry, simpler & understood by Malaysians. */
var TRANS_MS = [
  { qid: '39', label: 'Basmeih · JAKIM' },
  { qid: 'kmn', label: 'Kemenag · Indonesia' }
];
var curTransMs = (function () { var v; try { v = localStorage.getItem('quran-trans-ms'); } catch (e) {} return v || '39'; })();
function initReadTrans() {
  var sel = $('readTrans'); if (!sel) return;
  var isMs = (lang === 'ms'), eds = isMs ? TRANS_MS : TRANS_EDS, cur = isMs ? String(curTransMs) : String(curTransQid);
  sel.innerHTML = '';
  eds.forEach(function (t) { var o = document.createElement('option'); o.value = t.qid; o.textContent = t.label; sel.appendChild(o); });
  sel.value = cur;
  if (!sel.__dxlBound) {
    sel.__dxlBound = 1;
    sel.addEventListener('change', function () {
      if (lang === 'ms') { curTransMs = sel.value; try { localStorage.setItem('quran-trans-ms', curTransMs); } catch (e) {} }
      else { curTransQid = +sel.value; try { localStorage.setItem('quran-trans', curTransQid); } catch (e) {} }
      refreshTranslations();
    });
  }
  sel.style.display = '';   // shown in both EN and BM (Malay choices now available)
}
async function refreshTranslations() {
  if (!readBody) return;
  var blocks = Array.prototype.slice.call(readBody.querySelectorAll('.rv[data-key]'));
  if (!blocks.length) return;
  var tok = (refreshTranslations._t = (refreshTranslations._t || 0) + 1);
  for (var i = 0; i < blocks.length; i += 10) {
    var group = blocks.slice(i, i + 10);
    var results;
    try { results = await Promise.all(group.map(function (b) { return fetchVerseTranslations(b.dataset.key); })); }
    catch (e) { continue; }
    if (tok !== refreshTranslations._t) return;
    group.forEach(function (b, gi) {
      var res = results[gi] && results[gi][0];
      var trEl = b.querySelector('.rv-tr');
      if (res && trEl) trEl.textContent = b.dataset.key.split(':')[1] + '. ' + stripSup(res.text || '');
    });
  }
}
async function fetchVerseTranslations(ref) {
  const m = ref.match(/^(\d+):(\d+)(?:-(\d+))?$/);
  if (!m) return [];
  const keys = [];
  for (let a = +m[2]; a <= (+m[3] || +m[2]); a++) keys.push(m[1] + ':' + a);
  if (lang !== 'ms') {
    const kmnEn = await loadKmn(+m[1]);   // same Rumi transliteration in EN mode
    return Promise.all(keys.map(async (k) => {
      const r = await fetch('https://api.quran.com/api/v4/verses/by_key/' + k + '?translations=' + curTransQid);
      if (!r.ok) throw new Error('source api ' + r.status);
      const trs = (((await r.json()).verse || {}).translations || []);
      return { ayah: k, text: (trs[0] || {}).text || '', rumi: (kmnEn[+k.split(':')[1]] || {}).rumi || '' };
    }));
  }
  const kmn = await loadKmn(+m[1]);   // Kemenag: {rumi (Malaysian Latin), tr (Indonesian)} per surah
  if (String(curTransMs) !== '39') {
    // Kemenag (Indonesia) translation — already in the equran.id response, no extra fetch
    return keys.map((k) => { var e = kmn[+k.split(':')[1]] || {}; return { ayah: k, text: e.tr || '', rumi: e.rumi || '' }; });
  }
  return Promise.all(keys.map(async (k) => {
    const r = await fetch('https://api.quran.com/api/v4/verses/by_key/' + k + '?translations=39');
    if (!r.ok) throw new Error('source api ' + r.status);
    const trs = (((await r.json()).verse || {}).translations || []);
    const bm = trs.find((t) => t.resource_id === 39);
    return { ayah: k, text: bm ? bmFix(bm.text) : '', rumi: (kmn[+k.split(':')[1]] || {}).rumi || '' };
  }));
}

/* No Malay Ibn Kathir exists in any canonical source, so BM mode shows an
   automatic machine translation of the English text — streamed in block by
   block, always labelled, with the canonical original one tap away. */
const mtCache = {};
const MT_PROXY = 'https://dxl-translate-933988651513.asia-southeast1.run.app/translate';
/* Quran Foundation cloud features (hadith refs) switch on automatically once
   the Cloud Run proxy holds approved client credentials */
const QF_BASE = 'https://dxl-translate-933988651513.asia-southeast1.run.app';
let qfOn = false;
fetch(QF_BASE + '/qf/status').then((r) => r.json()).then((j) => { qfOn = !!(j && j.enabled); }).catch(() => {});
/* leak check: a "translated" block must not still read as English */
function mtLooksEnglish(t) {
  const m = t.match(/\b(the|was|were|which|that|this|should|would|is|are|not|will|when|from|there)\b/gi);
  return (m ? m.length : 0) >= 4;
}
/* primary: our Cloud Run proxy in front of the official Translation API */
async function mtViaProxy(texts) {
  const r = await fetch(MT_PROXY, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ texts, target: 'ms' }),
  });
  if (!r.ok) throw new Error('mt-proxy ' + r.status);
  const j = await r.json();
  if (!j.translations || j.translations.length !== texts.length) throw new Error('mt-proxy shape');
  return j.translations;
}
/* fallback: the public endpoint (can return partial output — hence validation) */
async function mtViaPublic(text, sl, tl) {
  sl = sl || 'en'; tl = tl || 'ms';
  const sens = text.match(/[^.!?\n]+[.!?]+[\s"')\]]*|[^.!?\n]+\n?|\n/g) || [text];
  const parts = [];
  let buf = '';
  sens.forEach((sen) => {
    if (buf && (buf.length + sen.length) > 1500) { parts.push(buf); buf = sen; }
    else buf += sen;
  });
  if (buf) parts.push(buf);
  const out = [];
  for (const p of parts) {
    const r = await fetch('https://translate.googleapis.com/translate_a/single?client=gtx&sl=' + sl + '&tl=' + tl + '&dt=t&q=' + encodeURIComponent(p));
    if (!r.ok) throw new Error('mt ' + r.status);
    const j = await r.json();
    out.push((j[0] || []).map((x) => x[0]).join(''));
  }
  return out.join(' ');
}
/* translate a batch with caching + per-text validation; throws rather than
   ever returning half-English output */
async function mtTexts(texts) {
  const misses = texts.filter((t) => !(t in mtCache));
  if (misses.length) {
    let outs = null;
    try { outs = await mtViaProxy(misses); } catch (e) { outs = null; }
    for (let i = 0; i < misses.length; i++) {
      let v = outs ? outs[i] : null;
      if (!v || mtLooksEnglish(v)) {
        try { v = await mtViaPublic(misses[i]); } catch (e) { v = null; }
      }
      if (!v || mtLooksEnglish(v)) throw new Error('mt-incomplete');
      mtCache[misses[i]] = v;
    }
  }
  return texts.map((t) => mtCache[t]);
}
async function mtToMalay(text) { return (await mtTexts([text]))[0]; }
/* mark Arabic quote blocks + their parenthesised glosses for styling */
/* Ibn Kathir constantly cites other ayat inside his commentary
   ("2:255", "3:1-2", even "20: 110" with a stray space, often mid-sentence).
   Turn every real surah:ayah reference in the prose into a tidy TAPPABLE badge
   that opens that verse — so the important AYAT become the navigable anchors of
   the tafsir (no keyword colouring). Runs on the English tafsir and the BM
   machine translation; Arabic verse text and hadith matn are skipped. */
var VREF_RE = /(\d{1,3})\s*:\s*(\d{1,3})(?:\s*-\s*(\d{1,3}))?/g;
function gotoAyah(ref) {
  var m = /(\d{1,3})\s*:\s*(\d{1,3})/.exec(ref || '');
  if (!m) return;
  var sn = +m[1], vn = +m[2];
  if (sn < 1 || sn > 114 || !SURAHS[sn - 1]) return;
  openReader(SURAHS[sn - 1], vn);
}
function linkifyVerseRefs(box) {
  var wk = document.createTreeWalker(box, NodeFilter.SHOW_TEXT);
  var nodes = [], nn;
  while ((nn = wk.nextNode())) nodes.push(nn);
  nodes.forEach(function (tn) {
    var p = tn.parentElement;
    if (!p || (p.closest && p.closest('.ar, .ar-had, .taf-ref'))) return;
    var txt = tn.textContent;
    if (txt.indexOf(':') < 0) return;
    var arc = (txt.match(/[؀-ۿ]/g) || []).length;
    if (arc > txt.replace(/\s/g, '').length * 0.3) return; // Arabic-heavy node: skip
    VREF_RE.lastIndex = 0;
    if (!VREF_RE.test(txt)) return;
    VREF_RE.lastIndex = 0;
    var frag = document.createDocumentFragment(), last = 0, m, changed = false;
    while ((m = VREF_RE.exec(txt))) {
      var sn = +m[1];
      if (sn < 1 || sn > 114) continue; // not a real surah — leave as plain text
      changed = true;
      frag.appendChild(document.createTextNode(txt.slice(last, m.index)));
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'taf-ref';
      b.dataset.ref = m[1] + ':' + m[2];
      b.textContent = m[1] + ':' + m[2] + (m[3] ? '-' + m[3] : '');
      b.setAttribute('aria-label', (lang === 'ms' ? 'Buka ayat ' : 'Open verse ') + b.textContent);
      b.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); gotoAyah(this.dataset.ref); });
      frag.appendChild(b);
      last = m.index + m[0].length;
    }
    if (!changed) return;
    frag.appendChild(document.createTextNode(txt.slice(last)));
    tn.parentNode.replaceChild(frag, tn);
  });
}
function wrapHadithQuotes(box) {
  const wk = document.createTreeWalker(box, NodeFilter.SHOW_TEXT);
  const nodes = [];
  while (wk.nextNode()) nodes.push(wk.currentNode);
  nodes.forEach((tn) => {
    if (tn.parentElement && tn.parentElement.classList.contains('hadq')) return;
    const txt = tn.textContent;
    if (txt.indexOf('\u00AB') < 0) return;
    const frag = document.createDocumentFragment();
    let last = 0;
    txt.replace(/\u00AB[^\u00BB]*\u00BB?/g, (m, off) => {
      frag.appendChild(document.createTextNode(txt.slice(last, off)));
      const s = document.createElement('span');
      s.className = 'hadq';
      s.textContent = m;
      frag.appendChild(s);
      last = off + m.length;
      return m;
    });
    frag.appendChild(document.createTextNode(txt.slice(last)));
    tn.parentNode.replaceChild(frag, tn);
  });
}
/* Tanda BLOK hadis: matn Arab yang mengandungi «» dapat kotak emas
   (bukan kotak biru ayat Quran), dan terjemahan (...) selepasnya turut
   diwarnakan supaya hadis jelas berbeza dalam EN dan BM. */
function markHadithBlocks(box) {
  box.querySelectorAll('p.ar').forEach((p) => {
    if (p.textContent.indexOf('\u00AB') < 0) return;
    p.classList.add('ar-had');
    const nx = p.nextElementSibling;
    if (nx && nx.classList.contains('trn')) nx.classList.add('had-tr');
  });
}
/* Readability pass applied to every tafsir edition. */
/* Split a long paragraph into sentences for re-chunking. A naive split on every
   '.' tore abbreviations apart ("...As-Sab'a Al-Mathani (i.e. the seven verses)"
   left an orphan paragraph starting "e. the seven verses)"). This protects
   abbreviation / name-initial / decimal periods, and only breaks where a
   terminator is followed by whitespace and a real sentence-starter (a capital,
   an Arabic letter, or an opening quote/paren) — never mid-abbreviation. */
function splitSentences(t) {
  var M = String.fromCharCode(0xE000), S = String.fromCharCode(0xE001);   // period-guard + break markers
  var masked = t.replace(/[\uE000\uE001]/g, '')                                           // never let a stray marker survive round-trip
    .replace(/(\d)\.(?=\d)/g, '$1' + M)                                                   // decimals: 8.24
    .replace(/\b(i\.e|e\.g|cf|viz|vs|Mr|Mrs|Ms|Dr|Prof|St|Sr|Jr|Rev|Vol)\./gi, function (m) { return m.split('.').join(M); })
    .replace(/(^|[\s(])([A-Za-z])\.(?=\s)/g, '$1$2' + M);                                 // single-letter initials: "b." "A."
  // bounded quantifiers ({1,4}/{0,4}) keep this linear — a pathological run of
  // terminators (e.g. malformed remote tafsir) can't trigger catastrophic
  // backtracking that would freeze the reader's main thread.
  var marked = masked.replace(/([.!?؟…]{1,4}["'”’»)\]]{0,4})\s+(?=[A-ZÀ-Þ؀-ۿ"'“‘(])/g, '$1' + S);
  return marked.split(S).map(function (s) { return s.split(M).join('.').trim(); }).filter(Boolean);
}
function beautifyTafsir(box) {
  if (!box.querySelector('h1, h2, h3')) {
    Array.prototype.slice.call(box.querySelectorAll('p')).forEach(function (p) {
      if (p.classList.contains('ar') || p.classList.contains('trn') || p.classList.contains('keep')) return;
      var t = p.textContent.trim();
      var nx = p.nextElementSibling;
      if (t.length >= 3 && t.length <= 72 && !/[.!?؟،؛:»"')]$/.test(t) &&
          nx && !nx.classList.contains('ar') && nx.textContent.trim().length > 90) {
        var h = document.createElement('h3'); h.textContent = t; p.replaceWith(h);
      }
    });
  }
  Array.prototype.slice.call(box.querySelectorAll('p')).forEach(function (p) {
    if (p.classList.contains('ar') || p.classList.contains('trn') || p.classList.contains('keep') || p.classList.contains('had-src')) return;
    var t = p.textContent;
    if (t.length < 560 || t.indexOf('«') >= 0) return;   // leave short + hadith paragraphs intact
    var sents = splitSentences(t);
    if (!sents || sents.length < 2) return;   // >=560-char paragraphs with >=2 real sentences still get chunked
    var chunks = [], buf = '';
    sents.forEach(function (s) { buf += (buf ? ' ' : '') + s; if (buf.length > 300) { chunks.push(buf); buf = ''; } });
    if (buf.trim()) chunks.push(buf);
    if (chunks.length < 2) return;
    var frag = document.createDocumentFragment();
    chunks.forEach(function (c) { var np = document.createElement('p'); np.textContent = c.trim(); frag.appendChild(np); });
    p.replaceWith(frag);
  });
}
function decorateTafsir(box) {
  box.classList.add('taf');
  // some source entries mangle a heading + its first paragraph into one <h2>
  // (digitization flaw) — anything that long reads as prose, so demote it
  box.querySelectorAll('h1, h2, h3').forEach((h) => {
    if (h.textContent.length > 100) {
      const p = document.createElement('p');
      p.textContent = h.textContent;
      p.className = 'was-h';
      h.replaceWith(p);
    }
  });
  box.querySelectorAll('p').forEach((p) => {
    const t = p.textContent;
    const ar = (t.match(/[\u0600-\u06FF]/g) || []).length;
    if (ar >= 4 && ar > t.replace(/\s/g, '').length * 0.5) {
      p.classList.add('ar'); p.dir = 'rtl'; p.lang = 'ar';
    }
  });
  box.querySelectorAll('p.ar + p').forEach((p) => {
    if (/^\s*[\(（]/.test(p.textContent)) p.classList.add('trn');
  });
  beautifyTafsir(box);
  wrapHadithQuotes(box);
  markHadithBlocks(box);
  linkifyVerseRefs(box);
}
/* tidy machine-translated text: stray Arabic quote marks / orphan Arabic
   punctuation survive translation of mixed paragraphs (e.g. a dangling
   «...؟») — drop them from non-Arabic output blocks */
function msCleanup(t) {
  var MS_FIX=[["lembaga Adam","susuk tubuh Adam","p"],["sosok","tokoh","w"],["shalat","solat","w"],["sholat","solat","w"],["wudhu","wuduk","w"],["adzan","azan","w"],["dzikir","zikir","w"],["dzalim","zalim","w"],["mesjid","masjid","w"],["surga","syurga","w"],["karena","kerana","w"],["niscaya","pasti","w"],["nescaya","pasti","w"],["barangsiapa","sesiapa","w"]];
  for(var _i=0;_i<MS_FIX.length;_i++){var _g=MS_FIX[_i],_esc=_g[0].replace(/[.*+?^${}()|[\]\\]/g,"\\$&"),_w=_g[2]==="w";var _re=_w?new RegExp("\\b("+_esc+")(nya|mu|ku|lah|kah)?\\b","gi"):new RegExp(_esc,"gi");t=t.replace(_re,(function(rep,isw){return function(m,p1,p2){var cl=(isw&&typeof p2==="string")?p2:"";var o=rep+cl;return /^[A-Z]/.test(m)?o.charAt(0).toUpperCase()+o.slice(1):o;};})(_g[1],_w));}
  return t.replace(/[«»]/g, ' ')
    .replace(/(^|[^\u0600-\u06FF])[؟،؛]+/g, '$1')
    .replace(/\s+([,.;:!?])/g, '$1')
    .replace(/\s{2,}/g, ' ')
    .trim();
}
/* BM headings are sentence case, not English Title Case */
const MS_PROPER = /^(Allah|Tuhan|Dia|Nya|Engkau|Nabi|Rasulullah|Muhammad|Adam|Nuh|Idris|Ibrahim|Ismail|Ishak|Yaakub|Yusuf|Lut|Hud|Salih|Syuaib|Musa|Harun|Dawud|Daud|Sulaiman|Ayub|Zulkifli|Yunus|Ilyas|Ilyasa|Zakaria|Yahya|Isa|Jibril|Mikail|Israfil|Izrail|Iblis|Makkah|Mekah|Madinah|Quraisy|Islam|Quran|Injil|Taurat|Zabur|Kaabah|Arasy|Jahannam|Firdaus|Syurga|Neraka|Ramadan|Ibn|Abu|Bani|Ummu|Imam|Sheikh|Syeikh|Bukhari|Muslim|Tirmidzi|Nasai|Ahmad|Aisyah|Umar|Uthman|Ali|Khadijah|Fatimah|Kiamat|Akhirat|Lauh|Mahfuz)$/;
const MS_NAME_LEAD = /^(Ibn|Abu|Bani|Ummu|Imam|Sheikh|Syeikh|Nabi|bin|binti)$/i;
const MS_AL = /^(Al|An|Ar|As|Ash|At|Az|Ad)-/;
function msSentenceCase(t) {
  const words = t.split(' ');
  const coreOf = (w) => w.replace(/^["'“”‘’(\[]+|["'“”‘’)\],.:;!?]+$/g, '');
  return words.map((w, i) => {
    if (i === 0) return w;
    if (/[.!?:]["'\u201d\u2019»)]*$/.test(words[i - 1] || '')) return w; // new sentence
    const core = coreOf(w);
    if (!core) return w;
    if (/[\u0600-\u06FF]/.test(core)) return w;
    if (/^[A-Z]{2,4}$/.test(core)) return w;
    if (MS_AL.test(core)) return w;
    if (MS_PROPER.test(core)) return w;
    const prev = coreOf(words[i - 1] || '');
    if (MS_NAME_LEAD.test(prev)) return w;
    const next = coreOf(words[i + 1] || '');
    if (/^(Ayat|Surah)$/.test(core) && MS_AL.test(next)) return w;
    if (/^Hari$/.test(core) && MS_PROPER.test(next)) return w;
    return w.toLowerCase();
  }).join(' ');
}
/* translate block-by-block: headings stay headings, Arabic passes through */
async function translateTafsirBox(enBox, msBox) {
  let curList = null;
  const blocks = [];
  enBox.querySelectorAll('p, h1, h2, h3, li, blockquote').forEach((b) => {
    const txt = b.textContent.replace(/\s+/g, ' ').trim();
    if (txt) blocks.push({ tag: b.tagName, txt, ar: b.classList.contains('ar'), keep: b.classList.contains('keep'), trn: b.classList.contains('trn'), wasH: b.classList.contains('was-h'), hadSrc: b.classList.contains('had-src') });
  });
  if (!blocks.length && enBox.textContent.trim()) {
    blocks.push({ tag: 'P', txt: enBox.textContent.replace(/\s+/g, ' ').trim(), ar: false, trn: false });
  }
  // translate each block on its own (3 in flight) — joining blocks with
  // newlines is unreliable: the translator sometimes drops the separator,
  // which merged headings into the following paragraph
  for (let i = 0; i < blocks.length; i += 6) {
    const group = blocks.slice(i, i + 6);
    const enTexts = group.filter((b) => !b.ar && !b.keep).map((b) => b.txt);
    const translated = enTexts.length ? await mtTexts(enTexts) : [];
    let k = 0;
    const outs = group.map((b) => (b.ar || b.keep ? b.txt : translated[k++]));
    group.forEach((b, k) => {
      let out = (outs[k] || b.txt).trim();
      if (!b.ar && !b.keep) {
        out = msCleanup(out);
        if (/^H[1-3]$/.test(b.tag) || b.wasH) out = msSentenceCase(out);
      }
      if (!out) return;
      const el = document.createElement(b.tag);
      el.textContent = out;
      if (b.ar) { el.classList.add('ar'); el.dir = 'rtl'; el.lang = 'ar'; }
      if (b.keep) el.className = 'q-note keep' + (b.hadSrc ? ' had-src' : '');
      if (b.trn) el.classList.add('trn');
      if (b.tag === 'LI') {
        if (!curList) { curList = document.createElement('ul'); msBox.appendChild(curList); }
        curList.appendChild(el);
      } else {
        curList = null;
        msBox.appendChild(el);
      }
    });
  }
  wrapHadithQuotes(msBox);
  markHadithBlocks(msBox);
  linkifyVerseRefs(msBox);
}
/* Tafsir edition picker — every verse can be studied through multiple
   mufassirin. English editions render as-is (EN) or machine-translated (BM). */
var TAFSIR_EDS = [
  { id: 'en-ibn-kathir', label: 'Ibn Kathir' },
  { id: 'en-maarif-ul-quran', label: "Ma'arif al-Qur'an" },
  { id: 'ar-muyassar', label: 'Al-Muyassar', ar: true },
  { id: 'ar-al-wasit', label: 'Al-Wasit (Tantawi)', ar: true },
  { id: 'ar-saadi', label: "As-Sa'di", ar: true },
  { id: 'ar-baghawi', label: 'Al-Baghawi', ar: true },
  { id: 'ar-qurtubi', label: 'Al-Qurtubi', ar: true },
  { id: 'ar-tabari', label: 'Al-Tabari', ar: true }
  /* Tazkirul Quran dropped: sparse per-ayah coverage */
];
/* Arabic tafsir: translate one block via gtx (auto-detect source), cached. */
async function mtOneAuto(text, target) {
  var ck = target + '|ar|' + text;
  if (ck in mtCache) return mtCache[ck];
  var v = await mtViaPublic(text, 'auto', target);
  mtCache[ck] = v;
  return v;
}
/* Key Islamic terms machine translation renders inconsistently or strips of their
   precise meaning (tauhid->"unification", shirk->"association", taqwa->"piety"...).
   In the Arabic-source tafsir we SHIELD each from MT (token swap) and restore it as
   the standard transliteration + the Arabic on first mention, so nothing is confused. */
var TAF_BND = '[\\s،.:;()"«»\\-]';
/* [bareRoot, transliteration, arabicWithArticle, requireArticle?]
   requireArticle=true → only the definite form (الكفر) is shielded, never the
   bare form. Used for roots whose vowelless bare spelling collides with a verb
   (كفر=he disbelieved, شرك=he associated, توكل=rely) or with an unrelated word
   (ربا vs كربا=anguish) — the article makes them unambiguously nominal. */
var TAF_TERMS = [
  ['توحيد', 'tauhid', 'التوحيد'],
  ['شرك', 'syirik', 'الشرك', true],
  ['تقوى', 'taqwa', 'التقوى'],
  ['احسان', 'ihsan', 'الإحسان'],
  ['اخلاص', 'ikhlas', 'الإخلاص'],
  ['نفاق', 'nifaq', 'النفاق'],
  ['غيب', 'ghaib', 'الغيب'],
  ['فتنة', 'fitnah', 'الفتنة'],
  ['ربا', 'riba', 'الربا', true],
  ['امانة', 'amanah', 'الأمانة'],
  ['توكل', 'tawakkul', 'التوكل', true],
  ['خشوع', 'khusyuk', 'الخشوع'],
  ['رياء', 'riak', 'الرياء'],
  ['بدعة', 'bidaah', 'البدعة'],
  ['برزخ', 'barzakh', 'البرزخ'],
  ['هداية', 'hidayah', 'الهداية'],
  ['يقين', 'yaqin', 'اليقين'],
  ['زهد', 'zuhud', 'الزهد'],
  ['ايمان', 'iman', 'الإيمان'],
  ['كفر', 'kufr', 'الكفر', true]
].map(function (t) {
  // group1 = leading boundary (kept); group2 = optional proclitic و/ف/ب/ل/ك
  // (kept) — a proclitic only counts when it itself starts a word, so a root's
  // own first letter (e.g. the ك of كربا) can no longer masquerade as one. The
  // definite article is consumed but dropped (the transliteration already reads
  // as the definite noun); it is mandatory when requireArticle is set.
  var art = t[3] ? '(?:ال)' : '(?:ال)?';
  return { re: new RegExp('(^|' + TAF_BND + ')([وفبلك]?)' + art + '(?:' + t[0] + ')(?=' + TAF_BND + '|$)', 'g'), tr: t[1], ar: t[2] };
});
function tafNormAr(t) { return String(t).replace(/[ً-ْٰـ]/g, '').replace(/[أإآ]/g, 'ا'); }
function tafProtect(ar, restore) {
  var t = tafNormAr(ar);
  TAF_TERMS.forEach(function (term) {
    t = t.replace(term.re, function (m, bnd, pro) { var i = restore.length; restore.push(term); return (bnd || '') + (pro || '') + '[[K' + i + ']]'; });
  });
  return t;
}
function tafRestore(mt, restore, seen) {
  return String(mt).replace(/\[\[K(\d+)\]\]/gi, function (m, idx) {
    var t = restore[+idx]; if (!t) return '';
    if (seen[t.tr]) return t.tr;
    seen[t.tr] = 1;
    return t.tr + ' (⁨' + t.ar + '⁩)';
  });
}
/* render an Arabic-source tafsir by machine-translating every block to the
   reader language (EN or BM), appended PROGRESSIVELY so long editions
   (Tabari/Qurtubi) show text as it arrives instead of one long blank wait. */
async function renderArabicTafsir(host, entries, edLabel, token) {
  var raw = entries.map(function (e) { return e.text || ''; }).join('\n');
  var doc = new DOMParser().parseFromString(raw, 'text/html');
  // Keep quoted QURAN AYAT in Arabic (span.qpc-hafs = the Uthmani text) as cyan
  // verse boxes like the English edition; translate only the commentary — so an
  // Arabic tafsir reads bilingually (ayah + explanation), same format as en.
  var seq = [];
  var buf = '';
  function arFlush() { var t = buf.replace(/\s+/g, ' ').trim(); if (t) seq.push({ k: 't', t: t }); buf = ''; }
  (function walk(node) {
    for (var i = 0; i < node.childNodes.length; i++) {
      var n = node.childNodes[i];
      if (n.nodeType === 3) { buf += n.textContent || ''; continue; }
      if (n.nodeType !== 1) continue;
      var cls = n.className || '';
      var at = (n.textContent || '').replace(/\s+/g, ' ').trim();
      if (/qpc-hafs/.test(cls)) { if (at.length > 6) { arFlush(); seq.push({ k: 'v', t: at }); } else { buf += n.textContent || ''; } continue; }
      if (/^H[1-3]$/.test(n.tagName)) { arFlush(); if (at) seq.push({ k: 'h', tag: n.tagName, t: at }); continue; }
      if (/^(P|DIV|LI|BLOCKQUOTE)$/.test(n.tagName)) { walk(n); arFlush(); continue; }
      walk(n);
    }
  })(doc.body);
  arFlush();
  if (!seq.length) { host.textContent = I18N[lang].noTafsir; return; }
  var target = lang === 'ms' ? 'ms' : 'en';
  var note = document.createElement('div');
  note.className = 'q-note';
  note.textContent = I18N[lang].chatLoad;
  host.appendChild(note);
  var out = document.createElement('div'); out.className = 'taf';
  host.appendChild(out);
  var seen = {};
  for (var i = 0; i < seq.length; i++) {
    var it = seq[i];
    if (it.k === 'v') {
      var vp = document.createElement('p'); vp.className = 'ar'; vp.dir = 'rtl'; vp.lang = 'ar'; vp.textContent = it.t;
      out.appendChild(vp); continue;
    }
    var restore = [];
    var tr = null;
    try { tr = await mtOneAuto(tafProtect(it.t, restore), target); } catch (e) { tr = null; }
    if (token !== host.__tk) return;               // superseded by a newer edition switch
    if (!tr) continue;
    if (target === 'ms') { tr = msCleanup(tr); if (it.k === 'h') tr = msSentenceCase(tr); }
    if (!tr) continue;
    var el = document.createElement(it.k === 'h' ? it.tag : 'P');
    el.textContent = tafRestore(tr, restore, seen);
    out.appendChild(el);
  }
  beautifyTafsir(out);
  markHadithBlocks(out);
  linkifyVerseRefs(out);
  note.remove();
}
async function loadTafsir(host, ayahKey, edId, edLabel) {
  host.innerHTML = '';
  var load = document.createElement('div');
  load.className = 'q-note'; load.textContent = I18N[lang].chatLoad;
  host.appendChild(load);
  var token = (host.__tk = (host.__tk || 0) + 1);
  try {
    await mcpInit();
    if (token !== host.__tk) return;
    var raw = await mcpTool('fetch_tafsir', { ayahs: ayahKey, editions: [edId] });
    if (token !== host.__tk) return;               // a newer switch superseded this
    var entries = [];
    try { entries = (JSON.parse(raw).results || {})[edId] || []; } catch (pe) { entries = []; } // [not_found] etc. -> treated as no tafsir
    if (edId.indexOf('ar-') === 0) { host.innerHTML = ''; await renderArabicTafsir(host, entries, edLabel, token); return; }
    var enBox = document.createElement('div');
    entries.forEach(function (e) { if ((e.text || '').trim()) sanitizeInto(enBox, e.text); });
    host.innerHTML = '';
    if (!enBox.textContent.trim()) { host.textContent = I18N[lang].noTafsir; return; }
    decorateTafsir(enBox);
    host.appendChild(enBox);
    attachMalayTafsir(host, enBox, '');
  } catch (e) {
    if (token !== host.__tk) return;
    host.innerHTML = ''; host.textContent = I18N[lang].chatErr;
  }
}
function buildTafsirPicker(ayahKey) {
  var wrap = document.createElement('div');
  var bar = document.createElement('div');
  bar.className = 'taf-edbar';
  var lbl = document.createElement('span');
  lbl.className = 'taf-edlbl'; lbl.textContent = I18N[lang].tafSource;
  var sel = document.createElement('select');
  sel.className = 'taf-edsel';
  sel.setAttribute('aria-label', I18N[lang].tafSource);
  TAFSIR_EDS.forEach(function (ed) {
    var o = document.createElement('option');
    o.value = ed.id; o.textContent = ed.label; sel.appendChild(o);
  });
  bar.appendChild(lbl); bar.appendChild(sel);
  var content = document.createElement('div');
  content.className = 'taf-edcontent';
  wrap.appendChild(bar); wrap.appendChild(content);
  loadTafsir(content, ayahKey, TAFSIR_EDS[0].id, TAFSIR_EDS[0].label);
  sel.addEventListener('click', function (e) { e.stopPropagation(); });
  sel.addEventListener('change', function () {
    var ed = TAFSIR_EDS.filter(function (x) { return x.id === sel.value; })[0] || TAFSIR_EDS[0];
    loadTafsir(content, ayahKey, ed.id, ed.label);
  });
  return wrap;
}
function attachMalayTafsir(container, enBox, noteText) {
  if (lang !== 'ms' || !enBox.textContent.trim()) return;
  const bar = document.createElement('div');
  bar.className = 'q-actions';
  const chip = document.createElement('button');
  chip.type = 'button'; chip.className = 'q-chip';
  chip.disabled = true;
  chip.textContent = I18N[lang].mtLoad;
  chip.dataset.mt = '1';
  bar.appendChild(chip);
  const msBox = document.createElement('div');
  msBox.className = 'taf';
  if (noteText) {
    const head = document.createElement('div');
    head.className = 'taf-head';
    const note = document.createElement('div');
    note.className = 'q-note';
    note.textContent = noteText;
    head.appendChild(note);
    msBox.appendChild(head);
  }
  container.appendChild(msBox);
  container.appendChild(bar);
  enBox.style.display = 'none'; // BM mode: translated text is the default view
  let showingMs = true;
  translateTafsirBox(enBox, msBox).then(() => {
    chip.style.display = 'none';
  }).catch(() => {
    msBox.style.display = 'none';
    enBox.style.display = '';
    showingMs = false;
    chip.style.display = 'none';
    const err = document.createElement('div');
    err.className = 'q-note';
    err.textContent = I18N[lang].mtErr;
    container.insertBefore(err, bar);
  });
  chip.addEventListener('click', () => {
    if (chip.disabled) return;
    showingMs = !showingMs;
    msBox.style.display = showingMs ? '' : 'none';
    enBox.style.display = showingMs ? 'none' : '';
    if (showingMs) chip.textContent = I18N[lang].mtBack;
    else chip.innerHTML = svgI('globe') + ' ' + I18N[lang].mtChip;
  });
}

/* ---- reply flows ---- */
async function chatShowVerses(ref, s, intent, capped) {
  const [qRaw, trans] = await Promise.all([
    mcpTool('fetch_quran', { ayahs: ref }),
    fetchVerseTranslations(ref),
  ]);
  const qd = JSON.parse(qRaw);
  const arabic = (qd.results && qd.results['ar-simple-clean']) || [];
  const trMap = {};
  trans.forEach((x) => { trMap[x.ayah] = x.text; });
  const d = chatMsg('bot');
  const head = document.createElement('div');
  head.className = 'q-ref';
  head.textContent = (s ? 'Surah ' + s.t + ' · ' : '') + ref;
  d.appendChild(head);
  arabic.forEach((a) => {
    const ar = document.createElement('div');
    ar.className = 'q-ar';
    ar.lang = 'ar'; ar.dir = 'rtl';
    ar.textContent = a.text + ' ﴿' + a.ayah.split(':')[1] + '﴾';
    d.appendChild(ar);
    if (trMap[a.ayah]) {
      const tr = document.createElement('div');
      tr.className = 'q-tr';
      tr.textContent = stripSup(trMap[a.ayah]);
      d.appendChild(tr);
    }
  });
  if (capped) {
    const c = document.createElement('div');
    c.className = 'q-note'; c.textContent = I18N[lang].chatCap;
    d.appendChild(c);
  }
  const acts = document.createElement('div');
  acts.className = 'q-actions';
  const tb = document.createElement('button');
  tb.type = 'button'; tb.className = 'q-chip';
  tb.textContent = I18N[lang].chatTafsir;
  tb.addEventListener('click', () => { tb.disabled = true; chatTafsirFlow(ref, s); });
  acts.appendChild(tb);
  if (s) {
    const pb = document.createElement('button');
    pb.type = 'button'; pb.className = 'q-chip';
    pb.textContent = '▶ ' + I18N[lang].playCard + ' ' + s.t;
    pb.addEventListener('click', () => { requestClose(chatWrap); play(s.n - 1); });
    acts.appendChild(pb);
  }
  d.appendChild(acts);
  const note = document.createElement('div');
  note.className = 'q-note';
  note.textContent = I18N[lang].chatNote;
  d.appendChild(note);
  d.scrollIntoView({ block: 'start', behavior: 'smooth' });
  if (intent && intent.tafsir) await chatTafsirFlow(ref, s);
}
async function chatTafsirFlow(ref, s) {
  const load = chatSaySafe('bot', I18N[lang].chatLoad);
  try {
    const tRaw = await mcpTool('fetch_tafsir', { ayahs: ref.split('-')[0], editions: ['en-ibn-kathir'] });
    const td = JSON.parse(tRaw);
    const entries = (td.results && td.results['en-ibn-kathir']) || [];
    load.remove();
    const d = chatMsg('bot');
    const head = document.createElement('div');
    head.className = 'q-ref';
    head.textContent = 'Tafsir Ibn Kathir · ' + (entries[0] && entries[0].range ? entries[0].range : ref);
    d.appendChild(head);
    const enBox = document.createElement('div');
    entries.forEach((e) => {
      if ((e.text || '').trim()) sanitizeInto(enBox, e.text);
    });
    if (!enBox.textContent.trim()) {
      const p0 = document.createElement('p');
      p0.textContent = I18N[lang].noTafsir;
      d.appendChild(p0);
    } else {
      decorateTafsir(enBox);
      d.appendChild(enBox);
      attachMalayTafsir(d, enBox);
    }
    const note = document.createElement('div');
    note.className = 'q-note'; note.textContent = I18N[lang].chatNote;
    d.appendChild(note);
    d.scrollIntoView({ block: 'start', behavior: 'smooth' });
  } catch (e) {
    load.remove();
    chatSaySafe('bot err', I18N[lang].chatErr);
  }
}
async function chatSearchFlow(q) {
  const raw = await mcpTool('search_translation', { query: q, editions: 'en-sahih-international' });
  const sd = JSON.parse(raw);
  const results = (sd.results || []).slice(0, 5);
  if (!results.length) { chatSaySafe('bot', I18N[lang].chatNoRes); return; }
  let texts = results.map((r) => stripSup(r.text));
  if (lang === 'ms') {
    try {
      texts = await Promise.all(results.map(async (r) => {
        const t2 = await fetchVerseTranslations(r.ayah_key);
        return t2[0] && t2[0].text ? stripSup(t2[0].text) : stripSup(r.text);
      }));
    } catch (e) {}
  }
  const d = chatMsg('bot');
  const head = document.createElement('div');
  head.className = 'q-ref';
  head.textContent = I18N[lang].chatFound + ' “' + q + '”:';
  d.appendChild(head);
  results.forEach((r, ix) => {
    const surah = SURAHS[r.surah - 1];
    const p = document.createElement('p');
    const b = document.createElement('b');
    b.textContent = (surah ? surah.t + ' ' : '') + r.ayah_key + ' — ';
    p.appendChild(b);
    p.appendChild(document.createTextNode(texts[ix]));
    d.appendChild(p);
    const chip = document.createElement('button');
    chip.type = 'button'; chip.className = 'q-chip';
    chip.textContent = (lang === 'ms' ? 'Buka ' : 'Open ') + r.ayah_key;
    chip.addEventListener('click', () => chatAsk(r.ayah_key));
    d.appendChild(chip);
  });
  const note = document.createElement('div');
  note.className = 'q-note'; note.textContent = I18N[lang].chatNote;
  d.appendChild(note);
  d.scrollIntoView({ block: 'start', behavior: 'smooth' });
}
let chatBusy = false;
async function chatAsk(q) {
  if (chatBusy || !q.trim()) return;
  chatBusy = true;
  $('dxq-chatSend').disabled = true;
  chatSaySafe('user', q);
  const typing = chatMsg('bot');
  typing.innerHTML = '<span class="q-typing"><i></i><i></i><i></i></span>';
  try {
    await mcpInit();
    const parsed = chatParse(q);
    if (parsed.ref) {
      const { ref, capped } = capRange(parsed.ref);
      await chatShowVerses(ref, parsed.s, parsed.intent, capped);
      typing.remove();
    } else {
      typing.remove();
      const load = chatSaySafe('bot', I18N[lang].chatLoad);
      try { await chatSearchFlow(parsed.search); } finally { load.remove(); }
    }
  } catch (e) {
    typing.remove();
    chatSaySafe('bot err', I18N[lang].chatErr);
  } finally {
    chatBusy = false;
    $('dxq-chatSend').disabled = false;
  }
}

/* ---------- Surah Reader: verse-by-verse Arabic + translation + tafsir ---------- */
const readWrap = $('dxq-readWrap'), readBody = $('dxq-readBody');

/* ---- shared modal machinery: animation, scroll lock, focus, back button ---- */
let modalReturnFocus = null;
let modalScrollY = 0;
function pageWrapEl() { return $('dxq-list').closest('.wrap'); }
function openModal(wrap) {
  if (!wrap.hidden) return;
  wrap.hidden = false;
  wrap.classList.add('off');
  requestAnimationFrame(() => requestAnimationFrame(() => wrap.classList.remove('off')));
  const firstOpen = ![chatWrap, readWrap, $('dxq-bookWrap')].some((o) => o && o !== wrap && !o.hidden);
  if (firstOpen) {
    modalReturnFocus = document.activeElement; // remember focus only for the FIRST modal in a stack (else a stacked open steals it)
    /* iOS Safari: overflow:hidden alone does not pin the layout viewport —
       after the keyboard closes it can stay scrolled, which shifts every
       position:fixed layer (player, modal backdrops) up off the visual
       viewport. Pinning the body freezes the layout viewport at 0. */
    modalScrollY = window.scrollY || document.documentElement.scrollTop || 0;
    document.body.style.position = 'fixed';
    document.body.style.top = (-modalScrollY) + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
  }
  document.documentElement.style.overflow = 'hidden';
  document.body.style.overflow = 'hidden';
  const btUp = $('dxq-backTop');
  if (btUp) btUp.classList.remove('show'); // scroll restore re-evaluates on close
  const w = pageWrapEl();
  if (w) w.inert = true;
  player.inert = true;
  try { history.pushState({ dxq: wrap.id }, ''); } catch (e) {}
}
function closeModal(wrap) {
  if (wrap.hidden) return;
  if (wrap === readWrap) { try { stopKar(); closeWbw(); stopVersePlay(); hideTajTip(); } catch (e) {} }
  wrap.classList.add('off');
  setTimeout(() => { wrap.hidden = true; wrap.classList.remove('off'); }, 230);
  const otherOpen = [chatWrap, readWrap, $('dxq-bookWrap')].some((w) => w && w !== wrap && !w.hidden);
  if (!otherOpen) {
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    window.scrollTo(0, modalScrollY);
    const w = pageWrapEl();
    if (w) w.inert = false;
    player.inert = false;
    if (modalReturnFocus && modalReturnFocus.focus) { try { modalReturnFocus.focus(); } catch (e) {} }
    modalReturnFocus = null;
  }
}
function requestClose(wrap) {
  if (wrap.hidden) return;
  if (history.state && history.state.dxq === wrap.id) history.back();
  else closeModal(wrap);
}
window.addEventListener('popstate', () => {
  const bw = $('dxq-bookWrap');
  if (bw && !bw.hidden) closeModal(bw);
  else if (!readWrap.hidden) closeModal(readWrap);
  else if (!chatWrap.hidden) closeModal(chatWrap);
});
let backdropDown = false;
[readWrap, chatWrap, $('dxq-bookWrap')].forEach((wrap) => {
  wrap.addEventListener('pointerdown', (e) => { backdropDown = e.target === wrap; });
});
/* iOS: after the keyboard dismisses, Safari can leave the layout viewport
   offset — re-assert the scroll position to re-anchor fixed layers. */
if (/iP(hone|ad|od)/.test(navigator.userAgent) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) {
  document.addEventListener('focusout', () => {
    setTimeout(() => {
      const ae = document.activeElement;
      if (!ae || !ae.closest || !ae.closest('input, textarea, select')) {
        window.scrollTo(window.scrollX, window.scrollY);
      }
    }, 80);
  });
}
const RD_BATCH = 10;
let rd = null;

function openReader(s, fromVerse) {
  rd = { s, next: Math.max(1, Math.min(fromVerse || 1, s.y)), busy: false };
  const rTtl = $('dxq-readTitle');
  rTtl.textContent = s.n + '. ' + s.t;
  const rAr = document.createElement('span');
  rAr.className = 'ttl-ar';
  rAr.textContent = ' — ' + s.a;
  rTtl.appendChild(rAr);
  $('dxq-readSub').textContent = meaning(s) + ' · ' + s.y + ' ' + I18N[lang].verses;
  $('dxq-readPlay').innerHTML = '▶<span class="lbl"> ' + I18N[lang].aPlay + '</span>';
  $('dxq-readMore').textContent = I18N[lang].readMore;
  readBody.innerHTML = '';
  if (rd.next === 1 && s.n !== 1 && s.n !== 9) {
    const b = document.createElement('div');
    b.className = 'qread-bismillah';
    b.lang = 'ar'; b.dir = 'rtl';
    b.textContent = 'بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ';
    readBody.appendChild(b);
  }
  updateReadFoot();
  const pv = SURAHS[s.n - 2], nx = SURAHS[s.n];
  $('dxq-readPrev').textContent = pv ? '‹ ' + pv.t : '';
  $('dxq-readNext').textContent = nx ? nx.t + ' ›' : '';
  $('dxq-readPrev').style.visibility = pv ? '' : 'hidden';
  $('dxq-readNext').style.visibility = nx ? '' : 'hidden';
  readBody.scrollTop = 0;
  stopKar();
  taj.on = false;
  $('dxq-readTaj').classList.remove('mode-on');
  $('dxq-readTaj').setAttribute('aria-pressed', 'false');
  $('dxq-readKar').classList.remove('mode-on');
  info.openFor = 0;
  openModal(readWrap);
  setTimeout(() => { try { $('dxq-readClose').focus(); } catch (e) {} }, 90);
  try { history.replaceState(history.state, '', '#surah-' + s.n); } catch (e) {}
  initReadTrans();
  readBatch();
}
/* Quran.Foundation answers are markdown — convert emphasis + paragraphs so
   they render (and machine-translate) cleanly. */
function mdToHtml(s) {
  var esc = String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  esc = esc.replace(/\*\*([^*\n]+)\*\*/g, '<strong>$1</strong>').replace(/\*([^*\n]+)\*/g, '<em>$1</em>');
  return esc.split(/\n{2,}/).map(function (p) { return '<p>' + p.replace(/\n/g, '<br>') + '</p>'; }).join('');
}
/* QF hadith bodies embed sunnah.com shortcodes like [quran sura="1" ...]{ ayah }
   which are not HTML — unwrap them to the inner text and drop any stray tags. */
function cleanHadithBody(html) {
  return String(html)
    .replace(/\[quran[^\]]*\]\s*\{([^}]*)\}/gi, '$1')
    .replace(/\[\/?[a-z][^\]]*\]/gi, '');
}
/* Per-verse 'Soalan' button on EVERY verse: where Quran.Foundation has curated
   scholarly Q&A (sparse) it expands inline; otherwise it opens the Quran AI Chat
   asking about that ayah — so all 114 surahs have a working question button. */
function askVerseInChat(ayah) {
  var q = (lang === 'ms')
    ? 'Apa maksud dan pengajaran ayat ' + ayah + '?'
    : 'What is the meaning and tafsir of verse ' + ayah + '?';
  chatOpen();                                  // open chat first (keeps the body-scroll pin)
  try { if (!readWrap.hidden) closeModal(readWrap); } catch (e) {}
  chatAsk(q);
}
function addAnswersChip(block, acts, ayah, anchor) {
  var achip = document.createElement('button');
  achip.type = 'button'; achip.className = 'q-chip';
  achip.textContent = I18N[lang].answersChip;
  var abody = document.createElement('div'); abody.className = 'rv-tafsir-body taf'; abody.hidden = true;
  var built = false;
  /* curated Q&A is sparse — pre-fetch; resolves to [] when none / QF off / error */
  var qfPromise = qfOn
    ? fetch(QF_BASE + '/qf/answers/' + ayah).then(function (r) { return r.json(); })
        .then(function (j) { return (j && j.questions) || []; }).catch(function () { return []; })
    : Promise.resolve([]);
  achip.addEventListener('click', function () {
    qfPromise.then(function (qs) {
      if (!qs.length) { askVerseInChat(ayah); return; }   // no curated -> AI chat (full coverage)
      if (!abody.hidden) { abody.hidden = true; return; }
      if (!built) {
        var aEn = document.createElement('div');
        qs.forEach(function (q, qi) {
          if (q && q.body) {
            var qh = document.createElement('h3');
            qh.textContent = (qs.length > 1 ? (qi + 1) + '. ' : '') + String(q.body).replace(/\*+/g, '');
            aEn.appendChild(qh);
          }
          (q && q.answers || []).forEach(function (ans) { if (ans && ans.body) sanitizeInto(aEn, mdToHtml(ans.body)); });
        });
        if (aEn.childNodes.length) {
          decorateTafsir(aEn); abody.appendChild(aEn);
          attachMalayTafsir(abody, aEn, I18N[lang].mtNoteAnswers);
        } else { abody.textContent = I18N[lang].answersNone; }
        built = true;
      }
      abody.hidden = false;
    });
  });
  if (anchor && anchor.parentNode === acts) acts.insertBefore(achip, anchor); else acts.appendChild(achip);
  block.appendChild(abody);
}
function updateReadFoot() {
  const done = Math.min(rd.next - 1, rd.s.y);
  $('dxq-readProg').textContent = done + ' / ' + rd.s.y;
  $('dxq-readMore').style.display = rd.next > rd.s.y ? 'none' : '';
}
async function readBatch() {
  if (!rd || rd.busy || rd.next > rd.s.y) return;
  rd.busy = true;
  const from = rd.next, to = Math.min(from + RD_BATCH - 1, rd.s.y);
  const ref = rd.s.n + ':' + from + (to > from ? '-' + to : '');
  readBody.querySelectorAll('.q-note.err').forEach((n) => n.remove());
  const load = document.createElement('div');
  load.className = 'q-note';
  load.textContent = I18N[lang].chatLoad;
  readBody.appendChild(load);
  try {
    await mcpInit();
    const [qRaw, trs] = await Promise.all([
      mcpTool('fetch_quran', { ayahs: ref }),
      fetchVerseTranslations(ref),
    ]);
    load.remove();
    const arabic = (JSON.parse(qRaw).results || {})['ar-simple-clean'] || [];
    const trMap = {}, rumiMap = {};
    trs.forEach((x) => { trMap[x.ayah] = x.text; if (x.rumi) rumiMap[x.ayah] = x.rumi; });
    arabic.forEach((a) => {
      const n = a.ayah.split(':')[1];
      const block = document.createElement('div');
      block.className = 'rv';
      const ar = document.createElement('div');
      ar.className = 'rv-ar'; ar.lang = 'ar'; ar.dir = 'rtl';
      ar.textContent = a.text + ' ';
      const nn = document.createElement('span');
      nn.className = 'rv-n'; nn.textContent = '﴿' + n + '﴾';
      ar.appendChild(nn);
      block.appendChild(ar);
      if (rumiMap[a.ayah]) {
        const rm = document.createElement('div');
        rm.className = 'rv-rumi';
        rm.lang = 'ms';
        rm.textContent = stripSup(rumiMap[a.ayah]);
        block.appendChild(rm);
      }
      if (trMap[a.ayah]) {
        const tr = document.createElement('div');
        tr.className = 'rv-tr';
        tr.textContent = n + '. ' + stripSup(trMap[a.ayah]);
        block.appendChild(tr);
      }
      if (SAJDAH.has(a.ayah)) {
        const sj = document.createElement('span');
        sj.className = 'sajdah-chip';
        sj.textContent = '۩ ' + I18N[lang].sajdah;
        block.appendChild(sj);
      }
      const tchip = document.createElement('button');
      tchip.type = 'button'; tchip.className = 'q-chip';
      tchip.textContent = I18N[lang].readTafsir + ' · ' + a.ayah;
      const tbody = document.createElement('div');
      tbody.className = 'rv-tafsir-body';
      tbody.hidden = true;
      tchip.addEventListener('click', () => {
        if (!tbody.hidden) { tbody.hidden = true; return; }
        if (!tbody.childNodes.length) tbody.appendChild(buildTafsirPicker(a.ayah));
        tbody.hidden = false;
      });
      const bmk = document.createElement('button');
      bmk.type = 'button';
      bmk.className = 'q-chip bmk' + (BMK.has(a.ayah) ? ' on' : '');
      bmk.innerHTML = svgI('bookmark', 13);
      bmk.setAttribute('aria-label', I18N[lang].bmkAdd);
      bmk.addEventListener('click', () => {
        if (BMK.has(a.ayah)) BMK.delete(a.ayah); else BMK.add(a.ayah);
        bmk.classList.toggle('on', BMK.has(a.ayah));
        saveBmk();
        if (!$('dxq-bmkPanel').hidden) renderBmkPanel();
      });
      block.dataset.key = a.ayah;
      ar.dataset.key = a.ayah;
      let hchip = null, hbody = null;
      {
        // Hadis chip — shown ONLY on verses that actually have linked hadith. A one-time
        // pre-fetch caches the hadith (hItems); the chip + panel are inserted only when
        // some exist, and the click renders from the cache (no re-fetch, no empty button).
        hchip = document.createElement('button');
        hchip.type = 'button';
        hchip.className = 'q-chip';
        hchip.textContent = I18N[lang].hadithChip;
        hbody = document.createElement('div');
        hbody.className = 'rv-tafsir-body taf had-panel';
        hbody.hidden = true;
        let hItems = null;
        hchip.addEventListener('click', () => {
          if (!hbody.hidden) { hbody.hidden = true; return; }
          if (!hbody.childNodes.length && hItems && hItems.length) {
            const hEn = document.createElement('div');
            hItems.forEach((it, hi) => {
              const en = (it.hadith || []).find((h) => h.lang === 'en');
              const arh = (it.hadith || []).find((h) => h.lang === 'ar');
              const collName = it.collection === 'bukhari' ? 'Sahih al-Bukhari'
                             : it.collection === 'muslim' ? 'Sahih Muslim'
                             : (it.collection ? 'Sahih ' + it.collection.charAt(0).toUpperCase() + it.collection.slice(1) : '');
              const grade = (((en && en.grades) || (arh && arh.grades) || []).map((g) => g && g.grade).filter(Boolean))[0];
              const meta = [
                (hItems.length > 1 ? (hi + 1) + '.' : ''),
                collName,
                it.hadithNumber ? 'No. ' + it.hadithNumber : '',
                grade || '',
              ].filter(Boolean).join(' · ');
              if (meta) {
                const s2 = document.createElement('p');
                s2.className = 'q-note keep had-src';
                s2.textContent = meta;
                hEn.appendChild(s2);
              }
              // authentic Arabic matn first (gold via .had-panel), then the translation
              if (arh && arh.body) sanitizeInto(hEn, cleanHadithBody(arh.body));
              if (en && en.body) sanitizeInto(hEn, cleanHadithBody(en.body));
            });
            if (hEn.childNodes.length) {
              decorateTafsir(hEn);
              hbody.appendChild(hEn);
              attachMalayTafsir(hbody, hEn, I18N[lang].mtNoteHadith);
            }
          }
          hbody.hidden = false;
        });
        // pre-check: only reveal the chip + cache the hadith when this verse has any
        fetch(QF_BASE + '/qf/hadith/' + a.ayah).then((r) => r.json()).then((j) => {
          const items = (j && j.hadiths) || [];
          if (!items.length) return;
          hItems = items;
          acts.insertBefore(hchip, hkchip);
          block.insertBefore(hbody, hkbody); // keep panel order matching the chip order (Hadis before Hukum)
        }).catch(() => {});
      }
      const vplay = document.createElement('button');
      vplay.type = 'button';
      vplay.className = 'q-chip vplay';
      vplay.innerHTML = svgI('play');
      vplay.setAttribute('aria-label', I18N[lang].playAyah + ' ' + a.ayah);
      vplay.addEventListener('click', () => playVerse(a.ayah, vplay));
      /* panel Hukum: senarai semua hukum tajweed dalam ayat ini — interaksi
         butang standard, tiada kebergantungan pada tooltip hover/tap */
      const hkchip = document.createElement('button');
      hkchip.type = 'button';
      hkchip.className = 'q-chip';
      hkchip.innerHTML = svgI('palette') + ' ' + I18N[lang].hukumChip;
      const hkbody = document.createElement('div');
      hkbody.className = 'rv-tafsir-body';
      hkbody.hidden = true;
      hkchip.addEventListener('click', async () => {
        if (!hkbody.hidden) { hkbody.hidden = true; return; }
        if (!taj.on) $('dxq-readTaj').click(); // colour-code the verses + auto-activate the top tajweed toggle
        if (!hkbody.childNodes.length) {
          hkchip.disabled = true;
          const oldHtml = hkchip.innerHTML;
          hkchip.textContent = I18N[lang].chatLoad;
          try {
            const map = await tajData(rd.s.n);
            const scratch = document.createElement('div');
            tajRender(scratch, map[a.ayah] || '');
            const found = TAJ_RULES.filter((pr) => scratch.querySelector('.tj-' + pr[0]));
            if (!found.length) {
              hkbody.textContent = I18N[lang].hukumNone;
            } else {
              found.forEach((pr) => {
                const row = document.createElement('p');
                const b2 = document.createElement('b');
                b2.className = 'tj-' + pr[0];
                b2.style.display = 'block';
                b2.textContent = pr[1];
                const d2 = document.createElement('span');
                d2.textContent = (I18N[lang].tajDesc || {})[pr[0]] || '';
                row.appendChild(b2);
                row.appendChild(d2);
                hkbody.appendChild(row);
              });
            }
          } catch (e) {
            hkbody.textContent = I18N[lang].chatErr;
          }
          hkchip.disabled = false;
          hkchip.innerHTML = oldHtml;
        }
        hkbody.hidden = false;
      });
      const acts = document.createElement('div');
      acts.className = 'rv-acts';
      acts.appendChild(tchip);
      acts.appendChild(hkchip);
      acts.appendChild(vplay);
      acts.appendChild(bmk);
      block.appendChild(acts);
      block.appendChild(tbody);
      block.appendChild(hkbody);
      readBody.appendChild(block);
    });
    bumpGoal(arabic.length);
    rd.next = to + 1;
    readModesApply();
    if (rd.next > rd.s.y) {
      const end = document.createElement('div');
      end.className = 'q-note';
      end.style.textAlign = 'center';
      end.style.padding = '14px 0';
      end.textContent = I18N[lang].readEnd;
      readBody.appendChild(end);
    }
    updateReadFoot();
  } catch (e) {
    load.textContent = I18N[lang].chatErr + ' ↻';
    load.classList.add('qmsg', 'err');
    load.style.cursor = 'pointer';
    load.addEventListener('click', readBatch, { once: true });
  } finally {
    rd.busy = false;
  }
}
$('dxq-readMore').addEventListener('click', readBatch);
readBody.addEventListener('scroll', () => {
  try { closeWbw(); } catch (e) {}
  if (rd && !rd.busy && rd.next <= rd.s.y &&
      readBody.scrollTop + readBody.clientHeight > readBody.scrollHeight - 500) {
    readBatch();
  }
});
$('dxq-readClose').addEventListener('click', () => { requestClose(readWrap); });
readWrap.addEventListener('click', (e) => { if (e.target === readWrap && backdropDown) requestClose(readWrap); });
document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !readWrap.hidden) requestClose(readWrap); });
$('dxq-readPlay').addEventListener('click', () => {
  if (rd) { requestClose(readWrap); play(rd.s.n - 1); }
});
$('dxq-readPrev').addEventListener('click', () => {
  if (rd && SURAHS[rd.s.n - 2]) openReader(SURAHS[rd.s.n - 2]);
});
$('dxq-readNext').addEventListener('click', () => {
  if (rd && SURAHS[rd.s.n]) openReader(SURAHS[rd.s.n]);
});

/* ---- open/close + quick chips ---- */
function chatQuickChips() {
  const q = $('dxq-chatQuick');
  q.innerHTML = '';
  const chips = lang === 'ms'
    ? ['Ayat Kursi', 'Al-Kahf 1-5', 'tafsir Al-Ikhlas', 'sabar menghadapi ujian']
    : ['Ayat Kursi', 'Al-Kahf 1-5', 'tafsir Al-Ikhlas', 'patience in hardship'];
  chips.forEach((c) => {
    const b = document.createElement('button');
    b.type = 'button'; b.className = 'q-chip'; b.textContent = c;
    b.addEventListener('click', () => chatAsk(c));
    q.appendChild(b);
  });
}
let chatOpenedOnce = false;
function chatOpen() {
  openModal(chatWrap);
  chatQuickChips();
  $('dxq-chatInput').placeholder = I18N[lang].chatPh;
  if (!chatOpenedOnce) {
    chatOpenedOnce = true;
    chatSaySafe('bot', I18N[lang].chatHi);
    mcpInit().catch(() => {});
  }
  // on touch the OS keyboard would cover the welcome + suggestion chips
  if (matchMedia('(hover:hover) and (pointer:fine)').matches) chatInput.focus();
}
$('dxq-chatOpen1').addEventListener('click', chatOpen);
$('dxq-chatClose').addEventListener('click', () => { requestClose(chatWrap); });
chatWrap.addEventListener('click', (e) => { if (e.target === chatWrap && backdropDown) requestClose(chatWrap); });
document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !chatWrap.hidden) requestClose(chatWrap); });
$('dxq-chatForm').addEventListener('submit', (e) => {
  e.preventDefault();
  if (chatBusy) return; // keep the typed text until the current answer finishes
  const v = chatInput.value;
  chatInput.value = '';
  chatAsk(v);
});

/* ---------- Mushaf PDF flipbook ----------
   Editions from pdfquran.com (King Fahd Complex mushaf, "no rights reserved";
   the site invites downloading and sharing) mirrored on the project's GCS
   bucket so the browser can range-stream them. Default: Big Edition. */
const bookWrap = $('dxq-bookWrap');
const BOOK_BASE = (location.hostname === '127.0.0.1')
  ? '' : 'https://storage.googleapis.com/digital-x-quran-pdf/';
const BOOK_EDS = [
  { f: 'big-quran.pdf', en: 'Holy Quran — Big Edition (Arabic)', ms: 'Mushaf Besar (Arab)' },
  { f: 'standard1-quran.pdf', en: 'Standard Edition 1 (Arabic)', ms: 'Mushaf Standard 1 (Arab)' },
  { f: 'standard2-quran.pdf', en: 'Standard Edition 2 (Arabic)', ms: 'Mushaf Standard 2 (Arab)' },
  { f: 'english-quran.pdf', en: 'With English translation', ms: 'Terjemahan Inggeris' },
  { f: 'indonesian-quran.pdf', en: 'With Indonesian translation', ms: 'Terjemahan Indonesia' },
  { f: 'chinese-quran.pdf', en: 'With Chinese translation', ms: 'Terjemahan Cina' },
  { f: 'french-quran.pdf', en: 'With French translation', ms: 'Terjemahan Perancis' },
  { f: 'turkish-quran.pdf', en: 'With Turkish translation', ms: 'Terjemahan Turki' },
  { f: 'urdu-quran.pdf', en: 'With Urdu translation', ms: 'Terjemahan Urdu' },
  { f: 'tamil-quran.pdf', en: 'With Tamil translation', ms: 'Terjemahan Tamil' },
  { f: 'telugu-quran.pdf', en: 'With Telugu translation', ms: 'Terjemahan Telugu' },
  { f: 'portuguese-quran.pdf', en: 'With Portuguese translation', ms: 'Terjemahan Portugis' },
  { f: 'hausa-quran.pdf', en: 'With Hausa translation', ms: 'Terjemahan Hausa' },
  { f: 'vietnami-quran.pdf', en: 'With Vietnamese translation', ms: 'Terjemahan Vietnam' },
  { f: 'anko-quran.pdf', en: "With N'ko translation", ms: "Terjemahan N'ko" },
];
async function fetchPdfData(url, note, token) {
  let cache = null;
  try {
    cache = await caches.open('dxq-mushaf-v1');
    const hit = await cache.match(url);
    if (hit) return new Uint8Array(await hit.arrayBuffer());
  } catch (e) { cache = null; }
  const r = await fetch(url);
  if (!r.ok || !r.body) throw new Error('pdf ' + r.status);
  const total = +r.headers.get('content-length') || 0;
  const reader = r.body.getReader();
  const chunks = [];
  let got = 0;
  for (;;) {
    const { done, value } = await reader.read();
    if (done) break;
    chunks.push(value);
    got += value.length;
    if (token === bk.token && total) {
      note.textContent = I18N[lang].bookLoad + ' ' + Math.min(99, Math.round((got / total) * 100)) + '%';
    }
  }
  const buf = new Uint8Array(got);
  let off = 0;
  chunks.forEach((c) => { buf.set(c, off); off += c.length; });
  chunks.length = 0;
  if (cache) {
    // Response() copies the bytes, so pdf.js can safely transfer `buf` later
    try { await cache.put(url, new Response(buf, { headers: { 'Content-Type': 'application/pdf' } })); } catch (e) {}
  }
  return buf;
}
let pdfjsReady = null;
function loadPdfJs() {
  if (pdfjsReady) return pdfjsReady;
  pdfjsReady = new Promise((res, rej) => {
    const s = document.createElement('script');
    s.src = 'https://cdn.jsdelivr.net/npm/pdfjs-dist@3.11.174/build/pdf.min.js';
    s.onload = async () => {
      try {
        const wjs = await fetch('https://cdn.jsdelivr.net/npm/pdfjs-dist@3.11.174/build/pdf.worker.min.js').then((r) => r.text());
        window.pdfjsLib.GlobalWorkerOptions.workerSrc =
          URL.createObjectURL(new Blob([wjs], { type: 'text/javascript' }));
      } catch (e) {
        window.pdfjsLib.GlobalWorkerOptions.workerSrc =
          'https://cdn.jsdelivr.net/npm/pdfjs-dist@3.11.174/build/pdf.worker.min.js';
      }
      res(window.pdfjsLib);
    };
    s.onerror = () => { pdfjsReady = null; rej(new Error('pdfjs')); };
    document.head.appendChild(s);
  });
  return pdfjsReady;
}
const LS_BOOK = 'quran-book-v1';
const bk = { pdf: null, ed: 0, page: 1, total: 0, busy: false, token: 0, cache: new Map() };
try {
  const sv = JSON.parse(localStorage.getItem(LS_BOOK));
  if (sv && BOOK_EDS[sv.ed]) bk.ed = sv.ed;
} catch (e) {}
function bookSingle() { return matchMedia('(max-width:720px)').matches; }
function bookEdList() {
  const sel = $('dxq-bookEd');
  sel.innerHTML = '';
  BOOK_EDS.forEach((e, i) => {
    const o = document.createElement('option');
    o.value = i;
    o.textContent = e[lang] || e.en;
    sel.appendChild(o);
  });
  sel.value = bk.ed;
}
async function renderBookPage(n) {
  if (bk.cache.has(n)) return bk.cache.get(n);
  const tok = bk.token;
  const page = await bk.pdf.getPage(n);
  const stage = $('dxq-bookStage');
  const vp1 = page.getViewport({ scale: 1 });
  const maxH = stage.clientHeight * 0.96;
  const maxW = stage.clientWidth * (bookSingle() ? 0.96 : 0.47);
  const mult = Math.min(window.devicePixelRatio || 1, 2);
  const fit = Math.min(maxH / vp1.height, maxW / vp1.width);
  const vp = page.getViewport({ scale: fit * mult });
  const c = document.createElement('canvas');
  c.width = vp.width;
  c.height = vp.height;
  c.style.width = Math.round(vp.width / mult) + 'px';
  c.style.height = Math.round(vp.height / mult) + 'px';
  await page.render({ canvasContext: c.getContext('2d'), viewport: vp }).promise;
  if (tok !== bk.token) return c; // edition changed mid-render — don't poison the cache
  bk.cache.set(n, c);
  if (bk.cache.size > 12) bk.cache.delete(bk.cache.keys().next().value);
  return c;
}
function bookPairFor(p) {
  const k = Math.floor((p - 1) / 2);
  return [2 * k + 1, 2 * k + 2];
}
async function drawBookSpread() {
  const tok = bk.token;
  const stage = $('dxq-bookStage');
  let pages;
  if (bookSingle()) pages = [bk.page];
  else {
    const pr = bookPairFor(bk.page);
    pages = pr[1] <= bk.total ? pr : [pr[0]];
  }
  const cans = await Promise.all(pages.map(renderBookPage));
  if (tok !== bk.token) return;
  stage.querySelectorAll('.book-spread, .book-sheet').forEach((x) => x.remove());
  const sp = document.createElement('div');
  sp.className = 'book-spread';
  if (pages.length === 1) {
    const lf = document.createElement('div');
    lf.className = 'leaf single';
    lf.appendChild(cans[0]);
    sp.appendChild(lf);
  } else {
    // RTL mushaf: the lower page number sits on the RIGHT leaf
    const lfL = document.createElement('div');
    lfL.className = 'leaf left';
    lfL.appendChild(cans[1]);
    const lfR = document.createElement('div');
    lfR.className = 'leaf right';
    lfR.appendChild(cans[0]);
    sp.appendChild(lfL);
    sp.appendChild(lfR);
  }
  stage.appendChild(sp);
  $('dxq-bookPage').value = bookSingle() ? bk.page : bookPairFor(bk.page)[0];
  $('dxq-bookTotal').textContent = bk.total || '–';
  try {
    const sv = JSON.parse(localStorage.getItem(LS_BOOK) || '{}') || {};
    const pages = sv.pages || {};
    pages[bk.ed] = bk.page;
    localStorage.setItem(LS_BOOK, JSON.stringify({ ed: bk.ed, pages }));
  } catch (e) {}
  setTimeout(() => {
    pages.forEach((p) => [p + 2, p - 2, p + 1].forEach((q) => {
      if (q >= 1 && q <= bk.total && !bk.cache.has(q)) renderBookPage(q).catch(() => {});
    }));
  }, 80);
}
let sndCtx = null;
function flipSound() {
  try {
    sndCtx = sndCtx || new (window.AudioContext || window.webkitAudioContext)();
    if (sndCtx.state === 'suspended') sndCtx.resume();
    const dur = 0.22;
    const buf = sndCtx.createBuffer(1, (sndCtx.sampleRate * dur) | 0, sndCtx.sampleRate);
    const d = buf.getChannelData(0);
    for (let i = 0; i < d.length; i++) {
      const t = i / d.length;
      d[i] = (Math.random() * 2 - 1) * Math.pow(1 - t, 2.4) * (0.35 + 0.65 * Math.sin(t * 8));
    }
    const s0 = sndCtx.createBufferSource();
    s0.buffer = buf;
    const bp = sndCtx.createBiquadFilter();
    bp.type = 'bandpass';
    bp.frequency.setValueAtTime(850, sndCtx.currentTime);
    bp.frequency.exponentialRampToValueAtTime(2600, sndCtx.currentTime + dur * 0.7);
    bp.Q.value = 0.8;
    const g = sndCtx.createGain();
    g.gain.value = 0.2;
    s0.connect(bp);
    bp.connect(g);
    g.connect(sndCtx.destination);
    s0.start();
  } catch (e) {}
}
async function bookTurn(dir, target) {
  const stage = $('dxq-bookStage');
  const sp = stage.querySelector('.book-spread');
  flipSound();
  if (!sp || bookSingle()) {
    // mobile: quick tilt-slide of the single page
    const lf = sp && sp.querySelector('.leaf.single');
    if (lf) {
      lf.style.transition = 'transform .22s ease, opacity .22s ease';
      lf.style.transformOrigin = dir === 'next' ? '0% 50%' : '100% 50%';
      lf.style.transform = 'rotateY(' + (dir === 'next' ? '-' : '') + '26deg) translateX(' + (dir === 'next' ? '-' : '') + '34px)';
      lf.style.opacity = '0.3';
      await new Promise((r) => setTimeout(r, 200));
    }
    return;
  }
  const [newR, newL] = bookPairFor(target);
  const leaves = sp.querySelectorAll('.leaf');
  if (leaves.length < 2) return;
  const lfL = leaves[0], lfR = leaves[1];
  try {
    const frontCanvas = dir === 'next' ? lfL.querySelector('canvas') : lfR.querySelector('canvas');
    const backCanvas = await renderBookPage(dir === 'next' ? newR : (newL <= bk.total ? newL : newR));
    const underCanvas = await renderBookPage(dir === 'next' ? (newL <= bk.total ? newL : newR) : newR);
    const sheet = document.createElement('div');
    sheet.className = 'book-sheet';
    const w = (dir === 'next' ? lfL : lfR).getBoundingClientRect();
    const st = stage.getBoundingClientRect();
    sheet.style.width = w.width + 'px';
    sheet.style.height = w.height + 'px';
    sheet.style.top = (w.top - st.top) + 'px';
    sheet.style.left = (w.left - st.left) + 'px';
    sheet.style.transformOrigin = dir === 'next' ? '100% 50%' : '0% 50%';
    const f1 = document.createElement('div');
    f1.className = 'face';
    if (frontCanvas) f1.appendChild(frontCanvas);
    const f2 = document.createElement('div');
    f2.className = 'face back';
    f2.appendChild(backCanvas.cloneNode ? await cloneCanvas(backCanvas) : backCanvas);
    sheet.appendChild(f1);
    sheet.appendChild(f2);
    // page revealed underneath the turning sheet
    (dir === 'next' ? lfL : lfR).innerHTML = '';
    (dir === 'next' ? lfL : lfR).appendChild(await cloneCanvas(underCanvas));
    stage.appendChild(sheet);
    await new Promise((r) => requestAnimationFrame(() => requestAnimationFrame(r)));
    sheet.style.transform = 'rotateY(' + (dir === 'next' ? '' : '-') + '180deg)';
    await new Promise((r) => setTimeout(r, 560));
  } catch (e) {}
}
async function cloneCanvas(c) {
  const n = document.createElement('canvas');
  n.width = c.width;
  n.height = c.height;
  n.style.width = c.style.width;
  n.style.height = c.style.height;
  n.getContext('2d').drawImage(c, 0, 0);
  return n;
}
async function bookGo(p, dir) {
  if (!bk.pdf || bk.busy) return;
  p = Math.max(1, Math.min(bk.total, p));
  bk.busy = true;
  try {
    if (dir) await bookTurn(dir, p);
    bk.page = p;
    await drawBookSpread();
  } catch (e) {} finally {
    bk.busy = false;
  }
}
async function bookLoadEd(i, restore) {
  const token = ++bk.token;
  bk.ed = i;
  bk.cache.clear();
  bk.pdf = null;
  const note = $('dxq-bookNote');
  note.hidden = false;
  note.classList.add('spin');
  note.textContent = I18N[lang].bookLoad;
  $('dxq-bookStage').querySelectorAll('.book-spread, .book-sheet').forEach((x) => x.remove());
  try {
    const lib = await loadPdfJs();
    const url = BOOK_BASE + BOOK_EDS[i].f;
    let doc;
    try {
      // range-stream: linearized PDFs on GCS support byte-range, so pdf.js
      // pulls only the pages being viewed (disableAutoFetch) — page 1 shows
      // in a second or two and the full 150MB+ file is never downloaded.
      doc = await lib.getDocument({ url, rangeChunkSize: 262144,
        disableAutoFetch: true, disableStream: false, disableRange: false }).promise;
    } catch (e1) {
      if (token !== bk.token) return;
      // rare fallback: whole-file download if range streaming is unavailable
      const data = await fetchPdfData(url, note, token);
      if (token !== bk.token) return;
      doc = await lib.getDocument({ data }).promise;
    }
    if (token !== bk.token) return;
    bk.pdf = doc;
    bk.total = doc.numPages;
    let p = 1;
    try {
      const sv = JSON.parse(localStorage.getItem(LS_BOOK)) || {};
      if (sv.pages && sv.pages[i]) p = sv.pages[i];
      else if (sv.page && sv.ed === i) p = sv.page; // pre-upgrade format
    } catch (e) {}
    bk.page = Math.max(1, Math.min(bk.total, p));
    note.hidden = true;
    note.classList.remove('spin');
    await drawBookSpread();
  } catch (e) {
    if (token !== bk.token) return;
    note.hidden = false;
    note.classList.remove('spin');
    note.textContent = I18N[lang].bookErr + ' ↻';
    note.style.cursor = 'pointer';
    note.addEventListener('click', () => { note.style.cursor = ''; bookLoadEd(bk.ed); }, { once: true });
  }
}
(function(){ var st = document.getElementById('dxq-bookStage'); if (st) st.addEventListener('contextmenu', function(e){ e.preventDefault(); }); })();
function bookOpen() {
  openModal(bookWrap);
  if (!bk.pdf) bookLoadEd(bk.ed, true);
}
$('dxq-bookOpen1').addEventListener('click', bookOpen);
$('dxq-bookClose').addEventListener('click', () => requestClose(bookWrap));
document.addEventListener('keydown', (e) => {
  if (bookWrap.hidden) return;
  if (e.key === 'Escape') requestClose(bookWrap);
  else if (e.key === 'ArrowLeft') bookGo(bk.page + (bookSingle() ? 1 : 2), 'next');
  else if (e.key === 'ArrowRight') bookGo(bk.page - (bookSingle() ? 1 : 2), 'prev');
});
$('dxq-bookEd').addEventListener('change', () => bookLoadEd(+$('dxq-bookEd').value, false));
$('dxq-bookNext').addEventListener('click', () => bookGo(bk.page + (bookSingle() ? 1 : 2), 'next'));
$('dxq-bookPrev').addEventListener('click', () => bookGo(bk.page - (bookSingle() ? 1 : 2), 'prev'));
$('dxq-bookPage').addEventListener('change', () => bookGo(+$('dxq-bookPage').value || 1));
(() => {
  const stage = $('dxq-bookStage');
  let downX = null;
  stage.addEventListener('pointerdown', (e) => { downX = e.clientX; });
  stage.addEventListener('pointerup', (e) => {
    if (downX === null) return;
    const dx = e.clientX - downX;
    downX = null;
    const step = bookSingle() ? 1 : 2;
    if (dx > 44) bookGo(bk.page + step, 'next');        // swipe right = flip onward (RTL)
    else if (dx < -44) bookGo(bk.page - step, 'prev');
    else {
      const r = stage.getBoundingClientRect();
      const x = (e.clientX - r.left) / r.width;
      if (x < 0.42) bookGo(bk.page + step, 'next');
      else if (x > 0.58) bookGo(bk.page - step, 'prev');
    }
  });
  let rT = null;
  window.addEventListener('resize', () => {
    if (bookWrap.hidden || !bk.pdf) return;
    clearTimeout(rT);
    rT = setTimeout(() => { bk.cache.clear(); drawBookSpread(); }, 250);
  });
})();

/* ---------- bookmarks (local) ---------- */
const BMK = new Set();
try { (JSON.parse(localStorage.getItem('quran-bmk-v1')) || []).forEach((k) => BMK.add(k)); } catch (e) {}
function saveBmk() {
  try { localStorage.setItem('quran-bmk-v1', JSON.stringify([...BMK])); } catch (e) {}
  $('dxq-bmkBtn').innerHTML = svgI('bookmark') + (BMK.size ? ' ' + BMK.size : '');
  $('dxq-bmkBtn').setAttribute('aria-label', I18N[lang].bmkBtn + (BMK.size ? ', ' + BMK.size : ''));
}
function renderBmkPanel() {
  const pn = $('dxq-bmkPanel');
  pn.innerHTML = '';
  if (!BMK.size) {
    const p = document.createElement('div');
    p.className = 'q-note';
    p.textContent = I18N[lang].bmkEmpty;
    pn.appendChild(p);
    return;
  }
  [...BMK].sort((a, b) => {
    const [as, av] = a.split(':').map(Number), [bs, bv] = b.split(':').map(Number);
    return as - bs || av - bv;
  }).forEach((k) => {
    const [sn, vn] = k.split(':').map(Number);
    const su = SURAHS[sn - 1];
    if (!su) return;
    const item = document.createElement('div');
    item.className = 'sr-item';
    const ref = document.createElement('span');
    ref.className = 'sr-ref';
    ref.innerHTML = svgI('bookmark', 12) + ' ' + su.t + ' · ' + k;
    const txt = document.createElement('span');
    txt.className = 'sr-txt';
    txt.textContent = meaning(su);
    const open = document.createElement('button');
    open.type = 'button';
    open.className = 'q-chip';
    open.innerHTML = svgI('book') + ' ' + I18N[lang].srchOpen;
    open.addEventListener('click', () => { bumpStreak(); openReader(su, vn); });
    const del = document.createElement('button');
    del.type = 'button';
    del.className = 'q-chip';
    del.textContent = '✕';
    del.addEventListener('click', () => { BMK.delete(k); saveBmk(); renderBmkPanel(); });
    item.appendChild(ref);
    item.appendChild(txt);
    item.appendChild(open);
    item.appendChild(del);
    pn.appendChild(item);
  });
}
$('dxq-bmkBtn').addEventListener('click', () => {
  const pn = $('dxq-bmkPanel');
  pn.hidden = !pn.hidden;
  $('dxq-bmkBtn').classList.toggle('on', !pn.hidden);
  if (!pn.hidden) renderBmkPanel();
});
saveBmk();

/* ---------- word data (word-by-word + karaoke share this) ---------- */
const wordCache = new Map();
async function fetchWords(key) {
  if (wordCache.has(key)) return wordCache.get(key);
  const r = await fetch('https://api.quran.com/api/v4/verses/by_key/' + key + '?words=true&word_fields=text_uthmani&language=en');
  if (!r.ok) throw new Error('words ' + r.status);
  const words = ((await r.json()).verse || {}).words || [];
  const usable = words.filter((w) => w.char_type_name !== 'end');
  wordCache.set(key, usable);
  return usable;
}
async function wordify(arEl) {
  if (arEl.dataset.wordified) return true;
  const key = arEl.dataset.key;
  if (!key) return false;
  try {
    const words = await fetchWords(key);
    if (!words.length) return false;
    const marker = arEl.querySelector('.rv-n');
    arEl.textContent = '';
    words.forEach((w, i) => {
      const sp = document.createElement('span');
      sp.className = 'w';
      sp.dataset.i = i;
      sp.textContent = w.text_uthmani || w.text || '';
      arEl.appendChild(sp);
      arEl.appendChild(document.createTextNode(' '));
    });
    if (marker) arEl.appendChild(marker);
    arEl.dataset.wordified = '1';
    return true;
  } catch (e) { return false; }
}
/* word tap popover */
let wbwPop = null;
function closeWbw() { if (wbwPop) { wbwPop.remove(); wbwPop = null; } }
document.addEventListener('click', (e) => {
  const w = e.target.closest && e.target.closest('.rv-ar .w');
  if (!w) { if (!e.target.closest || !e.target.closest('.wbw-pop')) closeWbw(); return; }
  const arEl = w.closest('.rv-ar');
  const words = wordCache.get(arEl.dataset.key);
  const wd = words && words[+w.dataset.i];
  if (!wd) return;
  closeWbw();
  wbwPop = document.createElement('div');
  wbwPop.className = 'wbw-pop';
  const a = document.createElement('div'); a.className = 'wp-ar'; a.lang = 'ar'; a.dir = 'rtl';
  a.textContent = wd.text_uthmani || wd.text || '';
  const tl = document.createElement('div'); tl.className = 'wp-tl';
  tl.textContent = (wd.transliteration && wd.transliteration.text) || '';
  const tr = document.createElement('div'); tr.className = 'wp-tr';
  tr.textContent = (wd.translation && wd.translation.text) || '';
  wbwPop.appendChild(a); wbwPop.appendChild(tl); wbwPop.appendChild(tr);
  if (wd.audio_url) {
    const pb = document.createElement('button');
    pb.type = 'button'; pb.className = 'q-chip'; pb.innerHTML = svgI('volume', 15);
    pb.addEventListener('click', (ev) => {
      ev.stopPropagation();
      new Audio('https://audio.qurancdn.com/' + wd.audio_url).play().catch(() => {});
    });
    wbwPop.appendChild(pb);
  }
  document.body.appendChild(wbwPop);
  const r = w.getBoundingClientRect();
  const pw = wbwPop.offsetWidth, ph = wbwPop.offsetHeight;
  wbwPop.style.left = Math.max(10, Math.min(window.innerWidth - pw - 10, r.left + r.width / 2 - pw / 2)) + 'px';
  const above = r.top - ph - 10;
  wbwPop.style.top = (above < 10 ? Math.min(window.innerHeight - ph - 10, r.bottom + 10) : above) + 'px';
});

/* ---------- karaoke: follow the recitation word by word ---------- */
const kar = { on: false, surah: 0, data: null, cur: 0, audio: new Audio(), token: 0 };
kar.audio.preload = 'auto';
async function karData(sn) {
  const id = QARIS.some((x) => x.id === qariState.id) ? qariState.id : 7;
  if (kar.data && kar.surah === sn && kar.qid === id) return kar.data;
  const r = await fetch('https://api.quran.com/api/v4/quran/recitations/' + id + '?chapter_number=' + sn + '&fields=segments');
  if (!r.ok) throw new Error('segments ' + r.status);
  const j = await r.json();
  const map = {};
  (j.audio_files || []).forEach((f) => { map[f.verse_key] = f; });
  kar.data = map;
  kar.surah = sn;
  kar.qid = id;
  return map;
}
function karClear() {
  readBody.querySelectorAll('.w-live').forEach((x) => x.classList.remove('w-live'));
  readBody.querySelectorAll('.rv.live-ayah').forEach((x) => x.classList.remove('live-ayah'));
}
function stopKar() {
  kar.on = false;
  kar.token++;
  try { kar.audio.pause(); } catch (e) {}
  karClear();
  const b = $('dxq-readKar');
  if (b) b.classList.remove('mode-on');
}
async function karPlayFrom(vn) {
  if (typeof stopVersePlay === 'function') stopVersePlay();
  const token = ++kar.token;
  const sn = rd.s.n;
  try {
    const map = await karData(sn);
    while (kar.on && token === kar.token && vn <= rd.s.y) {
      const key = sn + ':' + vn;
      let block = readBody.querySelector('.rv[data-key="' + key + '"]');
      if (!block) {
        if (rd.next <= rd.s.y) {
          const before = rd.next;
          await readBatch();
          // readBatch bails while busy — yield a macrotask so the in-flight
          // batch can actually land instead of spinning the microtask queue
          if (rd.next === before) await new Promise((r) => setTimeout(r, 350));
          continue;
        }
        break;
      }
      const f = map[key];
      if (!f) { vn++; continue; }
      karClear();
      block.classList.add('live-ayah');
      /* centre the recited verse in the region BELOW the sticky tajweed
         legend — plain block:'center' ignores the overlay and tucks the
         line underneath it */
      const legEl = readBody.querySelector('.taj-legend');
      const legH = legEl ? legEl.offsetHeight + 12 : 0;
      const region = readBody.clientHeight - legH;
      const delta = block.getBoundingClientRect().top - readBody.getBoundingClientRect().top;
      const target = readBody.scrollTop + delta - legH - Math.max(0, (region - block.offsetHeight) / 2);
      readBody.scrollTo({ top: Math.max(0, target), behavior: 'smooth' });
      const arEl = block.querySelector('.rv-ar');
      const worded = !taj.on && await wordify(arEl);
      const spans = worded ? arEl.querySelectorAll('.w') : null;
      const segs = f.segments || [];
      kar.audio.src = /^https?:/.test(f.url) ? f.url : 'https://verses.quran.com/' + f.url;
      const done = new Promise((res) => {
        const onEnd = () => { cleanup(); res(); };
        const onTime = () => {
          if (!spans || !segs.length) return;
          const t = kar.audio.currentTime * 1000;
          for (const g of segs) {
            if (t >= g[2] && t < g[3]) {
              const idx = g[0];
              arEl.querySelectorAll('.w-live').forEach((x) => x.classList.remove('w-live'));
              if (spans[idx]) spans[idx].classList.add('w-live');
              break;
            }
          }
        };
        const cleanup = () => {
          kar.audio.removeEventListener('ended', onEnd);
          kar.audio.removeEventListener('timeupdate', onTime);
          kar.audio.removeEventListener('error', onEnd);
        };
        kar.audio.addEventListener('ended', onEnd);
        kar.audio.addEventListener('error', onEnd);
        kar.audio.addEventListener('timeupdate', onTime);
      });
      let played = true;
      try { await kar.audio.play(); } catch (e) { played = false; }
      if (!played) { stopKar(); break; }
      await done;
      if (!kar.on || token !== kar.token) break;
      bumpGoal(1);
      vn++;
    }
  } catch (e) {}
  if (token === kar.token) { karClear(); kar.on = false; $('dxq-readKar').classList.remove('mode-on'); }
}
$('dxq-readKar').addEventListener('click', () => {
  if (kar.on) { stopKar(); return; }
  kar.on = true;
  $('dxq-readKar').classList.add('mode-on');
  audio.pause(); // the main player yields to follow-along
  // unlock the audio element inside this user gesture — the first real play
  // happens after network awaits, when the gesture window has expired
  try {
    kar.audio.src = 'data:audio/wav;base64,UklGRiQAAABXQVZFZm10IBAAAAABAAEAQB8AAEAfAAABAAgAZGF0YQAAAAA=';
    kar.audio.play().catch(() => {});
  } catch (e) {}
  bumpStreak();
  const first = readBody.querySelector('.rv[data-key]');
  const vn = first ? +first.dataset.key.split(':')[1] : 1;
  karPlayFrom(vn);
});

/* ---------- tajweed mode ---------- */
const taj = { on: false, surah: 0, map: null };
async function tajData(sn) {
  if (taj.map && taj.surah === sn) return taj.map;
  const r = await fetch('https://api.quran.com/api/v4/quran/verses/uthmani_tajweed?chapter_number=' + sn);
  if (!r.ok) throw new Error('taj ' + r.status);
  const j = await r.json();
  const map = {};
  (j.verses || []).forEach((v) => { map[v.verse_key] = v.text_uthmani_tajweed; });
  taj.map = map;
  taj.surah = sn;
  return map;
}
function tajRender(arEl, html) {
  const marker = arEl.querySelector('.rv-n');
  arEl.textContent = '';
  delete arEl.dataset.wordified;
  const doc = new DOMParser().parseFromString(html, 'text/html');
  (function walk(from, to) {
    from.childNodes.forEach((nd) => {
      if (nd.nodeType === 3) { to.appendChild(document.createTextNode(nd.textContent)); return; }
      if (nd.nodeType !== 1) return;
      if ((nd.getAttribute('class') || '') === 'end') return; // API's inline verse number — the ﴿n﴾ marker is ours
      if (nd.tagName === 'TAJWEED') {
        const cls = (nd.getAttribute('class') || '').replace(/[^a-z_]/g, '');
        const sp = document.createElement('span');
        sp.className = 'tj tj-' + cls;
        walk(nd, sp);
        to.appendChild(sp);
      } else {
        walk(nd, to);
      }
    });
  })(doc.body, arEl);
  tajQamariah(arEl);
  tajMaddSplit(arEl);
  tajLinSplit(arEl);
  tajAsli(arEl);
  tajIzhar(arEl);
  /* pengendali TERUS pada setiap segmen — elemen ber-onclick sentiasa
     "clickable" bagi iOS, tiada kebergantungan pada delegasi */
  arEl.querySelectorAll('.tj').forEach((s) => { s.onclick = tjSegTap; });
  if (marker) { arEl.appendChild(document.createTextNode(' ')); arEl.appendChild(marker); }
}
/* The API only tags dagger/small-letter madd as madda_normal — regular
   Madd Asli (fatha+alif, damma+waw, kasra+ya…) is untagged, so colour it
   here. Skips madd letters whose next base char is hamzat wasl ٱ — the
   madd drops in connected reading (iltiqa' sakinain). Validated against
   all 6,236 verses: 26,484 tags, 1,335 wasla exclusions. */
function tajAsli(root) {
  const COMB = /[\u064B-\u065F\u0670\u06D6-\u06ED\u08F0-\u08FF\u200C\u200D]/;
  const beforeText = (tn, off) => {
    const r = document.createRange();
    r.selectNodeContents(root);
    r.setEnd(tn, off);
    return r.toString();
  };
  const afterText = (tn, off) => {
    const r = document.createRange();
    r.selectNodeContents(root);
    r.setStart(tn, off);
    return r.toString();
  };
  const droppedBeforeWasla = (tn, off) => {
    const t = afterText(tn, off);
    for (let k = 0; k < t.length; k++) {
      const ch = t[k];
      if (ch === ' ' || COMB.test(ch)) continue;
      let m = k + 1, silent = false;
      while (m < t.length && COMB.test(t[m])) {
        if (t[m] === '\u0652' || t[m] === '\u06DF') silent = true;
        m++;
      }
      if (silent && /[اوى]/.test(ch)) { k = m - 1; continue; }
      return ch === '\u0671';
    }
    return false;
  };
  const wk = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
  const nodes = [];
  while (wk.nextNode()) nodes.push(wk.currentNode);
  nodes.forEach((tn) => {
    if (tn.parentElement && tn.parentElement.classList.contains('tj')) return;
    const txt = tn.textContent;
    const HAMZAB = /[\u0621\u0623\u0624\u0625\u0626\u0654\u0655]/;
    const hits = [];
    for (let i = 0; i < txt.length; i++) {
      const ch = txt[i];
      const back2 = i >= 2 ? txt.slice(i - 2, i) : (beforeText(tn, 0) + txt.slice(0, i)).slice(-2);
      const prv = back2.slice(-1);
      const p2 = back2.length > 1 ? back2[0] : '';
      const nxt = i + 1 < txt.length ? txt[i + 1] : afterText(tn, txt.length).charAt(0);
      if (((ch === 'ا' && prv === '\u064E') || (ch === 'و' && prv === '\u064F') ||
           (ch === 'ي' && prv === '\u0650')) && !(nxt && COMB.test(nxt))) {
        if (!droppedBeforeWasla(tn, i + 1)) {
          hits.push([i, i + 1, HAMZAB.test(p2) ? 'madda_badal' : 'madda_normal']);
        }
      } else if (ch === '\u0670') {
        const s = (prv === 'ى' || prv === '\u066E' || prv === '\u0640') && i > 0 ? i - 1 : i;
        hits.push([s, i + 1, 'madda_normal']);
      } else if (ch === '\u06E5' || ch === '\u06E6') {
        hits.push([i, i + 1, 'madda_normal']);
      }
    }
    if (!hits.length) return;
    const frag = document.createDocumentFragment();
    let last = 0;
    hits.forEach(([s, e, cls]) => {
      if (s < last) return;
      frag.appendChild(document.createTextNode(txt.slice(last, s)));
      const sp = document.createElement('span');
      sp.className = 'tj tj-' + cls;
      sp.textContent = txt.slice(s, e);
      frag.appendChild(sp);
      last = e;
    });
    frag.appendChild(document.createTextNode(txt.slice(last)));
    tn.parentNode.replaceChild(frag, tn);
  });
}
/* The API merges Madd Wajib Muttasil and Madd Jaiz Munfasil into one
   madda_obligatory class — split by where the hamza sits: same written
   word = muttasil; next word = munfasil (the silent jama'ah alif اْ / و۟
   is skipped on the walk to the hamza); the joined particles يَـٰٓ / هَـٰٓ
   (yaa-ayyuha, haa-ulaa) are munfasil hukmi. Validated against all 6,236
   verses: 1,950 muttasil + 3,216 munfasil = 5,166, zero unclassified. */
/* Izhar Halqi + Izhar Syafawi — the API never tags them (they are the
   untagged complement of ikhfa/idgham/iqlab). Uthmani orthography only
   writes an explicit sukun on nun/mim in izhar contexts, corpus-verified.
   Excluded: verse-end tanwin, anything before hamzat wasl (helper vowel),
   and نْ+ي/و izhar mutlaq words which are not halqi. */
function tajIzhar(root) {
  const COMB = /[\u064B-\u065F\u0670\u06D6-\u06ED\u08F0-\u08FF\u200C\u200D]/;
  const THROAT = /[\u0621\u0623\u0625\u0639\u062D\u063A\u062E\u0647]/;
  const after = (tn, off) => {
    const r = document.createRange();
    r.selectNodeContents(root);
    r.setStart(tn, off);
    return r.toString();
  };
  const nextBase = (t, skipCarrier) => {
    let carrier = skipCarrier;
    for (let k = 0; k < t.length; k++) {
      const ch = t[k];
      if (ch === ' ' || ch === '\u06DF' || COMB.test(ch)) continue;
      let m = k + 1, silent = false;
      while (m < t.length && (COMB.test(t[m]) || t[m] === '\u06DF')) {
        if (t[m] === '\u0652' || t[m] === '\u06DF') silent = true;
        m++;
      }
      if (silent && /[اوى]/.test(ch)) { k = m - 1; continue; }
      if (carrier && (ch === 'ا' || ch === 'ى')) { carrier = false; k = m - 1; continue; }
      return ch;
    }
    return '';
  };
  const wk = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
  const nodes = [];
  while (wk.nextNode()) nodes.push(wk.currentNode);
  nodes.forEach((tn) => {
    if (tn.parentElement && tn.parentElement.classList.contains('tj')) return;
    const txt = tn.textContent;
    const hits = [];
    for (let i = 0; i < txt.length; i++) {
      const ch = txt[i];
      const nxt = i + 1 < txt.length ? txt[i + 1] : after(tn, txt.length).charAt(0);
      if ((ch === 'ن' || ch === 'م') && nxt === '\u0652') {
        const b = nextBase(after(tn, Math.min(i + 2, txt.length)), false);
        if (ch === 'ن' && THROAT.test(b)) hits.push([i, Math.min(i + 2, txt.length), 'izhar_halqi']);
        else if (ch === 'م' && b && b !== '\u0671' && b !== 'ب' && b !== 'م') hits.push([i, Math.min(i + 2, txt.length), 'izhar_shafawi']);
      } else if (ch === '\u064B' || ch === '\u064C' || ch === '\u064D') {
        const b = nextBase(after(tn, i + 1), ch === '\u064B');
        if (THROAT.test(b) && i > 0) hits.push([i - 1, i + 1, 'izhar_halqi']);
      }
    }
    if (!hits.length) return;
    const frag = document.createDocumentFragment();
    let last = 0;
    hits.forEach(([s, e, cls]) => {
      if (s < last) return;
      frag.appendChild(document.createTextNode(txt.slice(last, s)));
      const sp = document.createElement('span');
      sp.className = 'tj tj-' + cls;
      sp.textContent = txt.slice(s, e);
      frag.appendChild(sp);
      last = e;
    });
    frag.appendChild(document.createTextNode(txt.slice(last)));
    tn.parentNode.replaceChild(frag, tn);
  });
}
/* API menggabungkan Mad Lin ke dalam madda_permissible (hujung ayat) —
   pisahkan: huruf و/ي dalam span yang didahului fatha (dalam span atau
   tepat sebelumnya) = Lin; selainnya Arid Lissukun. Korpus: 8 kes sahaja. */
function tajLinSplit(root) {
  root.querySelectorAll('.tj-madda_permissible').forEach((sp) => {
    const t = sp.textContent;
    const k = Math.max(t.indexOf('و'), t.indexOf('ي'));
    if (k < 0) return;
    let prev = k > 0 ? t[k - 1] : '';
    if (!prev) {
      const r = document.createRange();
      r.selectNodeContents(root);
      r.setEndBefore(sp);
      prev = r.toString().slice(-1);
    }
    if (prev === '\u064E') sp.classList.add('tj-madda_lin');
  });
}
function tajMaddSplit(root) {
  const MARK = /[\u064B-\u0653\u0656-\u065F\u0670\u06D6-\u06ED\u0640\u200C\u200D\u08F0-\u08FF]/;
  const HAMZA = /[\u0621\u0623\u0624\u0625\u0626\u0654\u0655\u0672\u0673]/;
  root.querySelectorAll('.tj-madda_obligatory').forEach((sp) => {
    const ra = document.createRange();
    ra.selectNodeContents(root);
    ra.setStartAfter(sp);
    const after = ra.toString();
    let saw = false, cls = 'muttasil';
    for (let i = 0; i < after.length; i++) {
      const ch = after[i];
      if (ch === ' ') { saw = true; continue; }
      if (HAMZA.test(ch)) {
        if (saw) { cls = 'munfasil'; break; }
        const rb = document.createRange();
        rb.selectNodeContents(root);
        rb.setEndBefore(sp);
        const before = rb.toString();
        const word = before.slice(before.lastIndexOf(' ') + 1);
        let letters = '';
        for (const c of word) { if (!MARK.test(c)) letters += c; }
        cls = (letters === 'ي' || letters === 'ه') ? 'munfasil' : 'muttasil';
        break;
      }
      if (MARK.test(ch)) continue;
      let j = i + 1, silent = false;
      while (j < after.length && MARK.test(after[j])) {
        if (after[j] === '\u0652' || after[j] === '\u06DF') silent = true;
        j++;
      }
      if (silent && /[اوى]/.test(ch)) { i = j - 1; continue; }
      break;
    }
    sp.classList.add('tj-madda_' + cls);
  });
}
/* The API tags the SILENT article lam (laam_shamsiyah) but never the
   pronounced one, so Lam Qamariah is derived here: wasla alif + lam+sukun,
   excluding the ta of Form-VIII verbs (Al-taqa, Al-taqata...). The lam may
   sit in the same text node as the alif (verse-initial) or right after a
   ham_wasl span (mid-verse). */
function tajQamariah(root) {
  const wk = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
  const nodes = [];
  while (wk.nextNode()) nodes.push(wk.currentNode);
  nodes.forEach((tn) => {
    if (tn.parentElement && tn.parentElement.classList.contains('tj')) return;
    const txt = tn.textContent;
    const frag = document.createDocumentFragment();
    const mk = () => {
      const sp = document.createElement('span');
      sp.className = 'tj tj-laam_qamariyah';
      sp.textContent = 'ل\u0652';
      return sp;
    };
    let last = 0, changed = false;
    const prev = tn.previousSibling;
    if (prev && prev.nodeType === 1 && prev.classList.contains('tj-ham_wasl') &&
        /^ل\u0652(?!ت)/.test(txt)) {
      frag.appendChild(mk());
      last = 2; changed = true;
    }
    const re = /\u0671(ل\u0652)(?!ت)/g;
    re.lastIndex = last;
    let m;
    while ((m = re.exec(txt))) {
      frag.appendChild(document.createTextNode(txt.slice(last, m.index + 1)));
      frag.appendChild(mk());
      last = m.index + m[0].length;
      changed = true;
    }
    if (!changed) return;
    frag.appendChild(document.createTextNode(txt.slice(last)));
    tn.parentNode.replaceChild(frag, tn);
  });
}
async function readModesApply() {
  if (!rd) return;
  const sn = rd.s.n;
  if (taj.on) {
    try {
      const map = await tajData(sn);
      if (!taj.on || !rd || rd.s.n !== sn) return;
      readBody.querySelectorAll('.rv-ar[data-key]').forEach((arEl) => {
        if (arEl.dataset.taj === '1') return;
        const h = map[arEl.dataset.key];
        if (h) { tajRender(arEl, h); arEl.dataset.taj = '1'; }
      });
    } catch (e) {}
  }
}
/* ---- header tema Shopify: toolbar melekat DI BAWAH header, dan header
   auto-sembunyi ketika skrol turun supaya fokus kekal pada Al-Quran ---- */
function dxqHeaderInit() {
  const sh = document.querySelector('sticky-header');
  const sec = sh ? (sh.closest('.shopify-section') || sh) : document.querySelector('.section-header');
  if (!sec) return;
  const pos = getComputedStyle(sec).position;
  if (pos !== 'sticky' && pos !== 'fixed' && !sh) return;
  if (!document.getElementById('dxq-hdr-css')) {
    const st = document.createElement('style');
    st.id = 'dxq-hdr-css';
    st.textContent = '.dxq-hdr-anim{transition:transform .28s ease}.dxq-hdr-hide{transform:translateY(-110%)!important}';
    document.head.appendChild(st);
  }
  sec.classList.add('dxq-hdr-anim');
  const tb = document.querySelector('.toolbar');
  if (tb) tb.style.transition = 'top .28s ease';
  let hidden = false, lastY = window.scrollY;
  const place = () => {
    if (!tb) return;
    tb.style.top = ((hidden ? 0 : sec.getBoundingClientRect().height) + 10) + 'px';
  };
  const onScroll = () => {
    const y = window.scrollY;
    if (y > lastY + 6 && y > 160 && !hidden) { hidden = true; sec.classList.add('dxq-hdr-hide'); }
    else if ((y < lastY - 6 || y < 80) && hidden) { hidden = false; sec.classList.remove('dxq-hdr-hide'); }
    lastY = y;
    place();
  };
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', place);
  place();
}
window.__dxqHeaderInit = dxqHeaderInit;
dxqHeaderInit();

/* ---- tajweed rule tooltips: hover / long-press / legend tap ---- */
const TAJ_RULES = [['madda_normal', 'Mad Asli'], ['madda_permissible', 'Mad Arid Lissukun'],
  ['madda_lin', 'Mad Lin'],
  ['madda_muttasil', 'Mad Wajib Muttasil'], ['madda_munfasil', 'Mad Jaiz Munfasil'],
  ['madda_necessary', 'Mad Lazim'], ['madda_badal', 'Mad Badal'],
  ['qalaqah', 'Qalqalah'], ['ghunnah', 'Ghunnah'],
  ['izhar_halqi', 'Izhar Halqi'], ['ikhafa', 'Ikhfa Haqiqi'],
  ['izhar_shafawi', 'Izhar Syafawi'], ['ikhafa_shafawi', 'Ikhfa Syafawi'],
  ['idgham_ghunnah', 'Idgham Maal Ghunnah'], ['idgham_wo_ghunnah', 'Idgham Bila Ghunnah'],
  ['idgham_shafawi', 'Idgham Syafawi'],
  ['idgham_mutajanisayn', 'Idgham Mutajanisain'],
  ['idgham_mutaqaribayn', 'Idgham Mutaqaribain'],
  ['iqlab', 'Iqlab'],
  ['ham_wasl', 'Hamzah Wasal'], ['laam_shamsiyah', 'Lam Syamsiah'],
  ['laam_qamariyah', 'Lam Qamariah'],
  ['slnt', 'Senyap']];
const DXQ_BUILD = 'b110104';
(() => {
  const f = document.querySelector('.qread-foot');
  if (f) {
    const s = document.createElement('span');
    s.className = 'q-note';
    s.style.cssText = 'opacity:.35;font-size:.6rem;border:none;background:none;padding:0 2px';
    s.textContent = DXQ_BUILD;
    f.appendChild(s);
  }
})();
const TAJ_NAME = {};
TAJ_RULES.forEach((pr) => { TAJ_NAME[pr[0]] = pr[1]; });
let tajTipEl = null, tajTipFor = null;
function hideTajTip() {
  if (tajTipEl) tajTipEl.remove();
  tajTipEl = null; tajTipFor = null;
}
function showTajTip(cls, r) {
  hideTajTip();
  const name = TAJ_NAME[cls];
  const desc = (I18N[lang].tajDesc || {})[cls];
  if (!name || !desc) return;
  tajTipEl = document.createElement('div');
  tajTipEl.className = 'wbw-pop taj-tip';
  const b = document.createElement('b');
  b.textContent = name;
  const probe = document.createElement('span');
  probe.className = 'tj-' + cls;
  probe.style.display = 'none';
  document.body.appendChild(probe);
  b.style.color = getComputedStyle(probe).color;
  probe.remove();
  const p = document.createElement('div');
  p.textContent = desc;
  tajTipEl.appendChild(b);
  tajTipEl.appendChild(p);
  document.body.appendChild(tajTipEl);
  const tw = tajTipEl.offsetWidth, th = tajTipEl.offsetHeight;
  const x = Math.min(Math.max(8, r.left + r.width / 2 - tw / 2), window.innerWidth - tw - 8);
  let y = r.bottom + 8;
  if (y + th > window.innerHeight - 8) y = r.top - th - 8;
  tajTipEl.style.left = x + 'px';
  tajTipEl.style.top = Math.max(8, y) + 'px';
  tajTipFor = cls;
}
function tajHit(el) {
  const t = el.closest ? el.closest('.rv-ar .tj, .taj-legend [data-tj]') : null;
  if (!t) return null;
  /* span pecahan membawa dua kelas (cth. tj-madda_permissible + tj-madda_lin)
     — ambil yang paling spesifik yang wujud dalam TAJ_NAME */
  const cls = t.dataset.tj ||
    ([...t.classList].filter((c) => c.indexOf('tj-') === 0)
      .map((c) => c.slice(3))
      .reverse()
      .find((c) => TAJ_NAME[c]) || '');
  return cls ? { cls, el: t } : null;
}
/* Sentuhan dikendalikan TERUS melalui Pointer Events — iOS Safari tidak
   mensintesis 'click' dengan konsisten untuk span teks (walau dengan
   cursor:pointer), jadi pointerup ialah laluan yang dijamin. Klik tetikus
   kekal melalui pengendali click di bawah. */
function tjSegTap(e) {
  e.stopPropagation();
  if (Date.now() - tjTouchHandled < 700) return;
  const hit = tajHit(e.target);
  if (hit) tajToggle(hit);
}
function tajToggle(hit) {
  if (tajTipFor === hit.cls) hideTajTip();
  else showTajTip(hit.cls, hit.el.getBoundingClientRect());
}
let tjPtr = null, tjTouchHandled = 0;
readWrap.addEventListener('pointerdown', (e) => {
  if (e.pointerType !== 'touch') return;
  const hit = tajHit(e.target);
  tjPtr = hit ? { x: e.clientX, y: e.clientY, hit } : null;
}, { passive: true });
readWrap.addEventListener('pointerup', (e) => {
  if (e.pointerType !== 'touch' || !tjPtr) return;
  const moved = Math.abs(e.clientX - tjPtr.x) > 10 || Math.abs(e.clientY - tjPtr.y) > 10;
  const hit = tjPtr.hit;
  tjPtr = null;
  if (moved) return;
  tjTouchHandled = Date.now();
  tajToggle(hit);
}, { passive: true });
readWrap.addEventListener('click', (e) => {
  const recentTouch = Date.now() - tjTouchHandled < 700;
  const hit = tajHit(e.target);
  if (hit) {
    if (!recentTouch) tajToggle(hit); // klik disintesis selepas sentuhan sudah dikendalikan
    return;
  }
  if (!e.target.closest || !e.target.closest('.taj-tip')) hideTajTip();
});
if (window.matchMedia && matchMedia('(hover: hover)').matches) {
  readWrap.addEventListener('mouseover', (e) => {
    const hit = tajHit(e.target);
    if (hit && hit.el.closest('.rv-ar')) showTajTip(hit.cls, hit.el.getBoundingClientRect());
  });
  readWrap.addEventListener('mouseout', (e) => {
    if (tajHit(e.target)) hideTajTip();
  });
}
readBody.addEventListener('scroll', hideTajTip, { passive: true });

/* ---- main bacaan satu ayat ---- */
const vp = { key: null, btn: null, token: 0, audio: new Audio() };
vp.audio.preload = 'none';
function stopVersePlay() {
  vp.token++;
  if (vp.onEv) {
    vp.audio.removeEventListener('ended', vp.onEv);
    vp.audio.removeEventListener('error', vp.onEv);
    vp.onEv = null;
  }
  try { vp.audio.pause(); } catch (e) {}
  if (vp.btn) {
    vp.btn.classList.remove('mode-on');
    vp.btn.innerHTML = svgI('play');
  }
  vp.key = null; vp.btn = null;
}
async function playVerse(key, btn) {
  if (vp.key === key) { stopVersePlay(); return; }
  stopVersePlay();
  if (kar.on) stopKar();
  if (!audio.paused) { try { audio.pause(); } catch (e) {} }
  /* buka kunci audio dalam gesture sebelum fetch async (iOS); pendengar
     ended dipasang SELEPAS src sebenar supaya ended WAV senyap tak
     membunuh mainan sebenar */
  vp.audio.src = 'data:audio/wav;base64,UklGRiQAAABXQVZFZm10IBAAAAABAAEAQB8AAEAfAAABAAgAZGF0YQAAAAA=';
  vp.audio.play().catch(() => {});
  const tk = ++vp.token;
  btn.disabled = true;
  try {
    const map = await karData(+key.split(':')[0]);
    if (tk !== vp.token) return;
    const f = map[key];
    if (!f) return;
    vp.audio.src = /^https?:/.test(f.url) ? f.url : 'https://verses.quran.com/' + f.url;
    vp.key = key; vp.btn = btn;
    btn.classList.add('mode-on');
    btn.innerHTML = svgI('stop');
    /* acara ended/error sesat daripada WAV senyap yang digugurkan boleh
       sampai selepas src sebenar dipasang — tapis dengan keadaan elemen */
    const onEv = (e) => {
      if (tk !== vp.token) return;
      if (e.type === 'ended' && vp.audio.ended) stopVersePlay();
      if (e.type === 'error' && vp.audio.error) stopVersePlay();
    };
    vp.onEv = onEv;
    vp.audio.addEventListener('ended', onEv);
    vp.audio.addEventListener('error', onEv);
    await vp.audio.play();
  } catch (e) {
    if (tk === vp.token) stopVersePlay();
  } finally {
    btn.disabled = false;
  }
}

/* ---- transliterasi Rumi (pemula BM belajar membaca Arab) ---- */
let rumiOn = (localStorage.getItem('quran-rumi') || '1') === '1';
function applyRumi() {
  readWrap.classList.toggle('rumi-on', rumiOn && lang === 'ms');
  const b = $('dxq-readRumi');
  if (!b) return;
  b.style.display = lang === 'ms' ? '' : 'none';
  b.classList.toggle('mode-on', rumiOn);
  b.setAttribute('aria-label', I18N[lang].rumi);
  b.setAttribute('aria-pressed', rumiOn);
}
$('dxq-readRumi').addEventListener('click', () => {
  rumiOn = !rumiOn;
  try { localStorage.setItem('quran-rumi', rumiOn ? '1' : '0'); } catch (e) {}
  applyRumi();
});
applyRumi();

/* ---- reader text size (accessibility) ---- */
const RD_SIZES = [1, 1.15, 1.3, 1.5, 1.75];
let rdSize = +(localStorage.getItem('quran-textsize') || 1);
if (RD_SIZES.indexOf(rdSize) < 0) rdSize = 1;
function applyRdSize() {
  readWrap.style.setProperty('--rds', rdSize);
  const b = $('dxq-readAa');
  if (!b) return;
  b.innerHTML = 'Aa' + (rdSize !== 1 ? ' <small>' + Math.round(rdSize * 100) + '%</small>' : '');
  b.setAttribute('aria-label', I18N[lang].textSize + ' — ' + Math.round(rdSize * 100) + '%');
  b.classList.toggle('mode-on', rdSize !== 1);
}
$('dxq-readAa').addEventListener('click', () => {
  rdSize = RD_SIZES[(RD_SIZES.indexOf(rdSize) + 1) % RD_SIZES.length];
  try { localStorage.setItem('quran-textsize', rdSize); } catch (e) {}
  applyRdSize();
});
applyRdSize();
$('dxq-readTaj').addEventListener('click', async () => {
  taj.on = !taj.on;
  $('dxq-readTaj').classList.toggle('mode-on', taj.on);
  $('dxq-readTaj').setAttribute('aria-pressed', taj.on);
  if (taj.on) {
    /* legenda awan dibuang — butang "Hukum" pada setiap ayat memberi
       senarai hukum + cara bacaan yang lebih fokus */
    await readModesApply();
  } else {
    readBody.querySelectorAll('.taj-note').forEach((x) => x.remove());
    // restore plain text from cached verse data by re-fetching words render
    readBody.querySelectorAll('.rv-ar[data-key]').forEach((arEl) => {
      delete arEl.dataset.taj;
      delete arEl.dataset.wordified;
    });
    // simplest faithful restore: re-open at the first visible verse
    const first = readBody.querySelector('.rv[data-key]');
    const vn = first ? +first.dataset.key.split(':')[1] : 1;
    openReader(rd.s, vn);
  }
});

/* ---------- about this surah ---------- */
const info = { openFor: 0, cache: new Map() };
$('dxq-readInfo').addEventListener('click', async () => {
  const sn = rd ? rd.s.n : 0;
  if (!sn) return;
  const existing = readBody.querySelector('.surah-info');
  if (existing) { existing.remove(); info.openFor = 0; return; }
  const panel = document.createElement('div');
  panel.className = 'surah-info';
  const h = document.createElement('h4');
  h.textContent = I18N[lang].infoHead;
  panel.appendChild(h);
  const load = document.createElement('div');
  load.className = 'q-note';
  load.textContent = I18N[lang].chatLoad;
  panel.appendChild(load);
  readBody.prepend(panel);
  info.openFor = sn;
  try {
    let html = info.cache.get(sn);
    if (!html) {
      const r = await fetch('https://api.quran.com/api/v4/chapters/' + sn + '/info?language=en');
      html = (((await r.json()) || {}).chapter_info || {}).text || '';
      info.cache.set(sn, html);
    }
    load.remove();
    const enBox = document.createElement('div');
    sanitizeInto(enBox, html);
    decorateTafsir(enBox);
    panel.appendChild(enBox);
    attachMalayTafsir(panel, enBox, I18N[lang].mtNoteInfo);
  } catch (e) {
    load.textContent = I18N[lang].chatErr;
  }
});

/* ---------- sajdah verses (fixed canonical list) ---------- */
const SAJDAH = new Set(['7:206', '13:15', '16:50', '17:109', '19:58', '22:18', '22:77',
  '25:60', '27:26', '32:15', '38:24', '41:38', '53:62', '84:21', '96:19']);

/* ---------- reciter choice: full-surah MP3s from quranicaudio ---------- */
const QARIS = [
  { id: 7, n: 'Sheikh Mishary Rashid Alafasy' },
  { id: 2, n: 'AbdulBaset AbdulSamad (Murattal)' },
  { id: 1, n: 'AbdulBaset AbdulSamad (Mujawwad)' },
  { id: 3, n: 'Abdur-Rahman As-Sudais' },
  { id: 10, n: "Sa'ud Ash-Shuraym" },
  { id: 9, n: 'Al-Minshawi (Murattal)' },
  { id: 8, n: 'Al-Minshawi (Mujawwad)' },
  { id: 6, n: 'Mahmoud Khalil Al-Husary' },
  { id: 12, n: 'Al-Husary (Muallim)' },
  { id: 4, n: 'Abu Bakr Ash-Shatri' },
  { id: 5, n: 'Hani Ar-Rifai' },
  { id: 11, n: 'Mohamed At-Tablawi' },
];
const qariState = { id: 7, map: null };
try {
  const q0 = +localStorage.getItem('quran-qari');
  if (QARIS.some((x) => x.id === q0)) qariState.id = q0;
} catch (e) {}
function qariSrc(s) {
  if (qariState.id !== 7 && qariState.map && qariState.map[s.n]) return qariState.map[s.n];
  return srcFor(s);
}
async function loadQariMap(id) {
  const r = await fetch('https://api.quran.com/api/v4/chapter_recitations/' + id);
  if (!r.ok) throw new Error('qari ' + r.status);
  const j = await r.json();
  const map = {};
  (j.audio_files || []).forEach((f) => { map[f.chapter_id] = f.audio_url; });
  return map;
}
(() => {
  const sel = $('dxq-qari');
  QARIS.forEach((x) => {
    const o = document.createElement('option');
    o.value = x.id;
    o.textContent = x.n;
    sel.appendChild(o);
  });
  sel.value = qariState.id;
  if (qariState.id !== 7) loadQariMap(qariState.id).then((m) => { qariState.map = m; }).catch(() => { qariState.id = 7; sel.value = 7; });
  sel.addEventListener('change', async () => {
    const id = +sel.value;
    try {
      if (id !== 7) {
        player.classList.add('buffering');
        qariState.map = await loadQariMap(id);
      }
      qariState.id = id;
      try { localStorage.setItem('quran-qari', id); } catch (e) {}
      if (current >= 0) {
        const t = audio.currentTime, wasPlaying = !audio.paused;
        if (pendingJmp) { audio.removeEventListener('loadedmetadata', pendingJmp); pendingJmp = null; }
        audio.src = qariSrc(SURAHS[current]);
        if (t > 2) {
          pendingJmp = function jmp() { audio.currentTime = t; };
          audio.addEventListener('loadedmetadata', pendingJmp, { once: true });
        }
        if (wasPlaying) audio.play().catch(() => {});
      }
      if ('mediaSession' in navigator && current >= 0) paintNow();
    } catch (e) {
      sel.value = qariState.id;
    } finally {
      player.classList.remove('buffering');
    }
  });
})();

/* ---------- reading streak (local) ---------- */
function bumpStreak() {
  try {
    const dstr = (d) => d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
    const today = dstr(new Date());
    const sv = JSON.parse(localStorage.getItem('quran-streak-v1') || '{}');
    if (sv.d !== today) {
      const y = dstr(new Date(Date.now() - 864e5));
      sv.n = (sv.d === y ? (sv.n || 0) : 0) + 1;
      sv.d = today;
      localStorage.setItem('quran-streak-v1', JSON.stringify(sv));
    }
    const pill = $('dxq-streakPill');
    if (sv.n >= 2) {
      pill.hidden = false;
      pill.innerHTML = svgI('flame', 12) + ' ' + sv.n + ' ' + I18N[lang].streakLbl;
    }
  } catch (e) {}
}

/* ---------- Ayat Hari Ini ---------- */
const CUMS = (() => {
  const c = [0];
  SURAHS.forEach((s) => c.push(c[c.length - 1] + s.y));
  return c;
})();
function globalToKey(g) {
  for (let i = 0; i < SURAHS.length; i++) {
    if (g < CUMS[i + 1]) return SURAHS[i].n + ':' + (g - CUMS[i] + 1);
  }
  return '1:1';
}
let dailyKey = null;
let dailySeq = 0;
async function showDaily(key) {
  const tok = ++dailySeq;
  try {
    const tid = lang === 'ms' ? 39 : 20;
    const r = await fetch('https://api.quran.com/api/v4/verses/by_key/' + key + '?translations=' + tid + '&fields=text_uthmani');
    if (!r.ok || tok !== dailySeq) return;
    const v = (await r.json()).verse;
    dailyKey = key;
    $('dxq-dailyAr').textContent = v.text_uthmani;
    const tr = (v.translations && v.translations[0] && v.translations[0].text) || '';
    $('dxq-dailyTr').textContent = bmFix(stripSup(tr));
    const sn = +key.split(':')[0];
    $('dxq-dailyOpen').innerHTML = svgI('book') + ' ' + I18N[lang].dailyOpen + ' — ' + SURAHS[sn - 1].t + ' ' + key;
    $('dxq-dailyCard').hidden = false;
  } catch (e) {}
}
(() => {
  const today = new Date();
  const seedStr = today.getFullYear() * 10000 + (today.getMonth() + 1) * 100 + today.getDate();
  let h = 0;
  String(seedStr).split('').forEach((ch) => { h = (h * 31 + ch.charCodeAt(0)) >>> 0; });
  showDaily(globalToKey(h % CUMS[CUMS.length - 1]));
  $('dxq-dailyOpen').addEventListener('click', () => {
    if (!dailyKey) return;
    const parts = dailyKey.split(':');
    bumpStreak();
    openReader(SURAHS[+parts[0] - 1], +parts[1]);
  });
  $('dxq-dailyShuf').addEventListener('click', () => {
    showDaily(globalToKey((Math.random() * CUMS[CUMS.length - 1]) | 0));
  });
})();

/* ---------- daily reading goal (local) ---------- */
const GOAL_PRESETS = [0, 5, 10, 20, 50];
const dayStr = (d) => d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
function goalTarget() {
  try { return +(JSON.parse(localStorage.getItem('quran-goal-v1')) || {}).t || 0; } catch (e) { return 0; }
}
function goalToday() {
  try {
    const p = JSON.parse(localStorage.getItem('quran-goalp-v1')) || {};
    return p.d === dayStr(new Date()) ? (p.n || 0) : 0;
  } catch (e) { return 0; }
}
function bumpGoal(n) {
  try {
    const today = dayStr(new Date());
    const p = JSON.parse(localStorage.getItem('quran-goalp-v1')) || {};
    const cur = p.d === today ? (p.n || 0) : 0;
    localStorage.setItem('quran-goalp-v1', JSON.stringify({ d: today, n: cur + n }));
  } catch (e) {}
  renderGoal();
}
function renderGoal() {
  const btn = $('dxq-goalBtn');
  if (!btn) return;
  const t = goalTarget();
  const prog = $('dxq-goalProg');
  if (!t) {
    btn.innerHTML = svgI('target') + ' ' + I18N[lang].goalSet;
    prog.hidden = true;
    return;
  }
  btn.innerHTML = svgI('target') + ' ' + I18N[lang].goalLbl.replace('{n}', t);
  const read = goalToday();
  prog.hidden = false;
  $('dxq-goalBarFill').style.width = Math.min(100, Math.round((read / t) * 100)) + '%';
  const done = read >= t;
  $('dxq-goalTxt').textContent = done
    ? '\u2713 ' + I18N[lang].goalDone + ' (' + read + '/' + t + ')'
    : read + ' / ' + t;
  prog.classList.toggle('done', done);
}
$('dxq-goalBtn').addEventListener('click', () => {
  const t = goalTarget();
  const next = GOAL_PRESETS[(GOAL_PRESETS.indexOf(t) + 1) % GOAL_PRESETS.length];
  try { localStorage.setItem('quran-goal-v1', JSON.stringify({ t: next })); } catch (e) {}
  renderGoal();
});
renderGoal();

/* ---------- Juz 1-30 filter ---------- */
let juzMap = null;
async function loadJuzMap() {
  if (juzMap) return juzMap;
  const r = await fetch('https://api.quran.com/api/v4/juzs');
  const j = await r.json();
  juzMap = {};
  (j.juzs || []).forEach((z) => {
    if (!juzMap[z.juz_number]) {
      juzMap[z.juz_number] = new Set(Object.keys(z.verse_mapping || {}).map(Number));
    }
  });
  return juzMap;
}
let hizbMap = null;
async function loadHizbMap() {
  if (hizbMap) return hizbMap;
  const r = await fetch('https://api.quran.com/api/v4/hizbs');
  const j = await r.json();
  hizbMap = {};
  (j.hizbs || []).forEach((z) => {
    if (!hizbMap[z.hizb_number]) {
      hizbMap[z.hizb_number] = new Set(Object.keys(z.verse_mapping || {}).map(Number));
    }
  });
  return hizbMap;
}
(() => {
  const sel = $('dxq-juzSel');
  const gJuz = document.createElement('optgroup');
  gJuz.label = 'Juz';
  for (let i = 1; i <= 30; i++) {
    const o = document.createElement('option');
    o.value = 'j' + i;
    o.textContent = 'Juz ' + i;
    gJuz.appendChild(o);
  }
  sel.appendChild(gJuz);
  const gHizb = document.createElement('optgroup');
  gHizb.label = 'Hizb';
  for (let i = 1; i <= 60; i++) {
    const o = document.createElement('option');
    o.value = 'h' + i;
    o.textContent = 'Hizb ' + i;
    gHizb.appendChild(o);
  }
  sel.appendChild(gHizb);
  sel.addEventListener('change', async () => {
    if (!sel.value) {
      juzSet = null;
      sel.classList.remove('on');
      document.querySelector('.chip[data-f="all"]').click();
      return;
    }
    const v = sel.value;
    try {
      const m = v[0] === 'h' ? await loadHizbMap() : await loadJuzMap();
      if (sel.value !== v) return; // user moved on while the map loaded
      juzSet = m[+v.slice(1)] || null;
      activeFilter = 'juz';
      document.querySelectorAll('.chips .chip').forEach((c) => c.classList.remove('on'));
      sel.classList.add('on');
      applyFilter();
    } catch (e) {
      sel.value = '';
      sel.classList.remove('on');
    }
  });
  document.querySelector('.chips').addEventListener('click', (e) => {
    if (e.target.closest && e.target.closest('button.chip[data-f]')) {
      sel.value = '';
      sel.classList.remove('on');
      juzSet = null;
    }
  });
})();

/* ---------- search inside the translation (BM/EN) ---------- */
let srchSeq = 0;
async function runSrchTr() {
  const query = q.value.trim();
  if (!query) return;
  const tok = ++srchSeq;
  const res = $('dxq-srchRes');
  res.innerHTML = '';
  const load = document.createElement('div');
  load.className = 'q-note';
  load.textContent = I18N[lang].chatLoad;
  res.appendChild(load);
  try {
    const r = await fetch('https://api.quran.com/api/v4/search?q=' + encodeURIComponent(query) + '&language=' + (lang === 'ms' ? 'ms' : 'en') + '&size=15');
    const j = await r.json();
    if (tok !== srchSeq) return;
    load.remove();
    const hits = ((j.search || {}).results || []);
    if (!hits.length) {
      const p = document.createElement('div');
      p.className = 'q-note';
      p.textContent = I18N[lang].noTrRes;
      res.appendChild(p);
      return;
    }
    hits.forEach((hh) => {
      const [sn, vn] = hh.verse_key.split(':').map(Number);
      const su = SURAHS[sn - 1];
      if (!su) return;
      const item = document.createElement('div');
      item.className = 'sr-item';
      const ref = document.createElement('span');
      ref.className = 'sr-ref';
      ref.textContent = su.t + ' · ' + hh.verse_key;
      const txt = document.createElement('span');
      txt.className = 'sr-txt';
      const best = (hh.translations && hh.translations[0] && hh.translations[0].text) || hh.text || '';
      best.split(/<em>|<\/em>/).forEach((seg, ix) => {
        if (!seg) return;
        if (ix % 2 === 1) {
          const em = document.createElement('em');
          em.textContent = seg;
          txt.appendChild(em);
        } else {
          txt.appendChild(document.createTextNode(seg));
        }
      });
      const open = document.createElement('button');
      open.type = 'button';
      open.className = 'q-chip';
      open.innerHTML = svgI('book') + ' ' + I18N[lang].srchOpen;
      open.addEventListener('click', () => { bumpStreak(); openReader(su, vn); });
      item.appendChild(ref);
      item.appendChild(txt);
      item.appendChild(open);
      res.appendChild(item);
    });
  } catch (e) {
    load.textContent = I18N[lang].chatErr;
  }
}
$('dxq-searchTr').addEventListener('click', runSrchTr);

/* ---------- Baca ikut topik / Read by topic ----------
   Chips drive the existing translation search (runSrchTr) so every result is a
   REAL verse returned by quran.com — nothing is fabricated. Keywords are chosen
   per language to land in the Malay (Basmeih) / English translations. */
var TOPICS = [
  { icon: '🕊️', ms: { l: 'Sabar', q: 'sabar' }, en: { l: 'Patience', q: 'patience' } },
  { icon: '🌾', ms: { l: 'Rezeki', q: 'rezeki' }, en: { l: 'Provision', q: 'provision' } },
  { icon: '🤲', ms: { l: 'Syukur', q: 'bersyukur' }, en: { l: 'Gratitude', q: 'gratitude' } },
  { icon: '🌿', ms: { l: 'Taubat', q: 'taubat' }, en: { l: 'Repentance', q: 'repentance' } },
  { icon: '💚', ms: { l: 'Rahmat', q: 'rahmat' }, en: { l: 'Mercy', q: 'mercy' } },
  { icon: '👪', ms: { l: 'Ibu Bapa', q: 'ibu bapa' }, en: { l: 'Parents', q: 'parents' } },
  { icon: '📖', ms: { l: 'Ilmu', q: 'ilmu' }, en: { l: 'Knowledge', q: 'knowledge' } },
  { icon: '🕌', ms: { l: 'Solat', q: 'sembahyang' }, en: { l: 'Prayer', q: 'prayer' } },
  { icon: '🎁', ms: { l: 'Sedekah', q: 'sedekah' }, en: { l: 'Charity', q: 'charity' } },
  { icon: '🌸', ms: { l: 'Syurga', q: 'syurga' }, en: { l: 'Paradise', q: 'paradise' } },
  { icon: '⏳', ms: { l: 'Akhirat', q: 'hari akhirat' }, en: { l: 'Hereafter', q: 'hereafter' } }
];
function runTopic(t) {
  var d = t[lang] || t.en;
  q.value = d.q;
  applyFilter();     // clears surah list to the empty state + wires the search button
  runSrchTr();       // fills #dxq-srchRes with real verse hits
  var tgt = $('dxq-empty');
  if (tgt) { try { tgt.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) { tgt.scrollIntoView(); } }
  // Self-heal a transient cold-fetch failure: if the results box shows only an
  // error note (no verse items) shortly after, quietly retry once.
  setTimeout(function () {
    var sr = $('dxq-srchRes');
    if (sr && !sr.querySelector('.sr-item') && sr.querySelector('.q-note') && q.value === d.q) runSrchTr();
  }, 1600);
}
function renderTopics() {
  var nav = document.querySelector('#DigitalQuran .browse .toolbar') || document.querySelector('#DigitalQuran .toolbar');
  if (!nav) return;
  if (!document.getElementById('dxq-topics-css')) {
    var stc = document.createElement('style'); stc.id = 'dxq-topics-css';
    stc.textContent = '#dxq-topics{display:flex;flex-direction:column;align-items:center;gap:10px;margin:2px 0 18px;text-align:center}'
      + '#dxq-topics .tp-lab{font-size:.86rem;color:var(--muted);display:inline-flex;align-items:center;gap:6px}'
      + '#dxq-topics .tp-row{display:flex;flex-wrap:wrap;align-items:center;justify-content:center;gap:9px}'
      + '#dxq-topics .tp{cursor:pointer;border:1px solid rgba(255,255,255,.12);background:rgba(255,255,255,.04);color:var(--text);'
      + 'font:inherit;font-size:.84rem;padding:9px 15px;border-radius:999px;display:inline-flex;align-items:center;gap:6px;line-height:1.1;transition:.18s}'
      + '#dxq-topics .tp:hover{border-color:rgba(0,200,255,.5);background:rgba(0,200,255,.10);transform:translateY(-1px)}'
      + '#dxq-topics .tp:active{transform:translateY(0)}'
      + '@media(max-width:520px){#dxq-topics .tp-row{gap:7px}#dxq-topics .tp{padding:8px 13px;font-size:.82rem}}';
    document.head.appendChild(stc);
  }
  var row = document.getElementById('dxq-topics');
  // Sits ABOVE the sticky toolbar so it is never hidden behind it when the toolbar pins,
  // and uses the full .browse width so all chips wrap into view (not the narrow toolbar pill).
  if (!row) { row = document.createElement('div'); row.id = 'dxq-topics'; row.setAttribute('role', 'group'); nav.insertAdjacentElement('beforebegin', row); }
  row.innerHTML = '';
  var lab = document.createElement('span'); lab.className = 'tp-lab';
  lab.textContent = (lang === 'ms' ? '📿 Baca ikut topik' : '📿 Read by topic');
  row.setAttribute('aria-label', lab.textContent);
  row.appendChild(lab);
  var chips = document.createElement('div'); chips.className = 'tp-row';
  TOPICS.forEach(function (t) {
    var d = t[lang] || t.en;
    var b = document.createElement('button'); b.type = 'button'; b.className = 'tp';
    b.textContent = t.icon + ' ' + d.l;
    b.setAttribute('aria-label', (lang === 'ms' ? 'Cari ayat tentang ' : 'Find verses about ') + d.l);
    b.addEventListener('click', function () { runTopic(t); });
    chips.appendChild(b);
  });
  row.appendChild(chips);
}

applyLang();
bumpStreak();

/* ---------- back to top ---------- */
(() => {
  const bt = $('dxq-backTop');
  let tick = false;
  window.addEventListener('scroll', () => {
    if (tick) return;
    tick = true;
    requestAnimationFrame(() => {
      bt.classList.toggle('show', window.scrollY > 900);
      tick = false;
    });
  }, { passive: true });
  bt.addEventListener('click', () => window.scrollTo({ top: 0, behavior: 'smooth' }));
})();

/* ---------- jump from the player to the current surah's card ---------- */
document.querySelector('#dxq-player .now').addEventListener('click', () => {
  if (current < 0) return;
  const li = document.getElementById('surah-' + (current + 1));
  if (!li) return;
  if (li.style.display === 'none') {
    const all = document.querySelector('.chip[data-f="all"]');
    if (all) all.click();
  }
  li.scrollIntoView({ behavior: 'smooth', block: 'center' });
});

/* ---------- empty state: one-tap reset ---------- */
$('dxq-emptyClear').addEventListener('click', () => {
  $('dxq-q').value = '';
  const all = document.querySelector('.chip[data-f="all"]');
  if (all) all.click();
});

/* ---------- deep link: #surah-36 scrolls to and highlights that surah ---------- */
(() => {
  const m = (location.hash || '').match(/^#surah-(\d{1,3})$/);
  if (!m) return;
  const li = document.getElementById('surah-' + +m[1]);
  if (!li) return;
  setTimeout(() => {
    li.scrollIntoView({ behavior: 'smooth', block: 'center' });
    const card = li.querySelector('.card');
    if (card) {
      card.classList.add('pulse');
      setTimeout(() => card.classList.remove('pulse'), 2600);
    }
  }, 350);
})();

/* ---------- bento dashboard: relocate real controls, wire new tiles ---------- */
(function dqDashboard(){
  var $ = function(id){ return document.getElementById(id); };
  var dash = $('dqDash'); if (!dash) return;
  var mv = function(el, slot){ var s = $(slot); if (el && s) s.appendChild(el); };
  // relocate live controls into slots (bindings ride along with the elements)
  var langGrp = document.querySelector('.hero .lang'); if (langGrp) $('dqLangSlot').appendChild(langGrp);
  mv($('dxq-qari'), 'dqQariSlot');
  mv($('dxq-resumeBtn'), 'dqContSlot');
  mv($('dxq-dailyCard'), 'dqVerseSlot');
  // Continue tile: always visible; rich content; default to Al-Fatihah when no saved position
  var rb = $('dxq-resumeBtn');
  if (rb){
    var rbSaved = null; try { rbSaved = JSON.parse(localStorage.getItem(LS_KEY)); } catch(e){}
    var hasSave = !!(rbSaved && SURAHS[rbSaved.i] && rbSaved.t > 5);
    var dqFillCont = function(){
      var s = hasSave ? SURAHS[rbSaved.i] : SURAHS[0];
      var place = s.p === 'M' ? (lang==='ms'?'Makkiyah':'Meccan') : (lang==='ms'?'Madaniyah':'Medinan');
      var info = meaning(s) + ' \u00b7 ' + s.y + ' ' + I18N[lang].verses + ' \u00b7 ' + place;
      var footLbl = (hasSave && typeof fmt==='function')
        ? (lang==='ms'?'Sambung dari ':'Resume at ') + fmt(rbSaved.t)
        : (lang==='ms'?'Main sekarang':'Play now');
      rb.innerHTML =
        '<span class="dq-clabel">' + (hasSave ? (lang==='ms'?'Sambung membaca':'Continue reading') : (lang==='ms'?'Mula membaca':'Start reading')) + '</span>' +
        '<span class="dq-ctext">' +
          '<span class="dq-ctitle">Surah ' + s.t + '<span class="dq-cname" lang="ar" dir="rtl">' + (s.a||'') + '</span></span>' +
          '<span class="dq-cmeta">' + info + '</span>' +
        '</span>' +
        '<span class="dq-cfoot">' +
          '<span class="dq-cresume">' + footLbl + '</span>' +
          '<span class="dq-cplay" aria-hidden="true"><svg viewBox="0 0 24 24" fill="currentColor"><path d="M8 5.5 19 12 8 18.5z"/></svg></span>' +
        '</span>';
    };
    rb.style.display = 'flex';
    dqFillCont();
    if (hasSave){ rb.addEventListener('click', function(){ rb.style.display = 'flex'; }); }
    else { rb.addEventListener('click', function(){ if (typeof play==='function') play(0); }); }
    [$('dxq-langEn'), $('dxq-langMs')].forEach(function(b){ if(b) b.addEventListener('click', function(){ setTimeout(dqFillCont, 20); }); });
  }

  // new learning tiles -> real reader / player
  var openFatihah = function(withTaj){
    if (typeof openReader !== 'function') return;
    openReader(SURAHS[0]);
    if (withTaj){ setTimeout(function(){ var t=$('dxq-readTaj'); if (t && typeof taj!=='undefined' && !taj.on) t.click(); }, 550); }
  };
  var bind = function(id, fn){ var e=$(id); if (e) e.addEventListener('click', fn); };
  bind('dqListen', function(){ if (typeof play==='function') play(0); });
  bind('dqTaj', function(){ openFatihah(true); });
  bind('dqTafsir', function(){ openFatihah(false); });
  bind('dqRumi', function(){ openFatihah(false); });
  bind('dqMushaf', function(){ var b=$('dxq-bookOpen1'); if (b) b.click(); });
  bind('dqChat', function(){ var b=$('dxq-chatOpen1'); if (b) b.click(); });
})();
